/*
 * @license
 * Pipeline Theme (c) Groupthought Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (e, t, i, s, r, n, o, a, l, c, h) {
    "use strict";
    const TRAILING_DECIMAL_ZEROS = /\.00(?!\d)/;

    theme.formatMoney = (cents) => {
        const formattedAmount = a.formatMoney(cents, theme.moneyFormat);
        const amountWithCurrency = theme.settings.currency_code_enable ? `${formattedAmount} ${theme.currencyCode}` : formattedAmount;

        return amountWithCurrency.replace(TRAILING_DECIMAL_ZEROS, "");
    };

    function d(e) {
        var t = Object.create(null);
        return (
            e &&
            Object.keys(e).forEach(function (i) {
                if ("default" !== i) {
                    var s = Object.getOwnPropertyDescriptor(e, i);
                    Object.defineProperty(
                        t,
                        i,
                        s.get
                            ? s
                            : {
                                enumerable: !0,
                                get: function () {
                                    return e[i];
                                },
                            }
                    );
                }
            }),
            (t.default = e),
            Object.freeze(t)
        );
    }
    var u = d(r);
    function p(e) {
        const t = e.querySelectorAll("[data-modal]"),
            i = document.querySelector("[data-modal-container]");
        t.forEach((e) => {
            i.querySelector(`[id="${e.id}"]`) || i.appendChild(e);
        });
    }
    function m(e) {
        e.querySelectorAll(".float__wrapper").forEach((e) => {
            const t = e.querySelector("label"),
                i = e.querySelector("input, textarea");
            t &&
                i.addEventListener("keyup", (e) => {
                    "" !== e.target.value ? t.classList.add("label--float") : t.classList.remove("label--float");
                }),
                i && i.value && i.value.length && t.classList.add("label--float");
        });
    }
    function f(e) {
        e.querySelectorAll(".errors").forEach((e) => {
            e.setAttribute("tabindex", "0"), e.setAttribute("aria-live", "assertive"), e.setAttribute("role", "alert");
        });
    }
    function g(e) {
        e.querySelectorAll("img").forEach((e) => {
            e.complete && e.parentNode.classList.remove("loading-shimmer");
        });
    }
    function y() {
        const e = {};
        return (
            (e.windowHeight = window.innerHeight),
            (e.announcementHeight = w("[data-announcement-bar]")),
            (e.toolbarHeight = w("[data-toolbar-height]")),
            (e.footerHeight = w('[data-section-type*="footer"]')),
            (e.menuHeight = w("[data-header-height]")),
            (e.headerHeight = e.menuHeight + e.announcementHeight),
            (e.logoHeight = (function () {
                const e = w("[data-footer-logo]");
                return e > 0 ? e + 20 : 0;
            })()),
            (e.stickyHeader = document.querySelector('[data-header-sticky="sticky"]') ? e.menuHeight : 0),
            (e.backfillHeight = w("[data-header-backfill]")),
            e
        );
    }
    function v() {
        document.addEventListener("theme:resize", b),
            (function () {
                const { windowHeight: e, announcementHeight: t, toolbarHeight: i, headerHeight: s, logoHeight: r, menuHeight: n, footerHeight: o, stickyHeader: a, backfillHeight: l } = y();
                document.documentElement.style.setProperty("--scrollbar-width", `${S()}px`),
                    document.documentElement.style.setProperty("--footer-logo", `${r}px`),
                    document.documentElement.style.setProperty("--full-screen", `${e}px`),
                    document.documentElement.style.setProperty("--three-quarters", 0.75 * e + "px"),
                    document.documentElement.style.setProperty("--two-thirds", 0.66 * e + "px"),
                    document.documentElement.style.setProperty("--one-half", 0.5 * e + "px"),
                    document.documentElement.style.setProperty("--one-third", 0.33 * e + "px"),
                    document.documentElement.style.setProperty("--one-fifth", 0.2 * e + "px"),
                    document.documentElement.style.setProperty("--menu-height", `${n}px`),
                    document.documentElement.style.setProperty("--announcement-height", `${t}px`),
                    document.documentElement.style.setProperty("--toolbar-height", `${i}px`),
                    document.documentElement.style.setProperty("--header-height", `${s}px`),
                    document.documentElement.style.setProperty("--footer-height", `${o}px`),
                    document.documentElement.style.setProperty("--content-full", e - s - r / 2 + "px"),
                    document.documentElement.style.setProperty("--menu-height-sticky", `${a}px`);
                let c = Math.abs(l - n) > 1 ? `${n}px` : "auto";
                document.documentElement.style.setProperty("--menu-backfill-height", c);
            })();
    }
    function b() {
        const { windowHeight: e, announcementHeight: t, toolbarHeight: i, headerHeight: s, logoHeight: r, menuHeight: n, footerHeight: o, stickyHeader: a, backfillHeight: l } = y();
        document.documentElement.style.setProperty("--scrollbar-width", `${S()}px`),
            document.documentElement.style.setProperty("--full-screen", `${e}px`),
            document.documentElement.style.setProperty("--menu-height", `${n}px`),
            document.documentElement.style.setProperty("--announcement-height", `${t}px`),
            document.documentElement.style.setProperty("--toolbar-height", `${i}px`),
            document.documentElement.style.setProperty("--header-height", `${s}px`),
            document.documentElement.style.setProperty("--footer-height", `${o}px`),
            document.documentElement.style.setProperty("--content-full", e - s - r / 2 + "px"),
            document.documentElement.style.setProperty("--menu-height-sticky", `${a}px`);
        let c = Math.abs(l - n) > 1 ? `${n}px` : "auto";
        document.documentElement.style.setProperty("--menu-backfill-height", c);
    }
    function w(e) {
        const t = document.querySelector(e);
        return t ? t.clientHeight : 0;
    }
    function S() {
        const e = document.createElement("div");
        (e.style.visibility = "hidden"), (e.style.overflow = "scroll"), (e.style.msOverflowStyle = "scrollbar"), document.body.appendChild(e);
        const t = document.createElement("div");
        e.appendChild(t);
        const i = e.offsetWidth - t.offsetWidth;
        return e.parentNode.removeChild(e), i;
    }
    function E(e, t) {
        let i = 64,
            s = 0;
        t.forEach((e) => {
            if (e.offsetHeight > s) {
                const t = parseInt(window.getComputedStyle(e).marginTop) + parseInt(window.getComputedStyle(e).marginBottom);
                t > i && (i = t), (s = e.offsetHeight);
            }
        });
        const r = e.querySelectorAll("[data-overflow-background]");
        [e, ...r].forEach((e) => {
            e.style.setProperty("min-height", `calc(${s + i}px + var(--menu-height))`);
        });
    }
    function L(e) {
        let t = document.querySelector("[data-footer-logo]") ? document.querySelector("[data-footer-logo]").clientHeight + 20 : 0;
        const i = document.querySelector("#MainContent .shopify-section:last-child [data-section-id]"),
            s = i ? i.getAttribute("data-section-id") : null;
        if ((((null !== s && e.getAttribute("data-section-id") !== s) || !i) && (t = 0), window.innerWidth < window.theme.sizes.medium)) {
            return void e.querySelectorAll("[data-overflow-frame]").forEach((e) => {
                const t = e.querySelectorAll("[data-overflow-content]");
                E(e, t);
            });
        }
        const r = document.createElement("div");
        e.prepend(r), (r.style.display = "none"), (r.style.width = getComputedStyle(e).getPropertyValue("--outer"));
        const n = 2 * parseInt(getComputedStyle(r).getPropertyValue("width"));
        e.firstChild.remove();
        let o = 0;
        const a = e.querySelectorAll("[data-overflow-frame]");
        e.querySelectorAll("[data-overflow-content]").forEach((e) => {
            e.offsetHeight > o && (o = e.offsetHeight);
        });
        [...a, ...e.querySelectorAll("[data-overflow-background]")].forEach((e) => {
            e.style.setProperty("min-height", `${o + n}px`);
        }),
            e.style.setProperty("min-height", `${o + n + 2 + t}px`);
    }
    function k(e) {
        const i = e.querySelectorAll(".js-overflow-container");
        if (i) {
            i.forEach((e) => {
                const t = e.querySelectorAll(".js-overflow-content");
                E(e, t),
                    document.addEventListener("theme:resize", () => {
                        E(e, t);
                    });
            });
            const s = e.querySelectorAll("[data-slideshow-wrapper]");
            s.length &&
                s.forEach((e) => {
                    const i = t.data(e);
                    void 0 !== i && i.reloadCells();
                });
        }
        const s = e.querySelectorAll("[data-overflow-wrapper]");
        s &&
            s.forEach((e) => {
                L(e),
                    document.addEventListener("theme:resize", () => {
                        L(e);
                    });
            });
    }
    function T(e, t = 500, i = !1) {
        var s, r, n, o, a;
        function l() {
            var c = Date.now() - o;
            c < t && c >= 0 ? (s = setTimeout(l, t - c)) : ((s = null), i || ((a = e.apply(n, r)), (n = r = null)));
        }
        null == t && (t = 100);
        var c = function () {
            (n = this), (r = arguments), (o = Date.now());
            var c = i && !s;
            return s || (s = setTimeout(l, t)), c && ((a = e.apply(n, r)), (n = r = null)), a;
        };
        return (
            (c.clear = function () {
                s && (clearTimeout(s), (s = null));
            }),
            (c.flush = function () {
                s && ((a = e.apply(n, r)), (n = r = null), clearTimeout(s), (s = null));
            }),
            c
        );
    }
    !(function () {
        const e = { NODE_ENV: "production" };
        try {
            if (process) return (process.env = Object.assign({}, process.env)), void Object.assign(process.env, e);
        } catch (e) { }
        globalThis.process = { env: e };
    })(),
        (window.requestIdleCallback =
            window.requestIdleCallback ||
            function (e) {
                var t = Date.now();
                return setTimeout(function () {
                    e({
                        didTimeout: !1,
                        timeRemaining: function () {
                            return Math.max(0, 50 - (Date.now() - t));
                        },
                    });
                }, 1);
            }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (e) {
                clearTimeout(e);
            });
    let x,
        _ = window.innerWidth,
        A = window.innerHeight;
    function q() {
        document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
            _ !== window.innerWidth && (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })), (_ = window.innerWidth)),
            A !== window.innerHeight && (document.dispatchEvent(new CustomEvent("theme:resize:height", { bubbles: !0 })), (A = window.innerHeight));
    }
    let C = window.pageYOffset,
        P = null,
        $ = null,
        M = null,
        I = null,
        D = 0;
    function O() {
        const e = window.pageYOffset;
        e > C ? (($ = !0), (P = !1)) : e < C ? (($ = !1), (P = !0)) : ((P = null), ($ = null)),
            (C = e),
            document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: P, down: $, position: e }, bubbles: !1 })),
            P && !M && document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: e }, bubbles: !1 })),
            $ && !I && document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: e }, bubbles: !1 })),
            (I = $),
            (M = P);
    }
    function H(e) {
        setTimeout(() => {
            D && clearTimeout(D), i.disablePageScroll(e.detail, { allowTouchMove: (e) => "TEXTAREA" === e.tagName }), document.documentElement.setAttribute("data-scroll-locked", "");
        });
    }
    function F(e) {
        const t = e.detail;
        t ? (D = setTimeout(B, t)) : B();
    }
    function B() {
        i.clearQueueScrollLocks(), i.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked");
    }
    window.addEventListener("resize", () => {
        x && window.cancelAnimationFrame(x), (x = window.requestAnimationFrame(T(q, 50)));
    }),
        (function () {
            let e;
            window.addEventListener(
                "scroll",
                function () {
                    e && window.cancelAnimationFrame(e), (e = window.requestAnimationFrame(O));
                },
                { passive: !0 }
            ),
                window.addEventListener("theme:scroll:lock", H),
                window.addEventListener("theme:scroll:unlock", F);
        })(),
        g(document),
        document.addEventListener(
            "load",
            (e) => {
                !(function (e) {
                    "IMG" == e.tagName && e.parentNode.classList.contains("loading-shimmer") && e.parentNode.classList.remove("loading-shimmer");
                })(e.target);
            },
            !0
        ),
        window.addEventListener("DOMContentLoaded", () => {
            v(), m(document), f(document), p(document), window.theme.settings.animate_scroll && e.refresh();
        }),
        window.addEventListener("load", () => {
            k(document), g(document);
        }),
        document.addEventListener("shopify:section:load", (t) => {
            const i = t.target;
            m(i), f(i), p(i), k(i), window.theme.settings.animate_scroll && e.refresh();
        }),
        document.addEventListener("shopify:section:reorder", () => {
            document.dispatchEvent(new CustomEvent("theme:header:check", { bubbles: !1 }));
        });
    const W = (e, t = !1, i = "block") => {
        e && (t ? e.style.removeProperty("display") : (e.style.display = i));
    };
    function N(e) {
        (this.status = e.status || null), (this.headers = e.headers || null), (this.json = e.json || null), (this.body = e.body || null);
    }
    N.prototype = Error.prototype;
    const R = "data-scrollbar-slider",
        j = "[data-scrollbar-arrow-prev]",
        z = "[data-scrollbar-arrow-next]",
        V = "is-hidden",
        U = 200;
    let G = class {
        init() {
            this.arrowNext && this.arrowPrev && (window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow(), this.events());
        }
        resize() {
            document.addEventListener("theme:resize", () => {
                window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow();
            });
        }
        events() {
            this.arrowNext.addEventListener("click", (e) => {
                e.preventDefault(), this.goToNext();
            }),
                this.arrowPrev.addEventListener("click", (e) => {
                    e.preventDefault(), this.goToPrev();
                }),
                this.scrollbar.addEventListener("scroll", () => {
                    this.togglePrevArrow(), this.toggleNextArrow();
                });
        }
        goToNext() {
            const e = this.scrollbar.getBoundingClientRect().width / 2 + this.scrollbar.scrollLeft;
            this.move(e), this.arrowPrev.classList.remove(V), this.toggleNextArrow();
        }
        goToPrev() {
            const e = this.scrollbar.scrollLeft - this.scrollbar.getBoundingClientRect().width / 2;
            this.move(e), this.arrowNext.classList.remove(V), this.togglePrevArrow();
        }
        toggleNextArrow() {
            setTimeout(() => {
                window.isRTL
                    ? this.arrowNext.classList.toggle(V, 0 === this.scrollbar.scrollLeft)
                    : this.arrowNext.classList.toggle(V, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth);
            }, U);
        }
        togglePrevArrow() {
            setTimeout(() => {
                window.isRTL
                    ? this.arrowPrev.classList.toggle(V, Math.abs(this.scrollbar.scrollLeft) + this.scrollbar.getBoundingClientRect().width + 1 >= this.scrollbar.scrollWidth)
                    : this.arrowPrev.classList.toggle(V, this.scrollbar.scrollLeft <= 0);
            }, U);
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (e) => {
                e.addEventListener("click", (t) => {
                    ("a" === t.target.tagName.toLowerCase() || (t.currentTarget && "a" === t.currentTarget.tagName.toLowerCase()) || (t.currentTarget && t.currentTarget.querySelector("a"))) && t.preventDefault(),
                        this.move(e.offsetLeft - e.clientWidth);
                });
            });
        }
        move(e) {
            this.scrollbar.scrollTo({ top: 0, left: e, behavior: "smooth" });
        }
        constructor(e) {
            (this.scrollbar = e),
                (this.arrowNext = this.scrollbar.parentNode.querySelector(z)),
                (this.arrowPrev = this.scrollbar.parentNode.querySelector(j)),
                this.init(),
                this.resize(),
                this.scrollbar.hasAttribute(R) && this.scrollToVisibleElement();
        }
    };
    const J = "[data-sibling-inner]";
    let Q = class {
        init() {
            this.siblings.forEach((e) => {
                new G(e);
            });
        }
        constructor(e) {
            (this.siblings = e.querySelectorAll(J)), this.init();
        }
    };
    const K = {
        onLoad() {
            new Q(this.container);
        },
    },
        Y = { expires: 7, path: "/", domain: window.location.hostname };
    let X = class {
        write(e) {
            document.cookie = `${this.options.name}=${e}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
        }
        read() {
            let e = [];
            const t = document.cookie.split("; ").find((e) => e.startsWith(this.options.name));
            if (-1 !== document.cookie.indexOf("; ") && t) {
                const t = document.cookie
                    .split("; ")
                    .find((e) => e.startsWith(this.options.name))
                    .split("=")[1];
                null !== t && (e = t.split(","));
            }
            return e;
        }
        destroy() {
            document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
        }
        remove(e) {
            const t = this.read(),
                i = t.indexOf(e);
            -1 !== i && (t.splice(i, 1), this.write(t));
        }
        constructor(e = {}) {
            this.options = { ...Y, ...e };
        }
    };
    const Z = 4,
        ee = 10,
        te = "[data-recently-viewed-products]",
        ie = "data-limit",
        se = "[data-recent-link-tab]",
        re = "[data-recent-wrapper]",
        ne = "[data-recently-viewed-tab]",
        oe = "[data-tabs-holder-scroll]",
        ae = "[data-api-content]",
        le = "data-minimum",
        ce = "data-item-id",
        he = "hide",
        de = "section-without-title--skip",
        ue = { expires: 90, name: "shopify_recently_viewed" },
        pe = [],
        me = [];
    const fe = {
        onLoad() {
            pe[this.id] = new (class {
                renderProducts() {
                    const e = this.cookie.read(),
                        t = [];
                    let i = 0;
                    if (e.length > 0) {
                        for (let s = 0; s < e.length; s++) {
                            const r = e[s];
                            if (me.includes(r)) continue;
                            const n = `${window.theme.routes.root_url}products/${r}?section_id=api-product-grid-item`;
                            if ((t.push(n), i++, i === this.howManyToShow || i === e.length - 1)) break;
                        }
                        if (t.length > 0 && t.length >= this.minimum) {
                            this.container.classList.remove(he), this.recentViewedLink && this.recentViewedLink.previousElementSibling && (this.tabsHolderScroll.classList.remove(he), this.container.classList.add(de));
                            const e = t.map((e) => fetch(e, { mode: "no-cors" }).then(this.handleErrors)),
                                i = [];
                            Promise.allSettled(e)
                                .then((e) =>
                                    Promise.all(
                                        e.map(async (e) => {
                                            "fulfilled" === e.status && i.push(await e.value.text());
                                        })
                                    )
                                )
                                .then(() => {
                                    i.forEach((e) => {
                                        const t = document.createElement("div"),
                                            i = document.createElement("div");
                                        (t.innerHTML = e),
                                            "" === t.querySelector(`[${ce}]`).getAttribute(ce) ||
                                            (i.classList.add("product-grid-slide"),
                                                i.setAttribute("data-carousel-slide", null),
                                                i.setAttribute("data-item", null),
                                                (i.innerHTML = t.querySelector(ae).innerHTML),
                                                this.wrapper.appendChild(i));
                                    }),
                                        new Q(this.container);
                                })
                                .then(() => {
                                    W(this.wrapper, !0), this.container.dispatchEvent(new CustomEvent("theme:recent-products:added", { bubbles: !0 }));
                                });
                        } else if (this.recentViewedTab) {
                            const e = Array.prototype.filter.call(this.recentViewedTab.parentNode.children, (e) => e !== this.recentViewedTab).length > 1;
                            this.recentViewedLink && this.recentViewedLink.previousElementSibling && (this.tabsHolderScroll.classList.add(he), this.container.classList.remove(de)), e || this.container.classList.add(he);
                        } else this.container.classList.add(he);
                    }
                }
                handleErrors(e) {
                    return e.ok
                        ? e
                        : e.text().then(function (t) {
                            throw new N({ status: e.statusText, headers: e.headers, text: t });
                        });
                }
                constructor(e) {
                    (this.container = e.container),
                        (this.cookie = new X(ue)),
                        (this.wrapper = this.container.querySelector(te)),
                        null !== this.wrapper &&
                        ((this.howManyToShow = parseInt(this.container.querySelector(re).getAttribute(ie)) || Z),
                            (this.minimum = parseInt(this.container.querySelector(re).getAttribute(le))),
                            (this.recentViewedTab = this.container.querySelector(ne)),
                            (this.recentViewedLink = this.container.querySelector(se)),
                            (this.tabsHolderScroll = this.container.querySelector(oe)),
                            this.renderProducts());
                }
            })(this);
        },
    };
    function ge() {
        const e = "(any-pointer: coarse)",
            t = `(max-width: ${window.theme.sizes.medium}px)`,
            i = `(min-width: ${window.theme.sizes.medium + 1}px) and (max-width: ${window.theme.sizes.large}px)`,
            s = `(min-width: ${window.theme.sizes.large + 1}px)`;
        (ge.isTouch = () => {
            const t = window.matchMedia(e).matches;
            return document.documentElement.classList.toggle("supports-touch", t), t;
        }),
            (ge.isMobile = () => window.matchMedia(t).matches),
            (ge.isTablet = () => window.matchMedia(i).matches),
            (ge.isDesktop = () => window.matchMedia(s).matches);
        const r = [
            [e, ge.isTouch],
            [t, ge.isMobile],
            [i, ge.isTablet],
            [s, ge.isDesktop],
        ];
        ge.onChange = (e) => {
            r.forEach((t) => {
                window.matchMedia(t[0]).addEventListener("change", () => {
                    t[1]() && e && e();
                });
            });
        };
    }
    function ye() {
        this.entries = [];
    }
    function ve(e, t) {
        be(e);
        var i = (function (e, t) {
            be(e),
                (function (e) {
                    if (!Array.isArray(e)) throw new TypeError(e + " is not an array.");
                    if (0 === e.length) throw new Error(e + " is empty.");
                    if (!e[0].hasOwnProperty("name")) throw new Error(e[0] + "does not contain name key.");
                    if ("string" != typeof e[0].name) throw new TypeError("Invalid value type passed for name of option " + e[0].name + ". Value should be string.");
                })(t);
            var i = [];
            return (
                t.forEach(function (t) {
                    for (var s = 0; s < e.options.length; s++) {
                        if ((e.options[s].name || e.options[s]).toLowerCase() === t.name.toLowerCase()) {
                            i[s] = t.value;
                            break;
                        }
                    }
                }),
                i
            );
        })(e, t);
        return (function (e, t) {
            return (
                be(e),
                (function (e) {
                    if (Array.isArray(e) && "object" == typeof e[0]) throw new Error(e + "is not a valid array of options.");
                })(t),
                e.variants.filter(function (e) {
                    return t.every(function (t, i) {
                        return e.options[i] === t;
                    });
                })[0] || null
            );
        })(e, i);
    }
    function be(e) {
        if ("object" != typeof e) throw new TypeError(e + " is not an object.");
        if (0 === Object.keys(e).length && e.constructor === Object) throw new Error(e + " is empty.");
    }
    ge(),
        (ye.prototype.add = function (e, t, i) {
            this.entries.push({ element: e, event: t, fn: i }), e.addEventListener(t, i);
        }),
        (ye.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (e) {
                return e.element.removeEventListener(e.event, e.fn), !1;
            });
        });
    var we = '[name="id"]',
        Se = '[name="selling_plan"]',
        Ee = '[name^="options"]',
        Le = '[name="quantity"]',
        ke = '[name^="properties"]';
    const Te = {};
    function xe(e = {}) {
        if ((e.type || (e.type = "json"), e.url))
            return Te[e.url]
                ? Te[e.url]
                : (function (e, t) {
                    const i = new Promise((i, s) => {
                        "text" === t
                            ? fetch(e)
                                .then((e) => e.text())
                                .then((e) => {
                                    i(e);
                                })
                                .catch((e) => {
                                    s(e);
                                })
                            : (function (e, t, i) {
                                let s = document.getElementsByTagName("head")[0],
                                    r = !1,
                                    n = document.createElement("script");
                                (n.src = e),
                                    (n.onload = n.onreadystatechange = function () {
                                        r || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState) ? i() : ((r = !0), t());
                                    }),
                                    s.appendChild(n);
                            })(
                                e,
                                function () {
                                    i();
                                },
                                function () {
                                    s();
                                }
                            );
                    });
                    return (Te[e] = i), i;
                })(e.url, e.type);
        if (e.json) {
            if (Te[e.json]) return Promise.resolve(Te[e.json]);
            {
                const t = window
                    .fetch(e.json)
                    .then((e) => e.json())
                    .then((t) => ((Te[e.json] = t), t))
                    .catch((t) => {
                        Te[e.json] = null;
                    });
                return (Te[e.json] = t), t;
            }
        }
        if (e.name) {
            const t = "".concat(e.name, e.version);
            return Te[t]
                ? Te[t]
                : (function (e) {
                    const t = "".concat(e.name, e.version),
                        i = new Promise((t, i) => {
                            try {
                                window.Shopify.loadFeatures([
                                    {
                                        name: e.name,
                                        version: e.version,
                                        onLoad: (e) => {
                                            !(function (e, t, i) {
                                                i ? t(i) : e();
                                            })(t, i, e);
                                        },
                                    },
                                ]);
                            } catch (e) {
                                i(e);
                            }
                        });
                    return (Te[t] = i), i;
                })(e);
        }
        return Promise.reject();
    }
    const _e = "[data-swapper-wrapper]",
        Ae = "[data-swapper-target]",
        qe = "data-swapper-hover";
    let Ce = {};
    function Pe(e) {
        Ce[e.id] = [];
        e.querySelectorAll(_e).forEach((t) => {
            Ce[e.id].push(
                new (class {
                    init() {
                        this.hovers.forEach((e) => {
                            e.addEventListener(
                                "mouseenter",
                                function () {
                                    const t = e.getAttribute(qe);
                                    this.target.innerHTML = `${t}`;
                                }.bind(this)
                            );
                        }),
                            this.hovers.forEach((e) => {
                                e.addEventListener(
                                    "mouseleave",
                                    function () {
                                        this.target.innerHTML = this.deafaultContent;
                                    }.bind(this)
                                );
                            }),
                            this.hovers.forEach((e) => {
                                e.addEventListener(
                                    "click",
                                    function () {
                                        const t = e.getAttribute(qe);
                                        this.deafaultContent = `${t}`;
                                    }.bind(this)
                                );
                            });
                    }
                    constructor(e) {
                        (this.container = e),
                            (this.target = this.container.querySelector(Ae)),
                            (this.hovers = this.container.querySelectorAll(`[${qe}]`)),
                            this.target && this.hovers.length && ((this.deafaultContent = this.target.innerHTML), this.init());
                    }
                })(t)
            );
        });
    }
    const $e = {
        onLoad() {
            Pe(this.container);
        },
    },
        Me = { color: "ash" },
        Ie = "data-swatch",
        De = "[data-grid-item]",
        Oe = "data-grid-image-default",
        He = "data-grid-image-target",
        Fe = "data-swatch-image",
        Be = "data-swatch-image-id",
        We = "data-swatch-variant",
        Ne = "[data-grid-swatches]",
        Re = "[data-swatch-template]",
        je = "data-swatch-handle",
        ze = "data-swatch-label",
        Ve = "is-fade";
    let Ue = class extends HTMLElement {
        init() {
            this.setStyles(),
                this.variant &&
                this.outer &&
                this.outer.addEventListener("theme:quickview:media", (e) => {
                    e && e.detail && e.detail.media && (this.media = e.detail.media);
                });
        }
        setStyles() {
            this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
                this.colorMatch.path && (this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`), this.element.style.setProperty("background-size", "cover"));
        }
        replaceImage() {
            if (this.imageReplace && this.imageSlide && this.imageId) {
                if (this.imageSlide.hasAttribute(He) && this.imageSlide.getAttribute(He) !== this.imageId) {
                    this.imageSlide.classList.add(Ve);
                    const e = 1e3 * parseFloat(window.getComputedStyle(this.imageSlide).getPropertyValue("animation-duration"));
                    setTimeout(() => {
                        this.imageSlide.classList.remove(Ve);
                    }, e);
                }
                this.imageSlide.setAttribute(He, this.imageId),
                    this.imageSlide.style.setProperty("background-color", "#fff"),
                    this.imageSlide.hasAttribute(Oe) || this.imageSlide.setAttribute(Oe, window.getComputedStyle(this.imageSlide).backgroundImage),
                    this.imageSlide.style.setProperty("background-image", this.imageReplace);
            }
        }
        constructor() {
            super(),
                (this.element = this.querySelector(`[${Ie}]`)),
                (this.colorString = this.element.getAttribute(Ie)),
                (this.image = this.element.getAttribute(Fe)),
                (this.imageId = this.element.getAttribute(Be)),
                (this.variant = this.element.getAttribute(We)),
                (this.outer = this.element.closest(De)),
                (this.media = null),
                (this.imageSlide = null),
                (this.imageDefault = null),
                (this.stopSlideAnimation = !1);
            const e = new (class {
                getColor() {
                    return this.match;
                }
                init() {
                    return xe({ json: window.theme.assets.swatches })
                        .then((e) => this.matchColors(e, this.settings.color))
                        .catch((e) => {
                            console.error("failed to load swatch colors script"), console.error(e);
                        });
                }
                matchColors(e, t) {
                    let i = "#E5E5E5",
                        s = null;
                    const r = window.theme.assets.base || "/",
                        n = t.toLowerCase().replace(/\s/g, ""),
                        o = e.colors;
                    if (o) {
                        const e = (e) => Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === n,
                            t = o.findIndex(e);
                        if (t > -1) {
                            const e = Object.values(o[t])[0],
                                n = e.toLowerCase();
                            n.includes(".jpg") || n.includes(".jpeg") || n.includes(".png") || n.includes(".svg") ? ((s = `${r}${encodeURIComponent(e)}`), (i = "#888888")) : (i = e);
                        }
                    }
                    return { color: this.settings.color, path: s, hex: i };
                }
                constructor(e = {}) {
                    (this.settings = { ...Me, ...e }), (this.match = this.init());
                }
            })({ color: this.colorString });
            e.getColor().then((e) => {
                (this.colorMatch = e), this.init();
            });
        }
    };
    function Ge(e) {
        e.querySelectorAll(Ne).forEach((e) => {
            new (class {
                init() {
                    (this.wrap.innerHTML = ""),
                        this.swatches.forEach((e, t) => {
                            let i = this.product.variants.find((t) => t.options.includes(e));
                            const s = i.featured_media ? i.featured_media.preview_image.src : "",
                                r = i.featured_media ? i.featured_media.id : "",
                                n = Math.floor(9999 * Math.random());
                            this.wrap.innerHTML += u.render(this.template, { color: e, uniq: `${this.product.id}-${i.id}-${n}`, variant: i.id, product_id: this.product.id, image_id: r, image: s, index: t });
                        }),
                        new G(this.wrap);
                }
                constructor(e) {
                    (this.template = document.querySelector(Re).innerHTML), (this.wrap = e), (this.handle = e.getAttribute(je));
                    const t = e.getAttribute(ze).trim().toLowerCase();
                    (function (e) {
                        const t = `${window.theme.routes.root_url}products/${e}.js`;
                        return window
                            .fetch(t)
                            .then((e) => e.json())
                            .catch((e) => {
                                console.error(e);
                            });
                    })(this.handle).then((e) => {
                        (this.product = e),
                            (this.colorOption = e.options.find(function (e) {
                                return e.name.toLowerCase() === t || null;
                            })),
                            this.colorOption && ((this.swatches = this.colorOption.values), this.init());
                    });
                }
            })(e);
        });
    }
    const Je = {
        onLoad() {
            Ge(this.container), Pe(this.container);
        },
    },
        Qe = "[data-custom-scrollbar-items]",
        Ke = "[data-custom-scrollbar]",
        Ye = "[data-custom-scrollbar-track]",
        Xe = "hide",
        Ze = {};
    let et = class {
        events() {
            this.holderItems.addEventListener("scroll", this.calculatePosition.bind(this)),
                this.holderItems.addEventListener("theme:carousel:scroll", this.calculatePosition.bind(this)),
                document.addEventListener("theme:resize:width", this.calculateTrackWidth.bind(this)),
                document.addEventListener("theme:resize:width", this.calculatePosition.bind(this));
        }
        calculateTrackWidth() {
            const e = document.createElement("div");
            this.holderItems.prepend(e), (e.style.display = "none"), (e.style.width = getComputedStyle(this.holderItems).getPropertyValue("--outer"));
            const t = parseInt(getComputedStyle(e).getPropertyValue("width"));
            this.holderItems.firstChild.remove(),
                (this.scrollbarWidth = 0 === this.scrollbar.clientWidth ? this.scrollbar.parentNode.getBoundingClientRect().width : this.scrollbar.clientWidth),
                setTimeout(() => {
                    const e = this.children[0].clientWidth,
                        i = Number(getComputedStyle(this.children[0]).marginRight.replace("px", "")),
                        s = Number(getComputedStyle(this.children[0]).marginLeft.replace("px", ""));
                    (this.scrollWidth = this.children.length * (e + i + s) + t - i),
                        (this.trackWidth = ((this.scrollbarWidth + t) / this.scrollWidth) * 100),
                        (this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth),
                        this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}%`);
                    const r = Math.ceil(this.trackWidth) >= 100;
                    this.scrollbar.classList.toggle(Xe, r);
                }, 100);
        }
        calculatePosition() {
            let e = this.holderItems.scrollLeft / (this.holderItems.scrollWidth - this.holderItems.clientWidth);
            (e *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth),
                (e = e < 0 ? 0 : e),
                (e = isNaN(e) ? 0 : e),
                this.scrollbar.style.setProperty("--position", `${Math.round(e)}px`),
                document.dispatchEvent(new CustomEvent("theme:scrollbar:scroll", { bubbles: !0, detail: { holder: this.holderItems } }));
        }
        constructor(e, t = null) {
            (this.holderItems = e.querySelector(Qe)),
                (this.scrollbar = e.querySelector(Ke)),
                (this.scrollbarTrack = e.querySelector(Ye)),
                (this.trackWidth = 0),
                (this.scrollWidth = 0),
                this.scrollbar && this.holderItems && ((this.children = t || this.holderItems.children), this.events(), this.calculateTrackWidth());
        }
    };
    const tt = {
        onLoad() {
            Ze[this.id] = new et(this.container);
        },
    },
        it = "[data-carousel]",
        st = "data-carousel-progress",
        rt = "[data-carousel-slide]",
        nt = "[data-grid-slide]",
        ot = "[data-wrapper]",
        at = "[data-carousel-track]",
        lt = "data-options",
        ct = "data-custom-scrollbar-items",
        ht = ".flickity-button.previous",
        dt = ".flickity-button.next",
        ut = "data-recently-viewed-products",
        pt = "data-related-products",
        mt = "[data-section-id]",
        ft = "flickity-force-arrows-top",
        gt = "not-moved-arrows",
        yt = "hide",
        vt = "flickity-enabled",
        bt = "hidden-arrows",
        wt = "flickity-static",
        St = 112;
    let Et = class extends HTMLElement {
        connectedCallback() {
            (this.carousel = this.container.querySelector(it)),
                (this.carouselTrack = this.container.querySelector(at)),
                (this.wrapper = this.container.closest(ot)),
                (this.section = this.container.closest(mt)),
                (this.slidesVisible = null),
                (this.carouselInstance = null),
                (this.carouselPrev = null),
                (this.carouselNext = null),
                (this.customOptions = {}),
                (this.toggleWrapperModifierEvent = () => this.toggleWrapperModifier()),
                this.carousel && this.carousel.hasAttribute(ut)
                    ? this.section.addEventListener("theme:recent-products:added", () => {
                        this.init();
                    })
                    : this.carousel && this.carousel.hasAttribute(pt)
                        ? this.section.addEventListener("theme:related-products:added", () => {
                            this.init();
                        })
                        : this.init();
        }
        init() {
            this.carousel &&
                ((this.slidesTotal = this.carousel.querySelectorAll(rt).length),
                    this.getGridLayout(),
                    this.carousel.hasAttribute(lt) && (this.customOptions = JSON.parse(decodeURIComponent(this.carousel.getAttribute(lt)))),
                    this.trackVisibleSlides(),
                    this.initCarousel(),
                    this.calculatedArrowsTopPosition(),
                    this.toggleWrapperModifier(),
                    document.addEventListener("theme:resize:width", this.toggleWrapperModifierEvent),
                    this.carousel.hasAttribute(st) && this.progressBarCalculate(),
                    this.carousel.hasAttribute(ct) && new et(this.container));
        }
        initCarousel() {
            (this.options = {
                accessibility: !0,
                contain: !0,
                freeScroll: !0,
                prevNextButtons: !0,
                wrapArround: !1,
                groupCells: !1,
                autoPlay: !1,
                pageDots: !1,
                cellAlign: window.isRTL ? "right" : "left",
                rightToLeft: window.isRTL,
                dragThreshold: 10,
                arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
                on: {
                    resize: () => {
                        this.toggleArrows(),
                            this.calculatedArrowsTopPosition(),
                            setTimeout(() => {
                                this.visibleSlides();
                            }, 100);
                    },
                },
                ...this.customOptions,
            }),
                (this.carouselInstance = new s(this.carousel, this.options)),
                (this.carouselPrev = this.carousel.querySelector(ht)),
                (this.carouselNext = this.carousel.querySelector(dt)),
                this.container.addEventListener("theme:tab:change", () => {
                    this.carouselInstance.resize(), (this.carouselPrev = this.carousel.querySelector(ht)), (this.carouselNext = this.carousel.querySelector(dt));
                }),
                this.carouselInstance.on("dragStart", () => {
                    (this.carouselInstance.slider.style.pointerEvents = "none"), ge.isMobile || this.containDrag();
                }),
                this.carouselInstance.on("dragEnd", () => {
                    (this.carouselInstance.slider.style.pointerEvents = "auto"), ge.isMobile || this.containDrag();
                }),
                this.carouselInstance.on("change", (e) => this.lockArrows(e)),
                setTimeout(() => {
                    this.visibleSlides();
                }, 100),
                Shopify.designMode &&
                setTimeout(() => {
                    this.carouselInstance.options.watchCSS && !this.carousel.classList.contains(vt)
                        ? (this.carouselInstance.destroy(),
                            (this.carouselInstance = new s(this.carousel, this.options)),
                            this.carouselInstance.resize(),
                            (this.carouselPrev = this.carousel.querySelector(ht)),
                            (this.carouselNext = this.carousel.querySelector(dt)))
                        : this.carouselInstance.resize();
                }, 10),
                this.carousel.classList.toggle(wt, this.smallItems === this.carousel.querySelectorAll(rt).length),
                Ge(this.container),
                new Q(this.container);
        }
        calculatedArrowsTopPosition() {
            const e = this.container.querySelector(nt);
            if (e) {
                const t = e.offsetHeight / 2;
                this.carousel.style.setProperty("--buttons-top", `${t}px`);
            }
        }
        toggleWrapperModifier() {
            if (!this.wrapper) return;
            const e = Number(getComputedStyle(document.documentElement).getPropertyValue("--scrollbar-width").replace("px", "")),
                t = this.wrapper.clientWidth;
            (this.wrapperWidthWithGutter = t + St + e),
                window.innerWidth >= this.wrapperWidthWithGutter && (this.wrapper.classList.remove(ft), this.section.classList.add(gt)),
                window.innerWidth < this.wrapperWidthWithGutter && (this.wrapper.classList.add(ft), this.section.classList.remove(gt));
        }
        progressBarCalculate() {
            null !== this.carouselInstance &&
                this.carouselTrack &&
                this.carouselInstance.on("scroll", (e) => {
                    (e = 100 * Math.max(0, Math.min(1, e)) + "%"), (this.carouselTrack.style.width = e);
                });
        }
        getGridLayout() {
            (this.largeItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-large-items")) || 3),
                (this.mediumItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-medium-items")) || this.largeItems),
                (this.smallItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-small-items")) || this.mediumItems || this.largeItems);
        }
        visibleSlides() {
            if (!this.carousel) return;
            this.getGridLayout();
            const e = this.carousel.clientWidth || this.carouselInstance.size.width,
                t = null !== this.carouselInstance && this.carouselInstance.selectedElement ? this.carouselInstance.selectedElement.clientWidth : this.carousel.querySelector(rt).clientWidth,
                i = null !== this.carouselInstance && this.carouselInstance.slides ? this.carouselInstance.slides.length : this.carousel.querySelectorAll(rt).length,
                s = Math.floor(e / t);
            this.section.classList.remove(bt),
                this.carouselPrev && this.carouselNext && (this.carouselPrev.classList.remove(yt), this.carouselNext.classList.remove(yt)),
                window.innerWidth > window.theme.sizes.large && !this.options.groupCells && s <= this.largeItems && i <= this.largeItems && this.carouselPrev && this.carouselNext && this.hideArrows(),
                window.innerWidth >= window.theme.sizes.medium &&
                window.innerWidth <= window.theme.sizes.large &&
                !this.options.groupCells &&
                s <= this.mediumItems &&
                i <= this.mediumItems &&
                this.carouselPrev &&
                this.carouselNext &&
                this.hideArrows(),
                window.innerWidth < window.theme.sizes.medium && !this.options.groupCells && s <= this.smallItems && i <= this.smallItems && this.carouselPrev && this.carouselNext && this.hideArrows();
        }
        trackVisibleSlides() {
            if (this.customOptions?.slidesVisible != null) { // manual override
                this.slidesVisible = this.customOptions.slidesVisible;
                return;
            }
            const e = window.matchMedia(`(max-width: ${window.theme.sizes.medium - 1}px)`),
                t = window.matchMedia(`(min-width: ${window.theme.sizes.medium}px) and (max-width: ${window.theme.sizes.large - 1}px)`),
                i = window.matchMedia(`(min-width: ${window.theme.sizes.large}px)`);
            e.addEventListener("change", (e) => {
                !e.matches || (this.slidesVisible = this.smallItems);
            }),
                !e.matches || (this.slidesVisible = this.smallItems),
                t.addEventListener("change", (e) => {
                    !e.matches || (this.slidesVisible = this.mediumItems);
                }),
                !t.matches || (this.slidesVisible = this.mediumItems),
                i.addEventListener("change", (e) => {
                    !e.matches || (this.slidesVisible = this.largeItems);
                }),
                !i.matches || (this.slidesVisible = this.largeItems);
        }
        containDrag() {
            const e = this.slidesTotal - this.slidesVisible;
            this.carouselInstance.selectedIndex >= e && (this.carouselInstance.select(e), this.lockArrows(this.carouselInstance.selectedIndex));
        }
        lockArrows(slideIndex) {
            if (this.options.wrapAround || this.options.groupCells) return;
            const t = parseInt(slideIndex);
            const i = this.slidesTotal - this.slidesVisible;

            this.carouselNext.disabled = t >= i;
        }
        showArrows() {
            this.carouselPrev.classList.remove(yt), this.carouselNext.classList.remove(yt), this.section.classList.remove(bt);
        }
        hideArrows() {
            this.carouselPrev.classList.add(yt), this.carouselNext.classList.add(yt), this.section.classList.add(bt);
        }
        toggleArrows() {
            this.carouselPrev && this.carouselNext && (this.carouselPrev.disabled && this.carouselNext.disabled ? this.hideArrows() : this.showArrows());
        }
        constructor() {
            super(), (this.container = this);
        }
    };
    customElements.get("flickity-carousel") || customElements.define("flickity-carousel", Et);
    const Lt = "[data-address-wrapper]",
        kt = "[data-new-address-form]",
        Tt = "[new-address-form-inner]",
        xt = ".address-new-toggle",
        _t = ".address-edit-toggle",
        At = ".address-delete",
        qt = "hide",
        Ct = "data-form-id",
        Pt = "data-confirm-message",
        $t = "Are you sure you wish to delete this address?",
        Mt = "#EditAddress",
        It = "AddressCountryNew",
        Dt = "AddressProvinceNew",
        Ot = "AddressProvinceContainerNew",
        Ht = ".address-country-option",
        Ft = "AddressCountry",
        Bt = "AddressProvince",
        Wt = "AddressProvinceContainer";
    const Nt = document.querySelector(Lt);
    Nt &&
        new (class {
            init() {
                if (this.addressNewForm) {
                    const e = this.section,
                        t = this.addressNewForm.querySelector(Tt);
                    this.customerAddresses();
                    const i = e.querySelectorAll(xt);
                    i.length &&
                        i.forEach((e) => {
                            e.addEventListener("click", function () {
                                t.classList.toggle(qt);
                            });
                        });
                    const s = e.querySelectorAll(_t);
                    s.length &&
                        s.forEach((t) => {
                            t.addEventListener("click", function () {
                                const t = this.getAttribute(Ct);
                                e.querySelector(`${Mt}_${t}`).classList.toggle(qt);
                            });
                        });
                    const r = e.querySelectorAll(At);
                    r.length &&
                        r.forEach((e) => {
                            e.addEventListener("click", function () {
                                const e = this.getAttribute(Ct),
                                    t = this.getAttribute(Pt);
                                confirm(t || $t) && Shopify.postLink(window.theme.routes.account_addresses_url + "/" + e, { parameters: { _method: "delete" } });
                            });
                        });
                }
            }
            customerAddresses() {
                Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(It, Dt, { hideElement: Ot }),
                    this.section.querySelectorAll(Ht).forEach((e) => {
                        const t = e.getAttribute(Ct),
                            i = `${Ft}_${t}`,
                            s = `${Bt}_${t}`,
                            r = `${Wt}_${t}`;
                        new Shopify.CountryProvinceSelector(i, s, { hideElement: r });
                    });
            }
            constructor(e) {
                (this.section = e), (this.addressNewForm = this.section.querySelector(kt)), this.init();
            }
        })(Nt),
        document.querySelector("#RecoverPassword") &&
        (function () {
            var e = { recoverPasswordForm: "#RecoverPassword", hideRecoverPasswordLink: "#HideRecoverPasswordLink" };
            function t(e) {
                e.preventDefault(), s();
            }
            function i() {
                "#recover" === window.location.hash && s();
            }
            function s() {
                var e = document.querySelector("#CustomerEmail").value;
                (document.querySelector("#RecoverEmail").value = e), document.querySelector("#RecoverPasswordForm").classList.toggle("display-none"), document.querySelector("#CustomerLoginForm").classList.toggle("display-none");
            }
            function r() {
                document.querySelector(".reset-password-success") && document.querySelector("#ResetSuccess").classList.remove("display-none");
            }
            i(), r(), document.querySelector(e.recoverPasswordForm).addEventListener("click", t), document.querySelector(e.hideRecoverPasswordLink).addEventListener("click", t);
        })(),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const Rt = window.Shopify.theme.sections.registered,
        jt = window.Shopify.theme.sections.instances,
        zt = "data-section-id",
        Vt = "data-section-type";
    let Ut = class {
        callFunctions(e, t = null) {
            this.callStack[e].forEach((e) => {
                const i = { id: this.id, type: this.type, container: this.container };
                t ? e.call(i, t) : e.call(i);
            });
        }
        onLoad() {
            this.callFunctions("onLoad");
        }
        onUnload() {
            this.callFunctions("onUnload");
        }
        onSelect(e) {
            this.callFunctions("onSelect", e);
        }
        onDeselect(e) {
            this.callFunctions("onDeselect", e);
        }
        onBlockSelect(e) {
            this.callFunctions("onBlockSelect", e);
        }
        onBlockDeselect(e) {
            this.callFunctions("onBlockDeselect", e);
        }
        onReorder(e) {
            this.callFunctions("onReorder", e);
        }
        constructor(e, t) {
            (this.container = (function (e) {
                if (!(e instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === e.getAttribute(zt)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + zt + " attribute.");
                return e;
            })(e)),
                (this.id = e.getAttribute(zt)),
                (this.type = t.type),
                (this.callStack = t.getStack());
            try {
                this.onLoad();
            } catch (e) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.error(e);
            }
        }
    };
    function Gt(e, t) {
        if ("string" != typeof e) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== Rt[e]) throw new Error('Theme Sections: A section of type "' + e + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(t) || (t = [t]);
        const i = new (class {
            getStack() {
                return this.callStack;
            }
            constructor(e = null, t = []) {
                (this.type = e),
                    (this.components = (function (e) {
                        if ((void 0 !== e && "object" != typeof e) || null === e) throw new TypeError("Theme Sections: The components object provided is not a valid");
                        return e;
                    })(t)),
                    (this.callStack = { onLoad: [], onUnload: [], onSelect: [], onDeselect: [], onBlockSelect: [], onBlockDeselect: [], onReorder: [] }),
                    t.forEach((e) => {
                        for (const [t, i] of Object.entries(e)) {
                            const e = this.callStack[t];
                            Array.isArray(e) && "function" == typeof i ? e.push(i) : (console.warn(`Unregisted function: '${t}' in component: '${this.type}'`), console.warn(i));
                        }
                    });
            }
        })(e, t);
        return (Rt[e] = i), Rt;
    }
    function Jt(e, t) {
        (e = Yt(e)),
            void 0 === t && (t = document.querySelectorAll("[" + Vt + "]")),
            (t = Xt(t)),
            e.forEach(function (e) {
                const i = Rt[e];
                void 0 !== i &&
                    (t = t.filter(function (t) {
                        return !(Qt(t).length > 0) && null !== t.getAttribute(Vt) && (t.getAttribute(Vt) !== e || (jt.push(new Ut(t, i)), !1));
                    }));
            });
    }
    function Qt(e) {
        var t = [];
        if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var i = e[0];
        if (e instanceof Element || i instanceof Element)
            Xt(e).forEach(function (e) {
                t = t.concat(
                    jt.filter(function (t) {
                        return t.container === e;
                    })
                );
            });
        else if ("string" == typeof e || "string" == typeof i) {
            Yt(e).forEach(function (e) {
                t = t.concat(
                    jt.filter(function (t) {
                        return t.type === e;
                    })
                );
            });
        }
        return t;
    }
    function Kt(e) {
        for (var t, i = 0; i < jt.length; i++)
            if (jt[i].id === e) {
                t = jt[i];
                break;
            }
        return t;
    }
    function Yt(e) {
        return (
            "*" === e
                ? (e = Object.keys(Rt))
                : "string" == typeof e
                    ? (e = [e])
                    : e.constructor === Ut
                        ? (e = [e.prototype.type])
                        : Array.isArray(e) &&
                        e[0].constructor === Ut &&
                        (e = e.map(function (e) {
                            return e.type;
                        })),
            (e = e.map(function (e) {
                return e.toLowerCase();
            }))
        );
    }
    function Xt(e) {
        return (
            NodeList.prototype.isPrototypeOf(e) && e.length > 0
                ? (e = Array.prototype.slice.call(e))
                : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) || null === e
                    ? (e = [])
                    : !Array.isArray(e) && e instanceof Element && (e = [e]),
            e
        );
    }
    function Zt(e, t) {
        (t = t || {}),
            e.focus(),
            void 0 !== t.className && e.classList.add(t.className),
            e.addEventListener("blur", function i(s) {
                s.target.removeEventListener(s.type, i), void 0 !== t.className && e.classList.remove(t.className);
            });
    }
    function ei(e) {
        e = e || {};
        var t = window.location.hash,
            i = document.getElementById(t.slice(1));
        if (i && e.ignore && i.matches(e.ignore)) return !1;
        t && i && Zt(i, e);
    }
    function ti(e) {
        return (
            (e = e || {}),
            Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (t) {
                if ("#" === t.hash || "" === t.hash) return !1;
                if (e.ignore && t.matches(e.ignore)) return !1;
                if (((i = t.hash.substr(1)), null === document.getElementById(i))) return !1;
                var i,
                    s = document.querySelector(t.hash);
                return (
                    !!s &&
                    (t.addEventListener("click", function () {
                        Zt(s, e);
                    }),
                        !0)
                );
            })
        );
    }
    function ii(e) {
        return Array.prototype.slice.call(e.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled[data-focus-element]")).filter(function (e) {
            return Boolean(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
        });
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (e) {
            var t = e.detail.sectionId,
                i = e.target.querySelector("[" + zt + '="' + t + '"]');
            null !== i && Jt(i.getAttribute(Vt), i);
        }),
            document.addEventListener("shopify:section:reorder", function (e) {
                var t = e.detail.sectionId,
                    i = e.target.querySelector("[" + zt + '="' + t + '"]');
                "object" == typeof Qt(i)[0] &&
                    Qt(i).forEach(function (e) {
                        e.onReorder();
                    });
            }),
            document.addEventListener("shopify:section:unload", function (e) {
                var t = e.detail.sectionId,
                    i = e.target.querySelector("[" + zt + '="' + t + '"]');
                "object" == typeof Qt(i)[0] &&
                    Qt(i).forEach(function (e) {
                        var t = jt
                            .map(function (e) {
                                return e.id;
                            })
                            .indexOf(e.id);
                        jt.splice(t, 1), e.onUnload();
                    });
            }),
            document.addEventListener("shopify:section:select", function (e) {
                var t = Kt(e.detail.sectionId);
                "object" == typeof t && t.onSelect(e);
            }),
            document.addEventListener("shopify:section:deselect", function (e) {
                var t = Kt(e.detail.sectionId);
                "object" == typeof t && t.onDeselect(e);
            }),
            document.addEventListener("shopify:block:select", function (e) {
                var t = Kt(e.detail.sectionId);
                "object" == typeof t && t.onBlockSelect(e);
            }),
            document.addEventListener("shopify:block:deselect", function (e) {
                var t = Kt(e.detail.sectionId);
                "object" == typeof t && t.onBlockDeselect(e);
            }));
    var si = {};
    function ri(e, t) {
        t = t || {};
        var i = ii(e),
            s = t.elementToFocus || e,
            r = i[0],
            n = i[i.length - 1];
        ni(),
            (si.focusin = function (t) {
                e !== t.target && !e.contains(t.target) && r && r === t.target && r.focus(), (t.target !== e && t.target !== n && t.target !== r) || document.addEventListener("keydown", si.keydown);
            }),
            (si.focusout = function () {
                document.removeEventListener("keydown", si.keydown);
            }),
            (si.keydown = function (t) {
                "Tab" === t.code && (t.target !== n || t.shiftKey || (t.preventDefault(), r.focus()), (t.target !== e && t.target !== r) || !t.shiftKey || (t.preventDefault(), n.focus()));
            }),
            document.addEventListener("focusout", si.focusout),
            document.addEventListener("focusin", si.focusin),
            Zt(s, t);
    }
    function ni() {
        document.removeEventListener("focusin", si.focusin), document.removeEventListener("focusout", si.focusout), document.removeEventListener("keydown", si.keydown);
    }
    var oi = Object.freeze({
        __proto__: null,
        forceFocus: Zt,
        focusHash: ei,
        bindInPageLinks: ti,
        focusable: ii,
        trapFocus: ri,
        removeTrapFocus: ni,
        accessibleLinks: function (e, t) {
            if ("string" != typeof e) throw new TypeError(e + " is not a String.");
            if (0 !== (e = document.querySelectorAll(e)).length) {
                (t = t || {}).messages = t.messages || {};
                var i,
                    s,
                    r,
                    n = {
                        newWindow: t.messages.newWindow || "Opens in a new window.",
                        external: t.messages.external || "Opens external website.",
                        newWindowExternal: t.messages.newWindowExternal || "Opens external website in a new window.",
                    },
                    o = t.prefix || "a11y",
                    a = { newWindow: o + "-new-window-message", external: o + "-external-message", newWindowExternal: o + "-new-window-external-message" };
                e.forEach(function (e) {
                    var t = e.getAttribute("target"),
                        i = e.getAttribute("rel"),
                        s = (function (e) {
                            return e.hostname !== window.location.hostname;
                        })(e),
                        r = "_blank" === t,
                        n = null === i || -1 === i.indexOf("noopener");
                    if (r && n) {
                        var o = null === i ? "noopener" : i + " noopener";
                        e.setAttribute("rel", o);
                    }
                    s && r ? e.setAttribute("aria-describedby", a.newWindowExternal) : s ? e.setAttribute("aria-describedby", a.external) : r && e.setAttribute("aria-describedby", a.newWindow);
                }),
                    (i = n),
                    (s = document.createElement("ul")),
                    (r = Object.keys(i).reduce(function (e, t) {
                        return e + "<li id=" + a[t] + ">" + i[t] + "</li>";
                    }, "")),
                    s.setAttribute("hidden", !0),
                    (s.innerHTML = r),
                    document.body.appendChild(s);
            }
        },
    });
    const ai = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])';
    function li(e) {
        const t = `data-popup-${e}`;
        n.init({
            openTrigger: t,
            disableScroll: !0,
            onShow: (e, t, i) => {
                i.preventDefault();
                const s = e.querySelector(ai);
                ri(e, { elementToFocus: s });
            },
            onClose: (e, t, i) => {
                i.preventDefault(), ni(), t.focus();
            },
        });
    }
    const ci = "[data-toggle-password-modal]",
        hi = ".storefront-password-form .errors",
        di = {};
    Gt("password", {
        onLoad() {
            di[this.id] = new (class {
                init() {
                    li("password"), this.errors && this.trigger.click();
                }
                constructor(e) {
                    (this.container = e.container), (this.trigger = this.container.querySelector(ci)), (this.errors = this.container.querySelector(hi)), this.init();
                }
            })(this);
        },
    }),
        (function () {
            var e = "#QrCode",
                t = ".giftcard__code";
            const i = document.querySelector(e);
            if (i) {
                function r() {
                    const e = i.getAttribute("data-identifier");
                    new QRCode(i, { text: e, width: 120, height: 120 });
                }
                window.addEventListener("load", r);
            }
            const s = document.querySelector(t);
            if (s) {
                function n() {
                    var e = document.querySelector("#GiftCardDigits"),
                        t = "";
                    if (document.body.createTextRange) (t = document.body.createTextRange()).moveToElementText(e), t.select();
                    else if (window.getSelection) {
                        var i = window.getSelection();
                        (t = document.createRange()).selectNodeContents(e), i.removeAllRanges(), i.addRange(t);
                    }
                }
                s.addEventListener("click", n());
            }
        })();
    const ui = "[data-parallax-wrapper]",
        pi = "[data-parallax-img]";
    let mi = {};
    const fi = {
        onLoad() {
            mi[this.id] = [];
            this.container.querySelectorAll(ui).forEach((e) => {
                const t = e.querySelector(pi);
                mi[this.id].push(new o(t, { center: !0, round: !0, frame: e }));
            });
        },
        onUnload: function () {
            mi[this.id].forEach((e) => {
                "function" == typeof e.destroy && e.destroy();
            });
        },
    };
    Gt("article", fi);
    const gi = "[data-ticker-frame]",
        yi = "[data-ticker-scale]",
        vi = "[data-ticker-text]",
        bi = "data-clone",
        wi = "aria-hidden",
        Si = "ticker--animated",
        Ei = "ticker--unloaded",
        Li = "ticker__comparitor",
        ki = {};
    let Ti = class {
        init() {
            this.addComparitor(), (this.resizeEvent = T(() => this.checkWidth(), 300)), this.listen();
        }
        addComparitor() {
            (this.comparitor = this.text.cloneNode(!0)), this.comparitor.classList.add(Li), this.frame.appendChild(this.comparitor), this.scale.classList.remove(Ei);
        }
        unload() {
            document.removeEventListener("theme:resize", this.resizeEvent);
        }
        listen() {
            document.addEventListener("theme:resize", this.resizeEvent), this.checkWidth();
        }
        checkWidth() {
            const e = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
            if (
                (Array.from(this.text.parentNode.children).forEach((e) => {
                    e.classList.add(Si);
                }),
                    this.frame.clientWidth - e < this.comparitor.clientWidth || this.stopClone)
            ) {
                if (1 === this.scale.childElementCount && ((this.clone = this.text.cloneNode(!0)), this.clone.setAttribute(wi, !0), this.clone.setAttribute(bi, ""), this.scale.appendChild(this.clone), this.stopClone))
                    for (let e = 0; e < 10; e++) {
                        const e = this.text.cloneNode(!0);
                        e.setAttribute(wi, !0), e.setAttribute(bi, ""), this.scale.appendChild(e);
                    }
                const e = (this.text.clientWidth / this.space) * this.timeIndex;
                this.scale.style.setProperty("--animation-time", `${e}s`);
            } else {
                let e = this.scale.querySelector(`[${bi}]`);
                e && this.scale.removeChild(e), this.text.classList.remove(Si);
            }
        }
        constructor(e, t = !1) {
            (this.frame = e), (this.stopClone = t), (this.scale = this.frame.querySelector(yi)), (this.text = this.frame.querySelector(vi)), (this.space = 100), (this.timeIndex = 1.63), this.init();
        }
    };
    const xi = {
        onLoad() {
            ki[this.id] = [];
            this.container.querySelectorAll(gi).forEach((e) => {
                ki[this.id].push(new Ti(e));
            });
        },
        onUnload() {
            ki[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            });
        },
    },
        _i = "[data-ticker-frame]",
        Ai = "data-slide",
        qi = "[data-ticker-scale]",
        Ci = "[data-ticker-text]",
        Pi = "ticker--animated",
        $i = {};
    Gt("logos", {
        onLoad() {
            ($i[this.id] = []),
                $i[this.id].push(
                    new (class {
                        init() {
                            this.initTickers(!0);
                        }
                        initTickers(e = !1) {
                            const t = this.container.querySelector(_i);
                            t && new Ti(t, e);
                        }
                        toggleTicker(e, t) {
                            const i = this.container.querySelector(qi),
                                s = this.container.querySelector(`[${Ai}="${e.detail.blockId}"]`);
                            if (s && i) {
                                if (t) {
                                    const e = Number(getComputedStyle(s).getPropertyValue("--gutter").replace("px", "")),
                                        t = -(s.offsetLeft - e);
                                    i.setAttribute("data-stop", ""),
                                        i.querySelectorAll(Ci).forEach((e) => {
                                            e.classList.remove(Pi), (e.style.transform = `translate3d(${t}px, 0, 0)`);
                                        });
                                }
                                t ||
                                    (i.querySelectorAll(Ci).forEach((e) => {
                                        e.classList.add(Pi), e.removeAttribute("style");
                                    }),
                                        i.removeAttribute("data-stop"));
                            }
                        }
                        onBlockSelect(e) {
                            this.toggleTicker(e, !0);
                        }
                        onBlockDeselect(e) {
                            this.toggleTicker(e, !1);
                        }
                        constructor(e) {
                            (this.container = e.container), this.init();
                        }
                    })(this)
                );
        },
        onBlockSelect(e) {
            $i[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
            });
        },
        onBlockDeselect(e) {
            $i[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockDeselect(e);
            });
        },
    }),
        Gt("blog", fi);
    var Mi = "[data-drawer]",
        Ii = "[data-drawer-scrolls]",
        Di = "[data-predictive-search-input]",
        Oi = "[data-drawer-underlay]",
        Hi = "[data-stagger-animation]",
        Fi = "data-drawer-toggle",
        Bi = ":scope > * > [data-animates]",
        Wi = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Ni = "drawer--visible",
        Ri = "display-none",
        ji = {};
    const zi = {
        onLoad() {
            ji[this.id] = [];
            this.container.querySelectorAll(Mi).forEach((e) => {
                ji[this.id].push(
                    new (class {
                        unload() { }
                        connectToggle() {
                            this.buttons.forEach((e) => {
                                e.addEventListener(
                                    "click",
                                    function (e) {

                                        var root = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)

                                        root.setAttribute('class', 'toggle_cart_drawer_open');

                                        e.preventDefault(), this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", { bubbles: !1 }));
                                    }.bind(this)
                                );
                            });
                        }
                        connectDrawer() {
                            this.drawer.addEventListener(
                                "theme:drawer:toggle",
                                function () {
                                    this.drawer.classList.contains(Ni)
                                        ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: !1 }))
                                        : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
                                }.bind(this)
                            ),
                                this.drawer.addEventListener("theme:drawer:close", this.hideDrawer.bind(this)),
                                this.drawer.addEventListener("theme:drawer:open", this.showDrawer.bind(this));
                        }
                        staggerChildAnimations() {
                            this.staggers.forEach((e) => {
                                e.querySelectorAll(Bi).forEach((e, t) => {
                                    e.style.transitionDelay = 50 * t + 10 + "ms";
                                });
                            });
                        }
                        closers() {
                            this.drawer.addEventListener(
                                "keyup",
                                function (e) {
                                    "Escape" === e.code && (this.hideDrawer(), this.buttons[0].focus());
                                }.bind(this)
                            ),
                                this.underlay.addEventListener(
                                    "click",
                                    function () {
                                        this.hideDrawer();
                                    }.bind(this)
                                );
                        }
                        focusFirst() {
                            // const e = this.drawer.querySelector(Di);
                            // if (e) e.focus();
                            // else {
                            //     const e = this.drawer.querySelector(Wi);
                            //     ri(this.drawer, { elementToFocus: e });
                            // }
                            const e = this.drawer.querySelector(Wi);
                            ri(this.drawer, { elementToFocus: e });
                        }
                        showDrawer() {
                            this.drawer.classList.remove(Ri),
                                setTimeout(() => {
                                    this.buttons.forEach((e) => e.setAttribute("aria-expanded", !0)),
                                        this.drawer.classList.add(Ni),
                                        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.drawerScrolls })),
                                        this.drawer.addEventListener("transitionend", this.focusFirst.bind(this), { once: !0 }),
                                        this.drawer.addEventListener("transitioncancel", this.focusFirst.bind(this), { once: !0 });
                                }, 1);
                        }
                        hideDrawer() {
                            (window.theme.state.cartOpen = !1),
                                this.buttons.forEach((e) => e.setAttribute("aria-expanded", !0)),
                                this.drawer.classList.remove(Ni),
                                this.drawerScrolls.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                                document.dispatchEvent(new CustomEvent("theme:sliderule:close", { bubbles: !1 })),
                                ni(),
                                setTimeout(() => {
                                    this.drawer.classList.contains(Ni) || this.drawer.classList.add(Ri);
                                }, 800);
                        }
                        constructor(e) {
                            (this.drawer = e), (this.drawerScrolls = this.drawer.querySelector(Ii)), (this.underlay = this.drawer.querySelector(Oi)), (this.key = this.drawer.dataset.drawer);
                            const t = `[${Fi}='${this.key}']`;
                            (this.buttons = document.querySelectorAll(t)), (this.staggers = this.drawer.querySelectorAll(Hi)), this.connectToggle(), this.connectDrawer(), this.closers(), this.staggerChildAnimations();
                        }
                    })(e)
                );
            });
        },
        onUnload: function () {
            ji[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            });
        },
    },
        Vi = "[data-announcement-bar]",
        Ui = "data-header-transparent",
        Gi = "[data-header-wrapper] header",
        Ji = "js__header__stuck",
        Qi = "js__header__stuck--animated",
        Ki = "js__header__stuck--trigger-animation",
        Yi = "js__header__stuck__backdrop";
    let Xi = {};
    const Zi = {
        onLoad() {
            Xi = new (class {
                unload() {
                    document.removeEventListener("theme:scroll", this.listen), document.removeEventListener("theme:scroll:up", this.scrollUpDirectional), document.removeEventListener("theme:scroll:down", this.scrollDownDirectional);
                }
                listen() {
                    (this.sticks || this.animated) &&
                        document.addEventListener("theme:scroll", (e) => {
                            e.detail.down
                                ? (!this.currentlyStuck && e.detail.position > this.stickDown && this.stickSimple(), !this.currentlyBlurred && e.detail.position > this.blur && this.addBlur())
                                : (e.detail.position <= this.stickUp && this.unstickSimple(), e.detail.position <= this.blur && this.removeBlur());
                        }),
                        this.animated && (document.addEventListener("theme:scroll:up", this.scrollUpDirectional.bind(this)), document.addEventListener("theme:scroll:down", this.scrollDownDirectional.bind(this)));
                }
                stickSimple() {
                    this.animated && this.cls.add(Qi), this.cls.add(Ji), this.wrapper.setAttribute(Ui, !1), (this.currentlyStuck = !0);
                }
                unstickSimple() {
                    this.cls.remove(Ji), this.wrapper.setAttribute(Ui, this.transparent), this.animated && this.cls.remove(Qi), (this.currentlyStuck = !1);
                }
                scrollDownInit() {
                    window.scrollY > this.stickDown && this.stickSimple(), window.scrollY > this.blur && this.addBlur();
                }
                stickDirectional() {
                    this.cls.add(Ki);
                }
                unstickDirectional() {
                    this.cls.remove(Ki);
                }
                scrollDownDirectional() {
                    this.unstickDirectional();
                }
                scrollUpDirectional() {
                    window.scrollY <= this.stickDown ? this.unstickDirectional() : this.stickDirectional();
                }
                addBlur() {
                    this.cls.add(Yi), (this.currentlyBlurred = !0);
                }
                removeBlur() {
                    this.cls.remove(Yi), (this.currentlyBlurred = !1);
                }
                constructor(e) {
                    (this.wrapper = e),
                        (this.type = this.wrapper.dataset.headerSticky),
                        (this.transparent = this.wrapper.dataset.headerTransparent),
                        (this.sticks = "sticky" === this.type),
                        (this.animated = "directional" === this.type),
                        (this.currentlyStuck = !1),
                        (this.cls = this.wrapper.classList);
                    const t = document.querySelector(Vi),
                        i = t ? t.clientHeight : 0,
                        s = document.querySelector(Gi).clientHeight;
                    (this.blur = s + i), (this.stickDown = s + i), (this.stickUp = i), "false" !== this.wrapper.getAttribute(Ui) && (this.blur = i), this.sticks && ((this.stickDown = i), this.scrollDownInit()), this.listen();
                }
            })(this.container);
        },
        onUnload: function () {
            "function" == typeof Xi.unload && Xi.unload();
        },
    },
        es = "data-hover-disclosure-toggle",
        ts = "[data-hover-disclosure]",
        is = "[data-top-link]",
        ss = "[data-header-wrapper]",
        rs = "[data-stagger]",
        ns = "[data-stagger-first]",
        os = "[data-stagger-second]",
        as = "[data-grid-item], [data-header-image]",
        ls = "is-visible",
        cs = "meganav--visible",
        hs = "grandparent";
    let ds = {},
        us = {};
    const ps = {
        onLoad() {
            (ds[this.id] = []),
                (us = this.container.querySelectorAll(ts)),
                us.forEach((e) => {
                    ds[this.id].push(
                        new (class {
                            onBlockSelect(e) {
                                this.disclosure.contains(e.target) && this.showDisclosure();
                            }
                            onBlockDeselect(e) {
                                this.disclosure.contains(e.target) && this.hideDisclosure();
                            }
                            showDisclosure() {
                                this.grandparent ? this.wrapper.classList.add(cs) : this.wrapper.classList.remove(cs), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(ls), this.disclosure.classList.add(ls);
                            }
                            hideDisclosure() {
                                this.disclosure.classList.remove(ls), this.trigger.classList.remove(ls), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(cs);
                            }
                            staggerChildAnimations() {
                                this.disclosure.querySelectorAll(rs).forEach((e, t) => {
                                    e.style.transitionDelay = 50 * t + 10 + "ms";
                                }),
                                    this.disclosure.querySelectorAll(ns).forEach((e, t) => {
                                        const i = 150 * t;
                                        (e.style.transitionDelay = `${i}ms`),
                                            e.parentElement.querySelectorAll(os).forEach((e, t) => {
                                                const s = 20 * (t + 1);
                                                e.style.transitionDelay = `${i + s}ms`;
                                            });
                                    }),
                                    this.disclosure.querySelectorAll(as).forEach((e, t) => {
                                        e.style.transitionDelay = 80 * (t + 1) + "ms";
                                    });
                            }
                            handleTablets() {
                                this.trigger.addEventListener(
                                    "touchstart",
                                    function (e) {
                                        this.disclosure.classList.contains(ls) || (e.preventDefault(), this.showDisclosure());
                                    }.bind(this),
                                    { passive: !0 }
                                );
                            }
                            connectHoverToggle() {
                                this.trigger.addEventListener("pointerenter", this.showDisclosure.bind(this)),
                                    this.link.addEventListener("focus", this.showDisclosure.bind(this)),
                                    this.trigger.addEventListener("pointerleave", this.hideDisclosure.bind(this)),
                                    this.trigger.addEventListener(
                                        "focusout",
                                        function (e) {
                                            this.trigger.contains(e.relatedTarget) || this.hideDisclosure();
                                        }.bind(this)
                                    ),
                                    this.disclosure.addEventListener(
                                        "keyup",
                                        function (e) {
                                            "Escape" === e.code && this.hideDisclosure();
                                        }.bind(this)
                                    );
                            }
                            constructor(e) {
                                (this.disclosure = e), (this.wrapper = e.closest(ss)), (this.key = this.disclosure.id);
                                const t = `[${es}='${this.key}']`;
                                (this.trigger = document.querySelector(t)),
                                    (this.link = this.trigger.querySelector(is)),
                                    (this.grandparent = this.trigger.classList.contains(hs)),
                                    this.trigger.setAttribute("aria-haspopup", !0),
                                    this.trigger.setAttribute("aria-expanded", !1),
                                    this.trigger.setAttribute("aria-controls", this.key),
                                    this.connectHoverToggle(),
                                    this.handleTablets(),
                                    this.staggerChildAnimations();
                            }
                        })(e)
                    );
                });
        },
        onBlockSelect(e) {
            ds[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
            });
        },
        onBlockDeselect(e) {
            ds[this.id].forEach((t) => {
                "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
            });
        },
        onUnload: function () {
            ds[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            });
        },
    },
        ms = "[data-main-menu-text-item]",
        fs = "[data-text-items-wrapper]",
        gs = ".navtext",
        ys = "data-menu-active",
        vs = "[data-header-wrapper]",
        bs = "data-underline-current",
        ws = ".menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext";
    let Ss = {},
        Es = null;
    const Ls = {
        onLoad() {
            Ss[this.id] = [];
            this.container.querySelectorAll(fs).forEach((e) => {
                Ss[this.id].push(
                    new (class {
                        init() {
                            if (this.itemList.length) {
                                if ((this.listen(), this.listenResize(), (this.textBottom = null), this.setHeight(), Es)) {
                                    if (this.defaultItem) {
                                        const e = this.defaultItem.offsetLeft || 0;
                                        this.sectionOuter.style.setProperty("--bar-left", `${e}px`);
                                    }
                                    this.reset();
                                } else {
                                    const e = this.sectionOuter.querySelector(ms).offsetLeft;
                                    this.sectionOuter.style.setProperty("--bar-left", `${e}px`), this.sectionOuter.style.setProperty("--bar-width", "0px");
                                }
                                this.sectionOuter.style.setProperty("--bar-opacity", "1");
                            }
                        }
                        unload() {
                            document.removeEventListener("theme:resize", this.reset), (Es = null);
                        }
                        listenResize() {
                            document.addEventListener("theme:resize", this.reset.bind(this));
                        }
                        setDefault() {
                            this.defaultItem && (Es = { left: this.defaultItem.offsetLeft || null, width: this.defaultItem.clientWidth || null });
                        }
                        setHeight() {
                            const e = this.wrapper.clientHeight,
                                t = this.itemList[0].querySelector(gs).clientHeight,
                                i = Math.floor(e / 2 - t / 2) - 4;
                            this.textBottom !== i && (this.sectionOuter.style.setProperty("--bar-text", `${t}px`), this.sectionOuter.style.setProperty("--bar-bottom", `${i}px`), (this.textBottom = i));
                        }
                        listen() {
                            this.itemList.forEach((e) => {
                                e.addEventListener("pointerenter", (e) => {
                                    const t = e.target.querySelector(gs);
                                    this.startBar(t);
                                });
                            }),
                                this.wrapper.addEventListener("pointerleave", this.clearBar.bind(this));
                        }
                        startBar(e) {
                            this.setHeight();
                            let t = "false" !== this.sectionOuter.getAttribute(ys),
                                i = e.offsetLeft,
                                s = e.clientWidth;
                            t
                                ? this.render(s, i)
                                : (this.sectionOuter.setAttribute(ys, !0),
                                    this.render(0, i),
                                    setTimeout(() => {
                                        this.render(s, i);
                                    }, 10));
                        }
                        render(e, t) {
                            this.sectionOuter.style.setProperty("--bar-left", `${t}px`), this.sectionOuter.style.setProperty("--bar-width", `${e}px`);
                        }
                        reset() {
                            this.setDefault(),
                                Es && Es.left && Es.width
                                    ? (this.sectionOuter.style.setProperty("--bar-left", `${Es.left}px`), this.sectionOuter.style.setProperty("--bar-width", `${Es.width}px`))
                                    : this.sectionOuter.style.setProperty("--bar-width", "0px");
                        }
                        clearBar() {
                            this.sectionOuter.setAttribute(ys, !1),
                                setTimeout(() => {
                                    "false" !== this.sectionOuter.getAttribute(ys) || this.reset();
                                }, 150);
                        }
                        constructor(e) {
                            (this.wrapper = e),
                                (this.itemList = this.wrapper.querySelectorAll(ms)),
                                (this.sectionOuter = document.querySelector(vs)),
                                (this.underlineCurrent = "true" === this.sectionOuter.getAttribute(bs)),
                                (this.defaultItem = null),
                                this.underlineCurrent && (this.defaultItem = this.wrapper.querySelector(ws)),
                                this.setDefault(),
                                document.fonts.ready.then(() => {
                                    this.init();
                                });
                        }
                    })(e)
                );
            });
        },
        onUnload: function () {
            Ss[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            }),
                delete Ss[this.id];
        },
    },
        ks = "data-header-cart-price",
        Ts = "data-header-cart-count",
        xs = "data-header-cart-full";
    const _s = {
        onLoad() {
            new (class {
                listen() {
                    document.addEventListener(
                        "theme:cart:change",
                        function (e) {
                            (this.cart = e.detail.cart), this.update();
                        }.bind(this)
                    );
                }
                update() {
                    this.cart &&
                        (this.prices.forEach((e) => {
                            e.setAttribute(ks, this.cart.total_price);
                            const t = a.formatMoney(this.cart.total_price, theme.moneyFormat);
                            e.innerHTML = t;
                        }),
                            this.counts.forEach((e) => {
                                e.setAttribute(Ts, this.cart.item_count), (e.innerHTML = `(${this.cart.item_count})`);
                            }),
                            this.dots.forEach((e) => {
                                const t = this.cart.item_count > 0;
                                e.setAttribute(xs, t);
                            }));
                }
                constructor(e) {
                    (this.section = e),
                        (this.counts = this.section.querySelectorAll(`[${Ts}]`)),
                        (this.prices = this.section.querySelectorAll(`[${ks}]`)),
                        (this.dots = this.section.querySelectorAll(`[${xs}]`)),
                        (this.cart = null),
                        this.listen();
                }
            })(this.container);
        },
    },
        As = "[data-search-popdown-wrap]",
        qs = "data-popdown-toggle",
        Cs = "[data-close-popdown]",
        Ps = "[data-predictive-search-input]",
        $s = "[data-search-underlay]",
        Ms = "underlay--visible",
        Is = "is-visible";
    let Ds = {};
    const Os = {
        onLoad() {
            Ds[this.id] = {};
            const e = this.container.querySelector(`[${qs}]`);
            e &&
                (Ds[this.id] = new (class {
                    initTriggerEvents() {
                        this.trigger.setAttribute("aria-haspopup", !0),
                            this.trigger.setAttribute("aria-expanded", !1),
                            this.trigger.setAttribute("aria-controls", this.key),
                            this.trigger.addEventListener(
                                "click",
                                function (e) {
                                    e.preventDefault(), this.showPopdown();
                                }.bind(this)
                            ),
                            this.trigger.addEventListener(
                                "keyup",
                                function (e) {
                                    "Space" === e.code && this.showPopdown();
                                }.bind(this)
                            );
                    }
                    initPopdownEvents() {
                        this.popdown.addEventListener(
                            "keyup",
                            function (e) {
                                "Escape" === e.code && this.hidePopdown();
                            }.bind(this)
                        ),
                            this.close.forEach(btn => btn.addEventListener(
                                "click",
                                function () {
                                    this.hidePopdown();
                                }.bind(this))
                            ),
                            this.underlay.addEventListener(
                                "click",
                                function () {
                                    this.hidePopdown();
                                }.bind(this)
                            );
                    }
                    hidePopdown() {
                        this.popdown.classList.remove(Is), this.underlay.classList.remove(Ms), this.trigger.focus(), ni(), this.popdown.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                    }
                    showPopdown() {
                        this.popdown.classList.add(Is), this.underlay.classList.add(Ms), ri(this.popdown, { elementToFocus: this.input }), this.popdown.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                    }
                    constructor(e) {
                        (this.trigger = e),
                            (this.key = this.trigger.getAttribute(qs)),
                            (this.popdown = document.querySelector(`[id='${this.key}']`)),
                            (this.input = this.popdown.querySelector(Ps)),
                            (this.close = this.popdown.querySelectorAll(Cs)),
                            (this.wrapper = this.popdown.closest(As)),
                            (this.underlay = this.wrapper.querySelector($s)),
                            this.initTriggerEvents(),
                            this.initPopdownEvents();
                    }
                })(e));
        },
        onUnload: function () {
            "function" == typeof Ds[this.id].unload && Ds[this.id].unload();
        },
    },
        Hs = "[data-product-add-popdown-wrapper]",
        Fs = "[data-close-popdown]",
        PopdownCloseOpenCartSel = "[data-close-popdown-open-cart]",
        Bs = "[data-api-content]",
        Ws = '[data-ajax-disable="false"]',
        Ns = '[data-ajax-disable="true"]',
        Rs = '[data-drawer-toggle="drawer-cart"]',
        js = '[data-drawer="drawer-cart"]',
        zs = "is-visible";
    let Vs;
    const Us = {
        onLoad() {
            new (class {
                renderPopdown(e) {
                    const t = e.detail.variant,
                        i = `${window.theme.routes.root_url}variants/${t.id}/?section_id=api-product-popdown`,
                        s = this;
                    l.get(i)
                        .then(function (e) {
                            const t = document.createElement("div");
                            t.innerHTML = e.data;
                            const content = t.querySelector(Bs);
                            if (content.hasAttribute("data-popdown-empty")) {
                                const cartDrawerToggle = document.querySelector(js);
                                cartDrawerToggle && cartDrawerToggle.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
                                return;
                            }
                            (s.drawer.innerHTML = content.innerHTML), s.connectCartButton(), s.connectCloseButton();
                        })
                        .catch(function (e) {
                            console.warn(e);
                        });
                }
                connectCloseButton() {
                    this.drawer.classList.add(zs),
                        this.drawer.querySelectorAll(Fs).forEach(btn => {
                        btn.addEventListener("click",
                            function (e) {
                                e.preventDefault(), this.drawer.classList.remove(zs);
                            }.bind(this)
                        );
                    });
                    const cartDrawerToggle = document.querySelector(js);
                    this.drawer.querySelectorAll(PopdownCloseOpenCartSel).forEach(btn => {
                        btn.addEventListener("click",
                            function (e) {
                                e.preventDefault(),
                                    this.drawer.classList.remove(zs),
                                    cartDrawerToggle && cartDrawerToggle.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
                            }.bind(this)
                        );
                    });
                }
                connectCartButton() {
                    const e = this.drawer.querySelector(Rs),
                        t = document.querySelector(js);
                    t &&
                        e.addEventListener(
                            "click",
                            function (e) {
                                e.preventDefault(), this.drawer.classList.remove(zs), t.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
                            }.bind(this)
                        );
                }
                popdownTimer() {
                    clearTimeout(Vs),
                        (Vs = setTimeout(() => {
                            this.drawer.classList.remove(zs);
                        }, 5e3));
                }
                constructor() {
                    (this.drawer = document.querySelector(Hs)),
                        (this.cartAjaxEnabled = document.querySelector(Ws)),
                        (this.cartAjaxDisabled = document.querySelector(Ns)),
                        document.addEventListener("theme:cart:popdown", (e) => {
                            this.cartAjaxEnabled ? this.cartAjaxEnabled.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 })) : this.cartAjaxDisabled ? window.location.reload() : this.renderPopdown(e);
                        });
                }
            })(this);
        },
    },
        Gs = "data-grid-item-variant";
    let Js = class extends HTMLElement {
        connectedCallback() {
            this.gridItemVariantLinks.length &&
                this.gridItemVariantLinks.forEach((e) => {
                    e.hasAttribute(Gs) && (this.swatchHoverEvent(e), this.swatchClickEvent(e));
                });
        }
        swatchHoverEvent(e) {
            e.addEventListener("mouseenter", () => {
                if (e.hasAttribute(Gs)) {
                    const t = e.getAttribute(Gs);
                    this.container.querySelectorAll(`product-grid-item-variant[${Gs}="${t}"] product-grid-item-image`).forEach((e) => {
                        e.setAttribute("loading", "eager");
                    });
                }
            });
        }
        swatchClickEvent(e) {
            e.addEventListener("click", (t) => {
                if ((t.preventDefault(), this.container.querySelectorAll(`a[${Gs}]`).forEach((e) => e.removeAttribute("aria-selected")), e.setAttribute("aria-selected", "true"), e.hasAttribute(Gs))) {
                    const t = e.getAttribute(Gs);
                    this.container.querySelectorAll(`product-grid-item-variant[${Gs}]`).forEach((e) => {
                        e.getAttribute(Gs) === t ? e.removeAttribute("hidden") : e.setAttribute("hidden", "");
                    });
                }
            });
        }
        constructor() {
            super(), (this.container = this), (this.gridItemVariantLinks = this.container.querySelectorAll(`a[${Gs}]`));
        }
    };
    const Qs = "[data-grid-link]",
        Ks = "data-grid-images",
        Ys = "data-grid-image",
        Xs = "data-grid-image-target",
        Zs = "data-grid-current-image",
        er = "data-grid-pagination",
        tr = "data-grid-page",
        ir = "data-slide-for-filter-selected-variant",
        sr = "data-slide-for-variant-media",
        rr = "data-slideshow-style",
        nr = "--width",
        or = "is-active",
        ar = "is-mobile",
        lr = "product-grid-item__pagination";
    let cr = class extends HTMLElement {
        static get observedAttributes() {
            return ["hidden"];
        }
        preloadImage(e) {
            if (this.isMobile) return;
            const t = [...this.images][e];
            if (!t) throw new Error(`No child element at index ${e}`);
            t.setAttribute("loading", "eager");
        }
        preloadImages() {
            [...this.imagesHolder.children].forEach((e, t) => this.preloadImage(t));
        }
        connectedCallback() {
            this.toggleMobile(),
                document.addEventListener("theme:resize:width", () => this.toggleMobile()),
                this.isMobile ||
                (this.imageCount > 1 &&
                    (this.createPaging(),
                        this.container.addEventListener("theme:swatch:change", this.swatchChangeEvent),
                        this.container.addEventListener("mouseenter", this.mouseEnterEvent),
                        this.container.addEventListener("mouseleave", this.mouseLeaveEvent)),
                    this.intersectionObserver.observe(this.container));
        }
        disconnectedCallback() {
            this.container.removeEventListener("theme:swatch:change", this.swatchChangeEvent), this.container.removeEventListener("mouseenter", this.mouseEnterEvent), this.container.removeEventListener("mouseleave", this.mouseLeaveEvent);
        }
        swatchChangeEvent(e) {
            const t = e.detail.id,
                i = this.container.querySelector(`[${Xs}="${t}"]`);
            if (i) {
                const t = i.getAttribute(Ys);
                (this.pagingProgressCounter = 0), this.changeImage(t), e.detail.stopSlideAnimation && this.stopPaging();
            }
        }
        mouseEnterEvent() {
            switch ((this.preloadImages(), this.slideshowStyle)) {
                case "cycle_images":
                    (this.pagingProgressPause = this.isMobile), this.progressPaging();
                    break;
                case "second_immediately":
                    this.changeImage(this.getNextIndex());
                    break;
                case "disabled":
                    break;
                default:
                    throw new Error(`Unknown option ${this.slideshowStyle}`);
            }
        }
        mouseLeaveEvent() {
            (this.pagingProgressPause = !0), this.resetSlideshow(), this.progressPaging();
        }
        attributeChangedCallback(e, t, i) {
            "hidden" === e && null == t && null != i && this.showVariant();
        }
        toggleMobile() {
            this.container.classList.toggle(ar, this.isMobile);
        }
        get isMobile() {
            return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < window.theme.sizes.medium;
        }
        resetSlideshow() {
            const e = this.container.querySelector(`[${ir}]`);
            if (e) {
                let t = Number(e.getAttribute(Ys));
                this.changeImage(t);
            } else this.changeImage(0);
            this.pagingProgressPause = !0;
        }
        showVariant() {
            const e = this.container.querySelector(`[${sr}]`);
            if (e) {
                let t = Number(e.getAttribute(Ys));
                this.changeImage(t);
            } else this.changeImage(0);
            this.pagingProgressPause = !0;
        }
        getNextIndex() {
            let e = this.container.querySelector(`[${Ys}][${Zs}]`);
            if (e) {
                return (Number(e.getAttribute(Ys)) + 1) % this.imageCount;
            }
            return 0;
        }
        changeImage(e) {
            const t = this.images[e % this.imageCount];
            t && (this.activeImages.forEach((e) => e.removeAttribute(Zs)), t.setAttribute(Zs, "true"), "cycle_images" === this.slideshowStyle && this.changePaging(e));
        }
        changePaging(e = 0) {
            const t = this.container.querySelector(`[${tr}].${or}`),
                i = this.container.querySelector(`[${tr}="${e}"]`);
            t && (t.style.setProperty(nr, "100%"), t.classList.remove(or)), i && (i.classList.add(or), this.progressPaging());
        }
        progressPaging() {
            const e = this.container.querySelector(`[${tr}].${or}`);
            e &&
                !this.isMobile &&
                (this.stopPaging(),
                    0 === this.pagingProgressCounter && e.style.setProperty(nr, "0%"),
                    (this.interval = setInterval(() => {
                        this.pagingProgressCounter >= 100 && !this.pagingProgressPause
                            ? (this.stopPaging(), (this.pagingProgressCounter = 0), this.changeImage(this.getNextIndex()))
                            : this.pagingProgressPause || (this.pagingProgressCounter++, e.style.setProperty(nr, `${this.pagingProgressCounter}%`));
                    }, this.timeout / 100)));
        }
        stopPaging() {
            this.interval && clearInterval(this.interval);
        }
        createPaging() {
            if (this.imagesHolder && "cycle_images" === this.slideshowStyle) {
                let e = "";
                for (let t = 0; t < this.imageCount; t++) {
                    let i = "";
                    0 === t && (i = `class="${or}"`), (e += `<span ${i} ${tr}="${t}">${t + 1}</span>`);
                }
                if ("" !== e) {
                    let t = this.container.querySelector(`[${er}]`);
                    t || ((t = document.createElement("div")), (t.className = lr), t.setAttribute(er, "")), (t.innerHTML = e), this.imagesHolder.parentElement.prepend(t);
                }
            }
        }
        removePaging() {
            const e = this.container.querySelector(`[${er}]`);
            e && e.remove();
        }
        get imagesHolder() {
            return this.container.querySelector(`[${Ks}]`);
        }
        get images() {
            return this.imagesHolder.querySelectorAll(`[${Ys}]`);
        }
        get activeImages() {
            return this.imagesHolder.querySelectorAll(`[${Ys}][${Zs}]`);
        }
        get links() {
            return this.container.querySelectorAll(Qs);
        }
        get slideshowStyle() {
            return this.container.getAttribute(rr);
        }
        get imageCount() {
            return this.images.length;
        }
        constructor() {
            super(),
                (this.container = this),
                (this.mobileStopSlideshow = "true"),
                (this.timeout = 1e3 * window.theme.settings.cycle_images_hover_delay || 1500),
                (this.interval = null),
                (this.pagingProgressPause = !1),
                (this.pagingProgressCounter = 0),
                (this.siblingsFetchCounter = 0),
                (this.siblingLoadImageIndex = null),
                (this.intersectionObserver = new IntersectionObserver(
                    (e) => {
                        e.forEach((e) => {
                            e.isIntersecting && this.imageCount > 1 && this.preloadImage(1);
                        });
                    },
                    { threshold: 0.1 }
                ));
        }
    };
    const hr = "data-grid-current-image",
        dr = "is-active";
    let ur = class extends HTMLElement {
        static get observedAttributes() {
            return ["loading", hr];
        }
        connectedCallback() {
            null === this.getAttribute(hr) ? this.hide() : this.show();
        }
        attributeChangedCallback(e, t, i) {
            switch (e) {
                case "loading":
                    (null !== i && "eager" !== i) || this.eagerLoad();
                    break;
                case hr:
                    null === i ? this.hide() : this.show();
            }
        }
        show() {
            this.classList.add(dr);
        }
        hide() {
            this.classList.remove(dr);
        }
        eagerLoad() {
            const e = this.firstElementChild;
            switch (e.nodeName) {
                case "TEMPLATE":
                    const t = e,
                        i = t.content;
                    i.querySelectorAll("img").forEach((e) => {
                        e.setAttribute("loading", "eager"), e.setAttribute("fetchpriority", "high");
                    }),
                        t.replaceWith(i);
                    break;
                case "IMG":
                    e.setAttribute("loading", "eager"), e.setAttribute("fetchpriority", "high");
            }
        }
    };
    const pr = "[data-popout]",
        mr = "[data-popout-list]",
        fr = "data-popout-list-scroll",
        gr = "data-popout-toggle",
        yr = "[data-popout-input]",
        vr = "[data-popout-option]",
        br = "data-popout-prevent",
        wr = "data-quantity-field",
        Sr = "data-value",
        Er = "aria-expanded",
        Lr = "aria-current",
        kr = "popout-list--visible",
        Tr = "--current";
    let xr = class extends HTMLElement {
        unload() {
            this.popoutOptions.length &&
                this.popoutOptions.forEach((e) => {
                    e.removeEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), e.removeEventListener("click", this._connectOptionsDispatch.bind(this));
                }),
                this.popoutToggle.removeEventListener("click", this.popupToggleClick.bind(this)),
                this.popoutToggle.removeEventListener("mouseover", this.popupToggleMouseover.bind(this)),
                this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.popoutList.removeEventListener("focusout", this.popupListFocusout.bind(this)),
                this.container.removeEventListener("keyup", this.containerKeyup.bind(this)),
                this.outsidePopupToggle && (this.outsidePopupToggle.removeEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)));
        }
        popupToggleClick(e) {
            const mq = window.matchMedia('(min-width: 1000px)');
            const url = e.target.dataset.url;
            if (mq.matches && url && url != '/') {
                window.location = url;
            }

            const t = "true" === e.currentTarget.getAttribute(Er);
            e.currentTarget.setAttribute(Er, !t),
                this.popoutList.classList.toggle(kr),
                this.popupListMaxWidth(),
                this.popoutList.hasAttribute(fr) &&
                setTimeout(() => {
                    this.popoutList.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                }, 1);
        }
        popupToggleMouseover(e) {
            if (e.currentTarget.getAttribute(Er) === 'true') {
                return;
            }
            
            const t = "true" === e.currentTarget.getAttribute(Er);
            e.currentTarget.setAttribute(Er, !t),
                this.popoutList.classList.toggle(kr),
                this.popupListMaxWidth(),
                this.popoutList.hasAttribute(fr) &&
                setTimeout(() => {
                    this.popoutList.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                }, 1);
        }
        popupToggleFocusout(e) {
            this.container.contains(e.relatedTarget) || this._hideList();
        }
        popupListFocusout(e) {
            const t = e.currentTarget.contains(e.relatedTarget);
            this.popoutList.classList.contains(kr) && !t && this._hideList();
        }
        popupListMouseout(e) {
            const t = e.currentTarget.contains(e.relatedTarget);
            this.popoutList.classList.contains(kr) && !t && this._hideList();
        }
        popupListMaxWidth() {
            this.popoutList.style.maxWidth = `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`;
        }
        popupOptionsClick(e) {
            if ("#" === e.target.closest(vr).attributes.href.value) {
                e.preventDefault();
                let t = "";
                if ((e.currentTarget.getAttribute(Sr) && (t = e.currentTarget.getAttribute(Sr)), (this.popoutInput.value = t), this.popoutPrevent)) {
                    this.popoutInput.dispatchEvent(new Event("change")), !e.detail.preventTrigger && this.popoutInput.hasAttribute(wr) && this.popoutInput.dispatchEvent(new Event("input"));
                    const i = this.popoutList.querySelector(`[class*="${Tr}"]`);
                    let s = Tr;
                    if (i && i.classList.length)
                        for (const e of i.classList)
                            if (e.includes(Tr)) {
                                s = e;
                                break;
                            }
                    const r = this.popoutList.querySelector(`.${s}`);
                    r && (r.classList.remove(`${s}`), e.currentTarget.parentElement.classList.add(`${s}`));
                    const n = this.popoutList.querySelector(`[${Lr}]`);
                    n && n.hasAttribute(`${Lr}`) && (n.removeAttribute(`${Lr}`), e.currentTarget.setAttribute(`${Lr}`, "true")),
                        "" !== t && ((this.popoutToggle.textContent = t), this.outsidePopupToggle && (this.outsidePopupToggle.textContent = t)),
                        this.popupToggleFocusout(e),
                        this.popupListFocusout(e);
                } else this._submitForm(t);
            }
        }
        updatePopout(e) {
            const t = this.popoutList.querySelector(`[${Sr}="${this.popoutInput.value}"]`);
            t && t.dispatchEvent(new CustomEvent("theme:popout:click", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !0 } }));
        }
        containerKeyup(e) {
            "Escape" === e.code && (this._hideList(), this.popoutToggle.focus());
        }
        bodyClick(e) {
            const t = this.container.contains(e.target),
                i = this.popoutList.classList.contains(kr);
            this.outsidePopupToggle, e.target, i && !t && this._hideList();
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("mouseover", this.popupToggleMouseover.bind(this));
            this.popoutToggle.addEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("click", this.popupToggleClick.bind(this));
        }
        _connectOptions() {
            this.popoutOptions.length &&
                this.popoutOptions.forEach((e) => {
                    e.addEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), e.addEventListener("click", this._connectOptionsDispatch.bind(this));
                });
        }
        _connectOptionsDispatch(e) {
            const t = new CustomEvent("theme:popout:click", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !1 } });
            e.target.dispatchEvent(t) || e.preventDefault();
        }
        _onMouseOut() {
            this.popoutList.addEventListener("mouseout", this.popupListMouseout.bind(this));
        }
        _onFocusOut() {
            this.popoutToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.popoutList.addEventListener("focusout", this.popupListFocusout.bind(this)),
                this.container.addEventListener("keyup", this.containerKeyup.bind(this)),
                document.body.addEventListener("click", this.bodyClick.bind(this));
        }
        _submitForm(e) {
            const t = this.container.closest("form");
            t && t.submit();
        }
        _hideList() {
            this.popoutList.classList.remove(kr), this.popoutToggle.setAttribute(Er, !1), this.outsidePopupToggle && this.outsidePopupToggle.setAttribute(Er, !1);
        }
        constructor() {
            super(),
                (this.container = this.querySelector(pr)),
                (this.popoutList = this.container.querySelector(mr)),
                (this.popoutToggle = this.container.querySelector(`[${gr}]`)),
                (this.outsidePopupToggle = document.querySelector(`[${gr}="${this.popoutList.id}"]`)),
                (this.popoutInput = this.container.querySelector(yr)),
                (this.popoutOptions = this.container.querySelectorAll(vr)),
                (this.popoutPrevent = "true" === this.container.getAttribute(br)),
                this._connectOptions(),
                this._connectToggle(),
                this._onFocusOut(),
                this._onMouseOut(),
                this.popupListMaxWidth(),
                this.popoutInput && this.popoutInput.hasAttribute(wr) && document.addEventListener("theme:popout:update", this.updatePopout.bind(this)),
                document.addEventListener("theme:resize", () => {
                    this.popupListMaxWidth();
                });
        }
    };
    const _r = (e, t = 0, i = !0) => {
        let s = window.getComputedStyle(e).display;
        if (i && "none" !== s) return;
        e.style.removeProperty("display"), "none" === s && (s = "block"), (e.style.display = s);
        let r = e.offsetHeight;
        (e.style.overflow = "hidden"),
            (e.style.height = 0),
            (e.style.paddingTop = 0),
            (e.style.paddingBottom = 0),
            (e.style.marginTop = 0),
            (e.style.marginBottom = 0),
            e.offsetHeight,
            (e.style.boxSizing = "border-box"),
            (e.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)"),
            (e.style.transitionProperty = "height, margin, padding"),
            (e.style.transitionDuration = t + "ms"),
            (e.style.height = r + "px"),
            e.style.removeProperty("padding-top"),
            e.style.removeProperty("padding-bottom"),
            e.style.removeProperty("margin-top"),
            e.style.removeProperty("margin-bottom"),
            window.setTimeout(() => {
                e.style.removeProperty("height"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transition-property"), e.style.removeProperty("transition-timing-function");
            }, t);
    },
        Ar = (e, t = 0) => {
            (e.style.transitionProperty = "height, margin, padding"),
                (e.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)"),
                (e.style.transitionDuration = t + "ms"),
                (e.style.boxSizing = "border-box"),
                (e.style.height = e.offsetHeight + "px"),
                e.offsetHeight,
                (e.style.overflow = "hidden"),
                (e.style.height = 0),
                (e.style.paddingTop = 0),
                (e.style.paddingBottom = 0),
                (e.style.marginTop = 0),
                (e.style.marginBottom = 0),
                window.setTimeout(() => {
                    (e.style.display = "none"),
                        e.style.removeProperty("height"),
                        e.style.removeProperty("padding-top"),
                        e.style.removeProperty("padding-bottom"),
                        e.style.removeProperty("margin-top"),
                        e.style.removeProperty("margin-bottom"),
                        e.style.removeProperty("overflow"),
                        e.style.removeProperty("transition-duration"),
                        e.style.removeProperty("transition-property"),
                        e.style.removeProperty("transition-timing-function");
                }, t);
        },
        qr = "[data-accordion-group]",
        Cr = "data-accordion-trigger",
        Pr = "[data-accordion-body]",
        $r = "data-accordion-body-mobile",
        Mr = "data-range-holder",
        Ir = "[data-section-id]",
        Dr = "accordion-is-open";
    let Or = {},
        Hr = class {
            mobileAccordions() {
                window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style")),
                    document.addEventListener("theme:resize", () => {
                        window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style"));
                    });
            }
            init() {
                this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.setDefaultState(),
                    this.trigger.addEventListener("click", this.toggleEvent),
                    this.body.addEventListener("keyup", this.keyboardEvent),
                    this.body.addEventListener("theme:accordion:close", this.hideEvent);
            }
            hideEvents() {
                this.hideAccordion();
            }
            clickEvents(e) {
                e.preventDefault(), this.toggleState();
            }
            keyboardEvents(e) {
                "Escape" === e.code && (this.hideAccordion(), this.trigger.focus());
            }
            resetMobileAccordions() {
                this.trigger.removeEventListener("click", this.toggleEvent), this.body.removeEventListener("keyup", this.keyboardEvent), this.body.removeEventListener("theme:accordion:close", this.hideEvent);
            }
            setDefaultState() {
                this.trigger.classList.contains(Dr) ? W(this.body) : this.hideAccordion();
            }
            getSiblings() {
                const e = [...this.body.closest(Ir).querySelectorAll(qr)].filter((e) => e.contains(this.body)).shift();
                if (e) {
                    return [...e.querySelectorAll(Pr)].filter((e) => !e.contains(this.body));
                }
                return [];
            }
            closeSiblings() {
                this.syncBodies.forEach((e) => {
                    e.dispatchEvent(new CustomEvent("theme:accordion:close", { bubbles: !1 }));
                });
            }
            toggleState() {
                this.trigger.classList.contains(Dr)
                    ? this.hideAccordion()
                    : (this.showAccordion(),
                        this.closeSiblings(),
                        this.body.hasAttribute(Mr) &&
                        setTimeout(() => {
                            document.dispatchEvent(new CustomEvent("theme:price-range:reset", { bubbles: !1 }));
                        }, 400));
            }
            hideAccordion() {
                this.trigger.classList.remove(Dr), Ar(this.body);
            }
            showAccordion() {
                this.trigger.classList.add(Dr),
                    _r(this.body),
                    setTimeout(() => {
                        this.checkInViewportAndScrollTo();
                    }, 600);
            }
            checkInViewportAndScrollTo() {
                const e = this.trigger.getBoundingClientRect(),
                    t = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
                (e.top >= 0 && e.left >= 0 && e.bottom <= (window.innerHeight || document.documentElement.clientHeight) && e.right <= (window.innerWidth || document.documentElement.clientWidth)) ||
                    window.scrollTo({ top: t + e.top, left: 0, behavior: "smooth" });
            }
            onBlockSelect(e) {
                this.body.contains(e.target) && this.showAccordion();
            }
            onBlockDeselect(e) {
                this.body.contains(e.target) && this.hideAccordion();
            }
            constructor(e) {
                (this.body = e), (this.key = this.body.id);
                const t = `[${Cr}='${this.key}']`;
                (this.trigger = document.querySelector(t)),
                    (this.toggleEvent = (e) => this.clickEvents(e)),
                    (this.keyboardEvent = (e) => this.keyboardEvents(e)),
                    (this.hideEvent = () => this.hideEvents()),
                    (this.syncBodies = this.getSiblings()),
                    this.body.hasAttribute($r) ? this.mobileAccordions() : this.init();
            }
        };
    const Fr = {
        onLoad() {
            Or[this.id] = [];
            this.container.querySelectorAll(Pr).forEach((e) => {
                Or[this.id].push(new Hr(e));
            });
        },
        onUnload: function () {
            Or[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            });
        },
        onSelect: function () {
            "accordion-single" === this.type && this.container.querySelector(`[${Cr}]`).click();
        },
        onDeselect: function () {
            "accordion-single" === this.type && this.container.querySelector(`[${Cr}]`).click();
        },
        onBlockSelect(e) {
            Or[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
            });
        },
        onBlockDeselect(e) {
            Or[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockDeselect(e);
            });
        },
    },
        Br = (e) => {
            e && (e.style.display = "none");
        },
        Wr = 'input[type="search"]',
        Nr = '[aria-selected="true"] a',
        Rr = 'button[type="reset"]',
        jr = "is-hidden";
    let zr = class extends HTMLElement {
        toggleResetButton() {
            const e = this.resetButton.classList.contains(jr);
            this.input.value.length > 0 && e ? this.resetButton.classList.remove(jr) : 0 !== this.input.value.length || e || this.resetButton.classList.add(jr);
        }
        onChange() {
            this.toggleResetButton();
        }
        shouldResetForm() {
            return !document.querySelector(Nr);
        }
        onFormReset(e) {
            e.preventDefault(), this.shouldResetForm() && ((this.input.value = ""), this.toggleResetButton(), e.target.querySelector(Wr).focus());
        }
        constructor() {
            super(),
                (this.input = this.querySelector(Wr)),
                (this.resetButton = this.querySelector(Rr)),
                this.input &&
                (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
                    this.input.addEventListener(
                        "input",
                        T((e) => {
                            this.onChange(e);
                        }, 300).bind(this)
                    ));
        }
    };
    customElements.define("header-search-form", zr);
    const Vr = '[role="option"]',
        Ur = '[aria-selected="true"]',
        Gr = "predictive-search",
        Jr = "[data-predictive-search-results]",
        Qr = "[data-predictive-search-status]",
        Kr = "[data-predictive-search-input]",
        Yr = "[data-predictive-search-live-region-count-value]",
        Xr = "data-search-results-groups-wrapper",
        Zr = "[data-predictive-search-search-for-text]",
        en = "#shopify-section-predictive-search",
        tn = '[aria-selected="true"] a',
        sn = '[aria-selected="true"] a, button[aria-selected="true"]',
        rn = "[data-loading-indicator]";
    let nn = class extends zr {
        connectedCallback() {
            this.isBlogSearch = this.hasAttribute("data-blog");
            this.input.addEventListener("focus", this.onFocus.bind(this)),
                this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                this.addEventListener("focusout", this.onFocusOut.bind(this)),
                this.addEventListener("keyup", this.onKeyup.bind(this)),
                this.addEventListener("keydown", this.onKeydown.bind(this));
        }
        getQuery() {
            return this.input.value.trim();
        }
        onChange() {
            super.onChange();
            const e = this.getQuery();
            var t;
            (this.searchTerm && e.startsWith(this.searchTerm)) || null === (t = this.querySelector(Xr)) || void 0 === t || t.remove();
            this.updateSearchForTerm(this.searchTerm, e), (this.searchTerm = e), this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset();
        }
        onFormSubmit(e) {
            (this.getQuery().length && !this.querySelector(tn)) || e.preventDefault();
        }
        onFormReset(e) {
            super.onFormReset(e), super.shouldResetForm() && ((this.searchTerm = ""), this.abortController.abort(), (this.abortController = new AbortController()), this.closeResults(!0));
        }
        shouldResetForm() {
            return !document.querySelector(tn);
        }
        onFocus() {
            const e = this.getQuery();
            e.length && (this.searchTerm !== e ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm));
        }
        onFocusOut() {
            setTimeout(() => {
                this.contains(document.activeElement) || this.close();
            });
        }
        onKeyup(e) {
            switch ((this.getQuery().length || this.close(!0), e.preventDefault(), e.code)) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption();
            }
        }
        onKeydown(e) {
            ("ArrowUp" !== e.code && "ArrowDown" !== e.code) || e.preventDefault();
        }
        updateSearchForTerm(e, t) {
            const i = this.querySelector(Zr),
                s = null == i ? void 0 : i.innerText;
            if (s) {
                var r;
                if ((null === (r = s.match(e)) || void 0 === r ? void 0 : r.length) > 1) return;
                const n = s.replace(e, t);
                i.innerText = n;
            }
        }
        switchOption(e) {
            if (!this.getAttribute("open")) return;
            const t = "up" === e,
                i = this.querySelector(Ur),
                s = Array.from(this.querySelectorAll(Vr)).filter((e) => null !== e.offsetParent);
            let r = 0;
            if (t && !i) return;
            let n = -1,
                o = 0;
            for (; -1 === n && o <= s.length;) s[o] === i && (n = o), o++;
            if (((this.statusElement.textContent = ""), !t && i ? (r = n === s.length - 1 ? 0 : n + 1) : t && (r = 0 === n ? s.length - 1 : n - 1), r === n)) return;
            const a = s[r];
            a.setAttribute("aria-selected", !0), i && i.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", a.id);
        }
        selectOption() {
            const e = this.querySelector(sn);
            e && e.click();
        }
        getSearchResults(e) {
            const t = e.replace(" ", "-").toLowerCase();
            const url = `${theme.routes.predictive_search_url}?q=${encodeURIComponent(e)}&section_id=${this.isBlogSearch ? 'blog-search&resources[type]=article&resources[limit]=6' : 'predictive-search'}`
            this.setLiveRegionLoadingState(),
                this.cachedResults[t]
                    ? this.renderSearchResults(this.cachedResults[t])
                    : (W(this.loader),
                        fetch(url, { signal: this.abortController.signal })
                            .then(this.handleErrors)
                            .then((e) => e.text())
                            .then((e) => {
                                const i = new DOMParser().parseFromString(e, "text/html").querySelector(this.isBlogSearch ? '#shopify-section-blog-search' : en).innerHTML;
                                this.allPredictiveSearchInstances.forEach((e) => {
                                    e.cachedResults[t] = i;
                                }),
                                    this.renderSearchResults(i);
                            })
                            .catch((e) => {
                                console.error(e);
                            })
                            .finally(() => {
                                Br(this.loader);
                            }));
        }
        setLiveRegionLoadingState() {
            (this.statusElement = this.statusElement || this.querySelector(Qr)), (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0);
        }
        setLiveRegionText(e) {
            this.statusElement.setAttribute("aria-hidden", "false"),
                (this.statusElement.textContent = e),
                setTimeout(() => {
                    this.statusElement.setAttribute("aria-hidden", "true");
                }, 1e3);
        }
        renderSearchResults(e) {
            (this.predictiveSearchResults.innerHTML = e), this.setAttribute("results", !0), this.setLiveRegionResults(), this.open();
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(Yr).textContent);
        }
        open() {
            this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), (this.isOpen = !0);
        }
        close(e = !1) {
            this.closeResults(e), (this.isOpen = !1);
        }
        closeResults(e = !1) {
            var t;
            e && ((this.input.value = ""), this.removeAttribute("results"));
            const i = this.querySelector(Ur);
            i && i.setAttribute("aria-selected", !1),
                this.input.setAttribute("aria-activedescendant", ""),
                this.removeAttribute("loading"),
                this.removeAttribute("open"),
                this.input.setAttribute("aria-expanded", !1),
                null === (t = this.predictiveSearchResults) || void 0 === t || t.removeAttribute("style");
        }
        reset() {
            (this.predictiveSearchResults.innerHTML = ""), (this.input.val = ""), this.a11y.removeTrapFocus();
        }
        handleErrors(e) {
            return e.ok
                ? e
                : e.json().then(function (t) {
                    throw new N({ status: e.statusText, headers: e.headers, json: t });
                });
        }
        constructor() {
            super(),
                (this.wrapper = this),
                (this.a11y = oi),
                (this.abortController = new AbortController()),
                (this.allPredictiveSearchInstances = document.querySelectorAll(Gr)),
                (this.cachedResults = {}),
                (this.input = this.wrapper.querySelector(Kr)),
                (this.isOpen = !1),
                (this.predictiveSearchResults = this.querySelector(Jr)),
                (this.searchTerm = ""),
                (this.loader = this.wrapper.querySelector(rn));
        }
    };
    function on() {
        return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= window.theme.sizes.small;
    }
    const an = 'input[type="search"]';
    let ln = class extends zr {
        setupEventListeners() {
            let e = [];
            this.allSearchInputs.forEach((t) => e.push(t.form)),
                this.input.addEventListener("focus", this.onInputFocus.bind(this)),
                e.length < 2 || (e.forEach((e) => e.addEventListener("reset", this.onFormReset.bind(this))), this.allSearchInputs.forEach((e) => e.addEventListener("input", this.onInput.bind(this))));
        }
        onFormReset(e) {
            super.onFormReset(e), super.shouldResetForm() && this.keepInSync("", this.input);
        }
        onInput(e) {
            const t = e.target;
            this.keepInSync(t.value, t);
        }
        onInputFocus() {
            on() || this.scrollIntoView({ behavior: "smooth" });
        }
        keepInSync(e, t) {
            this.allSearchInputs.forEach((i) => {
                i !== t && (i.value = e);
            });
        }
        constructor() {
            super(), (this.allSearchInputs = document.querySelectorAll(an)), this.setupEventListeners();
        }
    };
    const cn = {
        drawer: "data-drawer-scrolls",
        slideruleOpen: "data-sliderule-open",
        slideruleClose: "data-sliderule-close",
        sliderulePane: "data-sliderule-pane",
        slideruleWrappper: "[data-sliderule]",
        dataAnimates: "data-animates",
        children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope .sliderule-grid  > *",
    },
        hn = "is-visible",
        dn = "is-hiding",
        un = "is-hidden";
    let pn = {};
    const mn = {
        onLoad() {
            pn[this.id] = [];
            this.container.querySelectorAll(cn.slideruleWrappper).forEach((e) => {
                pn[this.id].push(
                    new (class {
                        clickEvents() {
                            this.trigger.addEventListener(
                                "click",
                                function () {
                                    this.showSliderule();
                                }.bind(this)
                            ),
                                this.exit.forEach((e) => {
                                    e.addEventListener(
                                        "click",
                                        function () {
                                            this.hideSliderule();
                                        }.bind(this)
                                    );
                                });
                        }
                        keyboardEvents() {
                            this.trigger.addEventListener(
                                "keyup",
                                function (e) {
                                    "Space" === e.code && this.showSliderule();
                                }.bind(this)
                            ),
                                this.sliderule.addEventListener(
                                    "keyup",
                                    function (e) {
                                        "Escape" === e.code && (this.hideSliderule(), this.buttons[0].focus());
                                    }.bind(this)
                                );
                        }
                        staggerChildAnimations(e = !1) {
                            (e ? Array.prototype.slice.call(this.children).slice().reverse() : this.children).forEach((e, t) => {
                                e.style.transitionDelay = 50 * t + 10 + "ms";
                            });
                        }
                        hideSliderule(e = !1) {
                            const t = window.getComputedStyle(this.pane),
                                i = 1e3 * parseFloat(t.getPropertyValue("transition-duration")),
                                s = e ? this.pane.querySelectorAll(`.${hn}`) : this.children;
                            this.pane.style.setProperty("--sliderule-height", "auto"),
                                this.staggerChildAnimations(!0),
                                this.pane.classList.add(dn),
                                this.sliderule.classList.add(dn),
                                this.sliderule.classList.remove(hn),
                                s.forEach((e) => {
                                    e.classList.remove(hn);
                                });
                            const r = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                            this.pane.setAttribute(cn.sliderulePane, r);
                            const n = e ? `[${cn.dataAnimates}].${un}` : `[${cn.dataAnimates}="${r}"].${un}`,
                                o = this.pane.querySelectorAll(n);
                            o.length &&
                                o.forEach((e) => {
                                    e.classList.remove(un);
                                }),
                                setTimeout(() => {
                                    this.pane.classList.remove(dn), this.sliderule.classList.remove(dn), this.staggerChildAnimations();
                                }, i);
                        }
                        showSliderule() {
                            this.pane.style.setProperty("--sliderule-height", "auto"),
                                this.sliderule.classList.add(hn),
                                this.children.forEach((e) => {
                                    e.classList.add(hn);
                                });
                            const e = parseInt(this.pane.dataset.sliderulePane, 10),
                                t = e + 1;
                            this.pane.setAttribute(cn.sliderulePane, t);
                            const i = this.pane.querySelectorAll(`[${cn.dataAnimates}="${e}"]`);
                            if (i.length) {
                                const e = 1e3 * parseFloat(window.getComputedStyle(i[0]).getPropertyValue("transition-duration"));
                                setTimeout(() => {
                                    i.forEach((e) => {
                                        e.classList.add(un);
                                    });
                                }, e);
                            }
                            const s = parseInt(this.trigger.nextElementSibling.offsetHeight);
                            this.pane.style.setProperty("--sliderule-height", `${s}px`);
                            const r = this.drawer.scrollTop,
                                n = this.pane.offsetTop;
                            n < r && this.pane.offsetHeight >= this.drawer.offsetHeight && this.drawer.scrollTo({ top: n, left: 0, behavior: "smooth" });
                        }
                        closeSliderule() {
                            this.pane &&
                                this.pane.hasAttribute(cn.sliderulePane) &&
                                parseInt(this.pane.getAttribute(cn.sliderulePane)) > 0 &&
                                (this.hideSliderule(!0), parseInt(this.pane.getAttribute(cn.sliderulePane)) > 0 && this.pane.setAttribute(cn.sliderulePane, 0));
                        }
                        constructor(e) {
                            (this.sliderule = e), (this.wrapper = e.closest(cn.wrapper)), (this.key = this.sliderule.id);
                            const t = `[${cn.slideruleOpen}='${this.key}']`,
                                i = `[${cn.slideruleClose}='${this.key}']`;
                            (this.trigger = document.querySelector(t)),
                                (this.drawer = document.querySelector(`[${cn.drawer}]`)),
                                (this.exit = document.querySelectorAll(i)),
                                (this.pane = document.querySelector(`[${cn.sliderulePane}]`)),
                                (this.children = this.sliderule.querySelectorAll(cn.children)),
                                this.trigger.setAttribute("aria-haspopup", !0),
                                this.trigger.setAttribute("aria-expanded", !1),
                                this.trigger.setAttribute("aria-controls", this.key),
                                this.clickEvents(),
                                this.staggerChildAnimations(),
                                document.addEventListener("theme:sliderule:close", this.closeSliderule.bind(this));
                        }
                    })(e)
                );
            });
        },
    },
        fn = "[data-takes-space]",
        gn = "[data-header-desktop]",
        yn = "js__header__clone",
        vn = "js__show__mobile",
        bn = "[data-header-backfill]",
        wn = "data-header-transparent",
        Sn = "header-override-border",
        En = ".main-content > .shopify-section:first-child [data-overlay-header]",
        Ln = ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
        kn = '.navlink[href="#"]',
        Tn = "has-overlay";
    let xn = {};
    Gt("header", [
        {
            onLoad() {
                xn = new (class {
                    unload() {
                        document.removeEventListener("theme:resize", this.checkWidth);
                    }
                    checkForImage() {
                        this.overlayedImages = document.querySelectorAll(En);
                        let e = document.querySelectorAll(Ln).length;
                        this.overlayedImages.length && !e && this.transparent ? ((document.querySelector(bn).style.display = "none"), this.listenOverlay()) : this.wrapper.setAttribute(wn, !1),
                            !this.overlayedImages.length || e || this.transparent || (this.wrapper.classList.add(Sn), this.subtractHeaderHeight());
                    }
                    listenOverlay() {
                        document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.subtractAnnouncementHeight();
                    }
                    listenWidth() {
                        document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.checkWidth();
                    }
                    killDeadLinks() {
                        this.deadLinks.forEach((e) => {
                            e.onclick = (e) => {
                                e.preventDefault();
                            };
                        });
                    }
                    subtractAnnouncementHeight() {
                        const { windowHeight: e, announcementHeight: t } = y();
                        this.overlayedImages.forEach((i) => {
                            i.style.setProperty("--full-screen", e - t + "px"), i.classList.add(Tn);
                        });
                    }
                    subtractHeaderHeight() {
                        const { windowHeight: e, headerHeight: t } = y();
                        this.overlayedImages.forEach((i) => {
                            i.style.setProperty("--full-screen", e - t + "px");
                        });
                    }
                    checkWidth() {
                        document.body.clientWidth < this.minWidth ? this.wrapper.classList.add(vn) : this.wrapper.classList.remove(vn);
                    }
                    getMinWidth() {
                        const e = this.wrapper.cloneNode(!0);
                        e.classList.add(yn), document.body.appendChild(e);
                        const t = e.querySelectorAll(fn);
                        let i = 0;
                        return (
                            (i =
                                3 === t.length
                                    ? (function (e) {
                                        let t = [];
                                        return (
                                            e.forEach((e) => {
                                                t.push(e.clientWidth);
                                            }),
                                            t[0] > t[2] ? (t[2] = t[0]) : (t[0] = t[2]),
                                            t.reduce((e, t) => e + t)
                                        );
                                    })(t)
                                    : (function (e) {
                                        let t = 0;
                                        return (
                                            e.forEach((e) => {
                                                t += e.clientWidth;
                                            }),
                                            t
                                        );
                                    })(t)),
                            document.body.removeChild(e),
                            i + 20 * t.length
                        );
                    }
                    constructor(e) {
                        (this.wrapper = e),
                            (this.style = this.wrapper.dataset.style),
                            (this.desktop = this.wrapper.querySelector(gn)),
                            (this.transparent = "false" !== this.wrapper.getAttribute(wn)),
                            (this.overlayedImages = document.querySelectorAll(En)),
                            (this.deadLinks = document.querySelectorAll(kn)),
                            this.killDeadLinks(),
                            "drawer" !== this.style && this.desktop && ((this.minWidth = this.getMinWidth()), this.listenWidth()),
                            this.checkForImage(),
                            window.dispatchEvent(new Event("resize")),
                            document.addEventListener("theme:header:check", this.checkForImage.bind(this));
                    }
                })(this.container);
            },
            onUnload: function () {
                "function" == typeof xn.unload && xn.unload();
            },
        },
        zi,
        mn,
        Zi,
        ps,
        Ls,
        _s,
        Os,
        Us,
        Je,
        Fr,
        xi,
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", xr),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Ue),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Js),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", cr),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", ur),
        customElements.get("predictive-search") || customElements.define("predictive-search", nn),
        customElements.get("main-search") || customElements.define("main-search", ln);
    const _n = "[data-newsletter-form]",
        An = "has-success",
        qn = "has-error",
        Cn = {};
    const Pn = {
        onLoad() {
            Cn[this.id] = [];
            this.container.querySelectorAll(_n).forEach((e) => {
                Cn[this.id].push(
                    new (class {
                        init() {
                            this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
                        }
                        newsletterSubmitEvent(e) {
                            this.stopSubmit && (e.preventDefault(), e.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), (this.stopSubmit = !1), this.newsletter.submit());
                        }
                        checkForChallengePage() {
                            this.isChallengePage = "/challenge" === window.location.pathname;
                        }
                        writeStorage() {
                            void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
                        }
                        readStorage() {
                            this.formID = this.sessionStorage.getItem("newsletter_form_id");
                        }
                        removeStorage() {
                            this.sessionStorage.removeItem("newsletter_form_id");
                        }
                        showMessage() {
                            if ((this.readStorage(), this.newsletter.id === this.formID)) {
                                const e = document.getElementById(this.formID);
                                -1 !== window.location.search.indexOf("?customer_posted=true")
                                    ? (e.classList.remove(qn), e.classList.add(An))
                                    : -1 !== window.location.search.indexOf("accepts_marketing") && (e.classList.remove(An), e.classList.add(qn)),
                                    this.removeStorage(),
                                    this.scrollToForm(e);
                            }
                        }
                        scrollToForm(e) {
                            const t = e.getBoundingClientRect();
                            (t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth)) ||
                                setTimeout(() => {
                                    window.scroll({ top: t.top, left: 0, behavior: "smooth" });
                                }, 400);
                        }
                        unload() {
                            this.newsletter.removeEventListener("submit", this.newsletterSubmit);
                        }
                        constructor(e) {
                            (this.sessionStorage = window.sessionStorage),
                                (this.newsletter = e),
                                (this.stopSubmit = !0),
                                (this.isChallengePage = !1),
                                (this.formID = null),
                                this.checkForChallengePage(),
                                (this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e)),
                                this.isChallengePage || this.init();
                        }
                    })(e)
                );
            });
        },
        onUnload() {
            Cn[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            });
        },
    },
        $n = "[data-shop-pay-wrapper]",
        Mn = "shop-login-button",
        In = "shop-follow-button",
        Dn = "follow-on-shop-button",
        On = "heart-icon",
        Hn = "shop-logo",
        Fn = {};
    const Bn = {
        onLoad() {
            Fn[this.id] = new (class {
                init() {
                    this.shopLoginButton &&
                        this.shopPayWrapper &&
                        ((this.mainButtonStyles = `\n      :host {\n        --bg-color: ${this.shopPayWrapper.dataset.bg};\n        --text-color: ${this.shopPayWrapper.dataset.text};\n        --hover-color: ${this.shopPayWrapper.dataset.hover};\n      }\n\n      .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--text-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n\n      .button {\n        background: transparent;\n        color: var(--text-color);\n      }\n\n      .following-text {\n        color: var(--text-color);\n      }\n\n      .button--following:focus-visible,\n      .button--following:hover {\n        background: var(--bg-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n    `),
                            (this.svgIconsStyles = `\n      :host {\n        color: ${this.shopPayWrapper.dataset.text};\n      }\n    `),
                            customElements.whenDefined(Mn).then((e) => {
                                requestAnimationFrame(() => {
                                    const e = this.shopLoginButton.shadowRoot,
                                        t = null == e ? void 0 : e.querySelector(In),
                                        i = null == t ? void 0 : t.shadowRoot,
                                        s = null == i ? void 0 : i.querySelector(Dn),
                                        r = null == s ? void 0 : s.shadowRoot;
                                    r && this.overwriteStyles(r.host.shadowRoot, this.mainButtonStyles);
                                    const n = r.querySelector(On),
                                        o = null == n ? void 0 : n.shadowRoot,
                                        a = r.querySelector(Hn),
                                        l = null == a ? void 0 : a.shadowRoot;
                                    o && this.overwriteStyles(o.host.shadowRoot, this.svgIconsStyles), l && this.overwriteStyles(l.host.shadowRoot, this.svgIconsStyles);
                                });
                            }));
                }
                overwriteStyles(e, t) {
                    let i = document.createElement("style");
                    (i.innerHTML = t), e.appendChild(i);
                }
                constructor(e) {
                    (this.container = e), (this.shopPayWrapper = document.querySelector($n)), (this.shopLoginButton = document.querySelector(Mn)), this.init();
                }
            })(this.container);
        },
    };
    Gt("footer", [Fr, Pn, Bn]), customElements.get("popout-select") || customElements.define("popout-select", xr);
    const Wn = { cc_load_policy: 1, iv_load_policy: 3, modestbranding: 1, playsinline: 1, controls: 1, showinfo: 0, ecver: 2, fs: 1, rel: 0 },
        Nn = "iframe, [data-replace]",
        Rn = "data-video-id";
    function jn(e, t) {
        const i = { ...Wn, ...t },
            s = document.querySelector(`[data-player="${e}"]`),
            r = s.querySelector(Nn),
            n = s.querySelector(`[${Rn}]`).getAttribute(Rn);
        xe({ url: "https://www.youtube.com/iframe_api" });
        return window.youtubeLoaderPromise
            .then(() => {
                let e = new window.YT.Player(r, {
                    videoId: n,
                    playerVars: { ...i },
                    events: {
                        onStateChange: (e) => {
                            1 == e.data ? s.dispatchEvent(new CustomEvent("play")) : 2 == e.data && s.dispatchEvent(new CustomEvent("pause"));
                        },
                    },
                });
                return (
                    s.addEventListener("pause", () => {
                        try {
                            e.pauseVideo();
                        } catch (e) {
                            console.warn(e);
                        }
                    }),
                    s.addEventListener("play", () => {
                        try {
                            e.playVideo
                                ? e.playVideo()
                                : e.addEventListener("onReady", () => {
                                    e.playVideo();
                                });
                        } catch (e) {
                            console.warn(e);
                        }
                    }),
                    s.addEventListener("destroy", () => {
                        try {
                            e.destroy && e.destroy();
                        } catch (e) {
                            console.warn(e);
                        }
                    }),
                    e
                );
            })
            .catch((e) => {
                console.error(e);
            });
    }
    window.youtubeLoaderPromise = new Promise((e) => {
        window.onYouTubeIframeAPIReady = function () {
            e();
        };
    });
    const zn = { autoplay: !0, loop: !0, controls: !0, muted: !1, playsinline: !0 },
        Vn = "iframe, [data-replace]",
        Un = "data-video-id";
    function Gn(e, t) {
        const i = { ...zn, ...t },
            s = document.querySelector(`[data-player="${e}"]`),
            r = s.querySelector(Vn),
            n = s.querySelector(`[${Un}]`).getAttribute(Un),
            o = xe({ url: "https://player.vimeo.com/api/player.js" }),
            a = `select-${e}`;
        r.setAttribute("id", a);
        return o
            .then(() => {
                const e = new window.Vimeo.Player(a, { ...i, id: n });
                return (
                    e.on("play", () => {
                        s.dispatchEvent(new CustomEvent("play"));
                    }),
                    e.on("pause", () => {
                        s.dispatchEvent(new CustomEvent("pause"));
                    }),
                    s.addEventListener("pause", () => {
                        try {
                            e.pause && e.pause();
                        } catch (e) {
                            console.warn(e);
                        }
                    }),
                    s.addEventListener("play", () => {
                        e.play &&
                            e.getPaused().then((t) => {
                                t && e.play();
                            });
                    }),
                    s.addEventListener("destroy", () => {
                        try {
                            e.destroy && e.destroy();
                        } catch (e) {
                            console.error(e);
                        }
                    }),
                    e
                );
            })
            .catch((e) => {
                console.error(e);
            });
    }
    const Jn = "[data-video-popup]",
        Qn = "[data-video-autoplay]",
        Kn = "data-unique",
        Yn = "data-video-id",
        Xn = "data-video-type",
        Zn = "data-player";
    const eo = {
        onLoad() {
            new (class {
                init() {
                    this.triggers.forEach((e) => {
                        const t = e.getAttribute(Kn),
                            i = e.getAttribute(Yn),
                            s = e.getAttribute(Xn),
                            r = `${i}-${t}`,
                            o = document.querySelector(`[${Zn}="${r}"]`);
                        n.init({
                            onShow: () => {
                                this.backgroundVideo && "function" == typeof this.backgroundVideo.pause && this.backgroundVideo.pause();
                                let e = {};
                                "youtube" === s ? (e = jn(r)) : "vimeo" === s && (e = Gn(r)),
                                    e.then(() => {
                                        o.dispatchEvent(new CustomEvent("play"));
                                    });
                            },
                            onClose: (e, t, i) => {
                                i.preventDefault(), o.dispatchEvent(new CustomEvent("destroy")), this.backgroundVideo && "function" == typeof this.backgroundVideo.play && this.backgroundVideo.play();
                            },
                            openTrigger: `data-trigger-${i}-${t}`,
                        });
                    });
                }
                constructor(e) {
                    (this.container = e.container), (this.triggers = this.container.querySelectorAll(Jn)), (this.backgroundVideo = this.container.querySelector(Qn)), this.init();
                }
            })(this);
        },
    },
        to = "[data-scroll-down]";
    const io = {
        onLoad() {
            this.scrollButton = new (class {
                init() {
                    const e = this.wrapper.querySelectorAll(to);
                    e &&
                        e.forEach((e) => {
                            e.addEventListener("click", this.scroll.bind(this));
                        });
                }
                scroll() {
                    const e = this.wrapper.offsetTop + this.wrapper.clientHeight;
                    window.scroll({ top: e, left: 0, behavior: "smooth" });
                }
                constructor(e) {
                    (this.wrapper = e), this.init();
                }
            })(this.container);
        },
        onUnload: function () {
            delete this.scrollButton;
        },
    };
    Gt("video", [fi, io, eo]), Gt("page-faq", Fr), Gt("hero", [fi, io, tt]);
    const so = "[data-slider]",
        ro = "[data-grid-slide]",
        no = "[data-wrapper]",
        oo = "data-custom-scrollbar-items",
        ao = "data-show-dots",
        lo = "wrapper",
        co = "wrapper--full",
        ho = window.innerWidth - document.documentElement.clientWidth,
        uo = 112,
        po = {};
    const mo = {
        onLoad() {
            po[this.id] = [];
            this.container.querySelectorAll(so).forEach((e) => {
                po[this.id].push(
                    new (class {
                        init() {
                            const e = this,
                                t = {
                                    initialIndex: 0,
                                    accessibility: !0,
                                    autoPlay: !1,
                                    contain: !0,
                                    pageDots: this.pageDots,
                                    adaptiveHeight: !1,
                                    wrapAround: !1,
                                    groupCells: !1,
                                    cellAlign: "left",
                                    freeScroll: !0,
                                    prevNextButtons: !0,
                                    draggable: !0,
                                    rightToLeft: window.isRTL,
                                    watchCSS: !0,
                                    arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
                                    on: {
                                        ready: function () {
                                            e.removeIncorrectAria();
                                        },
                                    },
                                };
                            (this.flkty = new s(this.slideshow, t)),
                                this.container.addEventListener("theme:tab:change", () => {
                                    this.flkty.resize();
                                }),
                                this.toggleWrapperModifier(),
                                document.addEventListener("theme:resize:width", this.toggleWrapperModifier.bind(this)),
                                this.slideshow.hasAttribute(oo) && new et(this.container),
                                new Q(this.container);
                        }
                        toggleWrapperModifier() {
                            this.wrapper.classList.contains(lo) && this.wrapper.classList.toggle(co, this.wrapperWidthWithGutter >= window.innerWidth);
                        }
                        removeIncorrectAria() {
                            this.slideshow.querySelectorAll('[aria-hidden="true"]').forEach((e) => e.removeAttribute("aria-hidden"));
                        }
                        onUnload() {
                            this.slideshow && this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
                        }
                        constructor(e, t) {
                            if (
                                ((this.container = e),
                                    (this.slideshow = t),
                                    (this.wrapper = this.container.querySelector(no)),
                                    (this.wrapperWidth = Number(getComputedStyle(document.documentElement).getPropertyValue("--LAYOUT-WIDTH").replace("px", ""))),
                                    (this.wrapperWidthWithGutter = this.wrapperWidth + uo + ho),
                                    (this.pageDots = "true" === this.slideshow.getAttribute(ao)),
                                    (this.firstPhoto = this.container.querySelector(ro)),
                                    this.firstPhoto)
                            ) {
                                const e = this.firstPhoto.offsetHeight / 2;
                                this.slideshow.style.setProperty("--buttons-top", `${e}px`);
                            }
                            this.slideshow && ((this.flkty = null), this.init());
                        }
                    })(this.container, e)
                );
            });
        },
        onUnload(e) {
            po[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload(e);
            });
        },
    };
    Gt("custom-content", [fi, eo, Je, mo]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Ue),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Js),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", cr),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", ur);
    const fo = [],
        go = "[data-slideshow-wrapper]",
        yo = "data-slideshow-speed",
        vo = "data-slideshow-autoplay",
        bo = "data-slideshow-slides",
        wo = "[data-slide-custom-prev]",
        So = "[data-slide-custom-next]",
        Eo = "data-slideshow-index",
        Lo = "flickity-enabled";
    Gt("slideshow", [
        {
            onLoad() {
                fo[this.id] = new (class {
                    init() {
                        const e = {
                            autoPlay: !(!this.autoplay || !this.speed) && parseInt(this.speed),
                            contain: !1,
                            pageDots: !0,
                            adaptiveHeight: !0,
                            accessibility: !0,
                            wrapAround: 2 !== this.slideCount,
                            prevNextButtons: !1,
                            draggable: !0,
                            fade: !0,
                            rightToLeft: window.isRTL,
                        };
                        (this.flkty = new t(this.wrapper, e)),
                            this.prevButtons.length &&
                            this.prevButtons.forEach((e) => {
                                e.onclick = () => {
                                    this.flkty.previous(!0, !1);
                                };
                            }),
                            this.nextButtons.length &&
                            this.nextButtons.forEach((e) => {
                                e.onclick = () => {
                                    this.flkty.next(!0, !1);
                                };
                            }),
                            document.addEventListener("theme:scroll", this.scrollEvent);
                    }
                    scrollEvents() {
                        if (this.flkty && this.autoplay && this.speed) {
                            const e = this.flkty.element,
                                t = e.getBoundingClientRect().top + window.scrollY + e.offsetHeight;
                            window.pageYOffset > t ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer();
                        }
                    }
                    unload() {
                        document.removeEventListener("theme:scroll", this.scrollEvent), this.flkty && this.wrapper && this.wrapper.classList.contains(Lo) && this.flkty.destroy();
                    }
                    onBlockSelect(e) {
                        const t = e.target.closest(`[${Eo}]`).getAttribute(Eo),
                            i = parseInt(t);
                        this.flkty.selectCell(i), this.flkty.stopPlayer();
                    }
                    onBlockDeselect() {
                        this.autoplay && this.flkty.playPlayer();
                    }
                    constructor(e) {
                        (this.container = e.container),
                            (this.wrapper = e.container.querySelector(go)),
                            (this.speed = this.wrapper.getAttribute(yo)),
                            (this.autoplay = "true" === this.wrapper.getAttribute(vo)),
                            (this.slideCount = parseInt(this.wrapper.getAttribute(bo), 10)),
                            (this.prevButtons = this.wrapper.querySelectorAll(wo)),
                            (this.nextButtons = this.wrapper.querySelectorAll(So)),
                            (this.flkty = null),
                            (this.scrollEvent = () => this.scrollEvents()),
                            this.init();
                    }
                })(this);
            },
            onUnload() {
                "function" == typeof fo[this.id].unload && fo[this.id].unload();
            },
            onBlockSelect(e) {
                "function" == typeof fo[this.id].onBlockSelect && fo[this.id].onBlockSelect(e);
            },
            onBlockDeselect(e) {
                "function" == typeof fo[this.id].onBlockSelect && fo[this.id].onBlockDeselect(e);
            },
        },
        fi,
        io,
    ]);
    const ko = "[data-range-slider]",
        To = "[data-range-left]",
        xo = "[data-range-right]",
        _o = "[data-range-line]",
        Ao = "[data-range-holder]",
        qo = "data-se-min",
        Co = "data-se-max",
        Po = "data-se-min-value",
        $o = "data-se-max-value",
        Mo = "data-se-step",
        Io = "data-range-filter-update",
        Do = "[data-field-price-min]",
        Oo = "[data-field-price-max]",
        Ho = "is-initialized";
    let Fo = class {
        init() {
            this.setDefaultValues(),
                this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                this.touchRight.addEventListener("mousedown", this.onStartEvent),
                this.touchLeft.addEventListener("touchstart", this.onStartEvent),
                this.touchRight.addEventListener("touchstart", this.onStartEvent),
                this.slider.classList.add(Ho);
        }
        setDefaultValues() {
            let e = this.min;
            this.slider.hasAttribute(Po) && (e = parseFloat(this.slider.getAttribute(Po)));
            let t = this.max;
            this.slider.hasAttribute($o) && (t = parseFloat(this.slider.getAttribute($o))),
                e < this.min && (e = this.min),
                t > this.max && (t = this.max),
                e > t && (e = t),
                this.slider.getAttribute(Mo) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(Mo)))),
                this.reset(),
                (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                (this.selectedTouch = null),
                (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                this.setMinValue(e),
                this.setMaxValue(t);
        }
        reset() {
            (this.touchLeft.style.left = "0px"),
                (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.lineSpan.style.marginLeft = "0px"),
                (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.startX = 0),
                (this.x = 0);
        }
        setMinValue(e) {
            const t = (e - this.min) / (this.max - this.min);
            (this.touchLeft.style.left = Math.ceil(t * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute(Po, e);
        }
        setMaxValue(e) {
            const t = (e - this.min) / (this.max - this.min);
            (this.touchRight.style.left = Math.ceil(t * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute($o, e);
        }
        onStart(e) {
            e.preventDefault();
            let t = e;
            e.touches && (t = e.touches[0]),
                e.currentTarget === this.touchLeft ? (this.x = this.touchLeft.offsetLeft) : e.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
                (this.startX = t.pageX - this.x),
                (this.selectedTouch = e.currentTarget),
                document.addEventListener("mousemove", this.onMoveEvent),
                document.addEventListener("mouseup", this.onStopEvent),
                document.addEventListener("touchmove", this.onMoveEvent),
                document.addEventListener("touchend", this.onStopEvent);
        }
        onMove(e) {
            let t = e;
            if (
                (e.touches && (t = e.touches[0]),
                    (this.x = t.pageX - this.startX),
                    this.selectedTouch === this.touchLeft
                        ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) : this.x < 0 && (this.x = 0),
                            (this.selectedTouch.style.left = this.x + "px"))
                        : this.selectedTouch === this.touchRight &&
                        (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) : this.x > this.maxX && (this.x = this.maxX),
                            (this.selectedTouch.style.left = this.x + "px")),
                    (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                    (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                    this.calculateValue(),
                    this.slider.getAttribute("on-change"))
            ) {
                new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(Po), this.slider.getAttribute($o));
            }
            this.onChange(this.slider.getAttribute(Po), this.slider.getAttribute($o));
        }
        onStop(e) {
            document.removeEventListener("mousemove", this.onMoveEvent),
                document.removeEventListener("mouseup", this.onStopEvent),
                document.removeEventListener("touchmove", this.onMoveEvent),
                document.removeEventListener("touchend", this.onStopEvent),
                (this.selectedTouch = null),
                this.calculateValue(),
                this.onChanged(this.slider.getAttribute(Po), this.slider.getAttribute($o));
        }
        onChange(e, t) {
            const i = this.slider.closest(Ao);
            if (i) {
                const s = i.querySelector(Do),
                    r = i.querySelector(Oo);
                s && r && ((s.value = e), (r.value = t));
            }
        }
        onChanged(e, t) {
            this.slider.hasAttribute(Io) && this.slider.dispatchEvent(new CustomEvent("theme:range:update", { bubbles: !0 }));
        }
        calculateValue() {
            const e = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let t = this.lineSpan.offsetLeft / this.initialValue,
                i = t + e;
            if (((t = t * (this.max - this.min) + this.min), (i = i * (this.max - this.min) + this.min), 0 !== this.step)) {
                let e = Math.floor(t / this.step);
                (t = this.step * e), (e = Math.floor(i / this.step)), (i = this.step * e);
            }
            this.selectedTouch === this.touchLeft && this.slider.setAttribute(Po, t), this.selectedTouch === this.touchRight && this.slider.setAttribute($o, i);
        }
        constructor(e) {
            (this.container = e.container),
                (this.slider = e.querySelector(ko)),
                this.slider &&
                ((this.onMoveEvent = (e) => this.onMove(e)),
                    (this.onStopEvent = (e) => this.onStop(e)),
                    (this.onStartEvent = (e) => this.onStart(e)),
                    (this.startX = 0),
                    (this.x = 0),
                    (this.touchLeft = this.slider.querySelector(To)),
                    (this.touchRight = this.slider.querySelector(xo)),
                    (this.lineSpan = this.slider.querySelector(_o)),
                    (this.min = parseFloat(this.slider.getAttribute(qo))),
                    (this.max = parseFloat(this.slider.getAttribute(Co))),
                    (this.step = 0),
                    (this.normalizeFact = 26),
                    this.init(),
                    document.addEventListener("theme:price-range:reset", () => {
                        this.setDefaultValues();
                    }));
        }
    };
    const Bo = (e, t) => {
        let i, s;
        return function r(...n) {
            const o = Date.now();
            (s = clearTimeout(s)), !i || o - i >= t ? (e.apply(null, n), (i = o)) : (s = setTimeout(r.bind(null, ...n), t - (o - i)));
        };
    },
        Wo = "data-filters",
        No = "[data-filters-underlay]",
        Ro = "data-default-hide",
        jo = "data-filters-toggle",
        zo = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        Vo = "data-group-heading",
        Uo = "data-show-more",
        Go = "drawer--visible",
        Jo = "filters--default-visible",
        Qo = "hidden",
        Ko = "is-hidden",
        Yo = "focus-enabled",
        Xo = {};
    let Zo = class {
        unload() {
            this.filtersToggleButtons.length &&
                this.filtersToggleButtons.forEach((e) => {
                    e.removeEventListener("click", this.connectToggleMemory);
                }),
                this.showMoreButtons.length &&
                this.showMoreButtons.forEach((e) => {
                    e.removeEventListener("click", this.connectShowHiddenOptions);
                });
        }
        expandingEvents() {
            this.showMoreButtons.length &&
                this.showMoreButtons.forEach((e) => {
                    e.addEventListener("click", Bo(this.connectShowHiddenOptions, 500));
                });
        }
        showHiddenOptions(e) {
            const t = e.target.hasAttribute(Uo) ? e.target : e.target.closest(`[${Uo}]`);
            t.classList.add(Ko),
                t.previousElementSibling.querySelectorAll(`.${Ko}`).forEach((e) => {
                    e.classList.remove(Ko);
                });
        }
        connectToggle(e = !1) {
            this.filtersToggleButtons.forEach((t) => {
                const i = null !== t.closest(`[${Wo}]`);
                ((i && e) || (i && !e) || (!i && !e)) && t.addEventListener("click", this.connectToggleMemory.bind(this));
            });
        }
        connectToggleFunction(e) {
            "true" === e.currentTarget.getAttribute("aria-expanded") ? this.hideFilters() : this.showFilters();
        }
        onFocusOut() {
            this.container.addEventListener(
                "focusout",
                function (e) {
                    if (window.innerWidth >= window.theme.sizes.medium) return;
                    const t = e.currentTarget.contains(e.relatedTarget),
                        i = this.container.classList.contains(Go);
                    document.body.classList.contains(Yo) && i && !t && this.hideFilters();
                }.bind(this)
            ),
                this.container.addEventListener(
                    "keyup",
                    function (e) {
                        "Escape" === e.code && (this.hideFilters(), this.filtersToggleButtons[0].focus());
                    }.bind(this)
                ),
                this.underlay.addEventListener(
                    "click",
                    function () {
                        this.hideFilters();
                    }.bind(this)
                );
        }
        getShowOnLoad() {
            const e = `[${Ro}='false']`,
                t = document.querySelector(e),
                i = window.innerWidth >= window.theme.sizes.medium;
            return !(!t || !i);
        }
        showFilters() {
            (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                this.container.classList.remove(Qo),
                setTimeout(() => {
                    this.filtersToggleButtons.forEach((e) => e.setAttribute("aria-expanded", !0)), this.filtersToggleButtons.forEach((e) => e.classList.add(Go)), this.container.classList.add(Go), this.container.querySelector(zo).focus();
                }, 1);
        }
        hideFilters() {
            (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                this.filtersToggleButtons.forEach((e) => e.setAttribute("aria-expanded", !1)),
                this.container.classList.remove(Go),
                this.container.classList.remove(Jo),
                this.filtersToggleButtons.forEach((e) => e.classList.remove(Go)),
                this.filtersToggleButtons.forEach((e) => e.classList.remove(Jo)),
                setTimeout(() => {
                    this.container.classList.contains(Go) || this.container.classList.add(Qo);
                }, 800);
        }
        constructor(e, t = !1) {
            (this.container = e),
                (this.underlay = this.container.querySelector(No)),
                (this.groupHeadings = this.container.querySelectorAll(`[${Vo}]`)),
                (this.showMoreButtons = this.container.querySelectorAll(`[${Uo}]`)),
                (this.triggerKey = this.container.getAttribute(Wo)),
                (this.selector = `[${jo}='${this.triggerKey}']`),
                (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                (this.connectToggleMemory = (e) => this.connectToggleFunction(e)),
                (this.connectShowHiddenOptions = (e) => this.showHiddenOptions(e)),
                this.connectToggle(t),
                this.onFocusOut(),
                this.expandingEvents(),
                this.getShowOnLoad() ? this.showFilters() : this.hideFilters();
        }
    };
    const ea = {
        onLoad() {
            Xo[this.id] = [];
            this.container.querySelectorAll(`[${Wo}]`).forEach((e) => {
                Xo[this.id].push(new Zo(e));
            });
        },
        onUnload: function () {
            Xo[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            });
        },
    },
        ta = {
            collectionSidebar: "[data-collection-sidebar]",
            form: "[data-sidebar-filter-form]",
            inputs: "input, select, label, textarea",
            priceMin: "data-field-price-min",
            priceMax: "data-field-price-max",
            rangeMin: "data-se-min-value",
            rangeMax: "data-se-max-value",
            rangeMinDefault: "data-se-min",
            rangeMaxDefault: "data-se-max",
            productsContainer: "[data-products-grid]",
            filterUpdateUrlButton: "[data-filter-update-url]",
            activeFiltersHolder: "[data-active-filters]",
            activeFiltersCount: "[data-active-filters-count]",
            productsCount: "[data-products-count]",
            dataSort: "data-sort-enabled",
            collectionTools: "[data-collection-tools]",
            filtersWrappper: "[data-filters]",
            headerSticky: '[data-header-sticky="sticky"]',
            headerHeight: "[data-header-height]",
            gridLarge: "data-grid-large",
            gridSmall: "data-grid-small",
            accordionBody: "[data-accordion-body]",
            checkedOption: "input:checked",
            optionHolder: "[data-option-holder]",
        },
        ia = "is-hidden",
        sa = "is-loading",
        ra = 1e3,
        na = 1e3;
    const oa = {
        onLoad() {
            this.filterForm = new (class {
                init() {
                    this.showAllOptions(),
                        this.form &&
                        (new Fo(this.form),
                            this.sidebar.addEventListener(
                                "input",
                                T((e) => {
                                    const t = e.type,
                                        i = e.target;
                                    if (!ta.inputs.includes(t) || !this.form || "function" != typeof this.form.submit) return;
                                    const s = this.form.querySelector(`[${ta.priceMin}]`),
                                        r = this.form.querySelector(`[${ta.priceMax}]`);
                                    if (i.hasAttribute(ta.priceMin) || i.hasAttribute(ta.priceMax)) {
                                        const e = this.form.querySelector(`[${ta.rangeMin}]`),
                                            t = this.form.querySelector(`[${ta.rangeMax}]`),
                                            i = parseInt(e.getAttribute(ta.rangeMinDefault)),
                                            n = parseInt(t.getAttribute(ta.rangeMaxDefault));
                                        s.value && !r.value && (r.value = n), r.value && !s.value && (s.value = i), s.value <= i && r.value >= n && ((s.placeholder = i), (r.placeholder = n), (s.value = ""), (r.value = ""));
                                    }
                                    this.filtering(e);
                                }, 1500)
                            ),
                            this.form.addEventListener("theme:range:update", (e) => this.updateRange(e))),
                        this.sidebar && this.sidebar.addEventListener("click", (e) => this.updateFilterFromUrl(e)),
                        this.activeFiltersHolder && this.activeFiltersHolder.addEventListener("click", (e) => this.updateFilterFromUrl(e)),
                        this.productsContainer && this.productsContainer.addEventListener("click", (e) => this.updateFilterFromUrl(e)),
                        Pe(this.sidebar);
                }
                updateRange(e) {
                    if (this.form && "function" == typeof this.form.submit) {
                        const t = this.form.querySelector(`[${ta.rangeMin}]`),
                            i = this.form.querySelector(`[${ta.rangeMax}]`),
                            s = this.form.querySelector(`[${ta.priceMin}]`),
                            r = this.form.querySelector(`[${ta.priceMax}]`);
                        if (t && i && s && r && t.hasAttribute(ta.rangeMin) && i.hasAttribute(ta.rangeMax)) {
                            const n = parseInt(s.placeholder),
                                o = parseInt(r.placeholder),
                                a = parseInt(t.getAttribute(ta.rangeMin)),
                                l = parseInt(i.getAttribute(ta.rangeMax));
                            (n === a && o === l) || ((s.value = a), (r.value = l), this.filtering(e));
                        }
                    }
                }
                updateFilterFromUrl(e) {
                    const t = e.target;
                    if (t.matches(ta.filterUpdateUrlButton) || (t.closest(ta.filterUpdateUrlButton) && t)) {
                        e.preventDefault();
                        const i = t.matches(ta.filterUpdateUrlButton) ? t : t.closest(ta.filterUpdateUrlButton);
                        this.filtering(e, i.getAttribute("href"));
                    }
                }
                addToHistory(e, t = "") {
                    const i = this.sort ? this.sort.getAttribute(ta.dataSort) : "";
                    if (!e || (e && "popstate" !== e.type)) {
                        if ("" === t) {
                            const t = new window.URL(window.location.href).searchParams,
                                s = Object.fromEntries(t),
                                r = t.toString();
                            if (r.includes("filter.") || r.includes("sort_by") || r.includes("page")) for (const e in s) (e.includes("filter.") || e.includes("sort_by") || e.includes("page")) && t.delete(e);
                            if (this.form) {
                                const e = new URLSearchParams(new FormData(this.form));
                                for (let [i, s] of e.entries()) i.includes("filter.") && s && t.append(i, s);
                                const i = this.form.querySelector(`[${ta.rangeMin}]`),
                                    s = this.form.querySelector(`[${ta.rangeMax}]`),
                                    r = this.form.querySelector(`[${ta.priceMin}]`),
                                    n = this.form.querySelector(`[${ta.priceMax}]`);
                                if (i && s && r && n && i.hasAttribute(ta.rangeMinDefault) && s.hasAttribute(ta.rangeMaxDefault)) {
                                    const e = parseFloat(i.getAttribute(ta.rangeMinDefault), 10),
                                        o = parseFloat(s.getAttribute(ta.rangeMaxDefault), 10),
                                        a = "" === r.value ? parseFloat(r.placeholder, 10) : parseFloat(r.value, 10),
                                        l = "" === n.value ? parseFloat(n.placeholder, 10) : parseFloat(n.value, 10);
                                    a <= e && l >= o && (t.delete("filter.v.price.gte"), t.delete("filter.v.price.lte"));
                                }
                            }
                            if (i || (e && e.detail && e.detail.href)) {
                                const s = i || e.detail.params;
                                t.set("sort_by", s);
                            }
                            const n = t.toString(),
                                o = n ? `?${n}` : location.pathname;
                            return void window.history.pushState(null, "", o);
                        }
                        window.history.pushState(null, "", t);
                    }
                }
                getFilterResult() {
                    this.productsContainer.classList.add(sa), this.getGridValues();
                    const e = new window.URL(window.location.href);
                    e.searchParams.set("section_id", this.section.id),
                        fetch(`${window.location.pathname}${e.search}`)
                            .then((e) => e.text())
                            .then((e) => {
                                const t = document.createElement("div");
                                (t.innerHTML = e),
                                    this.sidebar && (this.sidebar.innerHTML = t.querySelector(ta.collectionSidebar).innerHTML),
                                    this.activeFiltersCount && (this.activeFiltersCount.innerHTML = t.querySelector(ta.activeFiltersCount).innerHTML),
                                    (this.productsContainer.innerHTML = t.querySelector(ta.productsContainer).innerHTML),
                                    (this.activeFiltersHolder.innerHTML = t.querySelector(ta.activeFiltersHolder).innerHTML),
                                    this.activeFiltersHolder.parentNode.classList.toggle(ia, "" === this.activeFiltersHolder.innerHTML),
                                    this.productsCount && (this.productsCount.innerHTML = t.querySelector(ta.productsCount).innerHTML),
                                    this.setGridValues(),
                                    this.refreshFunctionalities(),
                                    setTimeout(() => {
                                        this.productsContainer.classList.remove(sa);
                                    }, ra);
                            });
                }
                refreshFunctionalities() {
                    (this.form = this.container.querySelector(ta.form)),
                        this.form && (new Fo(this.form), this.form.addEventListener("theme:range:update", (e) => this.updateRange(e))),
                        this.container.querySelectorAll(ta.filtersWrappper).forEach((e) => {
                            new Zo(e, !0);
                        }),
                        this.container.querySelectorAll(ta.accordionBody).forEach((e) => {
                            new Hr(e);
                        }),
                        new Q(this.container),
                        this.sidebar && Pe(this.sidebar),
                        Ge(this.container),
                        this.showAllOptions();
                }
                getGridValues() {
                    this.layoutLarge && (this.layoutLargeValue = this.layoutLarge.getAttribute(ta.gridLarge)), this.layoutSmall && (this.layoutSmallValue = this.layoutSmall.getAttribute(ta.gridSmall));
                }
                setGridValues() {
                    this.layoutLarge && ((this.layoutLarge = this.container.querySelector(`[${ta.gridLarge}]`)), this.layoutLarge.setAttribute(ta.gridLarge, this.layoutLargeValue)),
                        this.layoutSmall && ((this.layoutSmall = this.container.querySelector(`[${ta.gridSmall}]`)), this.layoutSmall.setAttribute(ta.gridSmall, this.layoutSmallValue));
                }
                showAllOptions() {
                    this.container.querySelectorAll(ta.checkedOption).forEach((e) => {
                        if (e.closest(ta.optionHolder) && e.closest(ta.optionHolder).classList.contains(ia)) {
                            const t = e.closest(ta.accordionBody).nextElementSibling;
                            t.classList.contains(ta.classHidden) || t.dispatchEvent(new Event("click"));
                        }
                    });
                }
                filtering(e, t = "") {
                    const i = this.headerIsSticky ? document.querySelector(ta.headerHeight).getBoundingClientRect().height : 0,
                        s = this.container.offsetTop - i,
                        r = new IntersectionObserver(
                            (i) => {
                                const [n] = i;
                                setTimeout(
                                    () => {
                                        this.addToHistory(e, t), this.getFilterResult();
                                    },
                                    n.isIntersecting ? 10 : na
                                ),
                                    r.unobserve(this.productsContainer),
                                    n.isIntersecting || window.scrollTo({ top: s, left: 0, behavior: "smooth" });
                            },
                            { root: null, rootMargin: `${i}px`, threshold: 1 }
                        );
                    r.observe(this.productsContainer);
                }
                constructor(e) {
                    (this.section = e),
                        (this.container = this.section.container),
                        (this.sidebar = this.container.querySelector(ta.collectionSidebar)),
                        (this.form = e.container.querySelector(ta.form)),
                        (this.sort = this.container.querySelector(`[${ta.dataSort}]`)),
                        (this.productsContainer = this.container.querySelector(ta.productsContainer)),
                        (this.activeFiltersHolder = this.container.querySelector(ta.activeFiltersHolder)),
                        (this.activeFiltersCount = this.container.querySelector(ta.activeFiltersCount)),
                        (this.productsCount = this.container.querySelector(ta.productsCount)),
                        (this.headerIsSticky = null !== document.querySelector(ta.headerSticky)),
                        (this.layoutLarge = this.container.querySelector(`[${ta.gridLarge}]`)),
                        (this.layoutSmall = this.container.querySelector(`[${ta.gridSmall}]`)),
                        this.productsContainer && this.sidebar && this.init(),
                        this.sort && this.container.addEventListener("theme:form:filter", (e) => this.filtering(e)),
                        (this.sidebar || this.sort) && window.addEventListener("popstate", (e) => this.filtering(e));
                }
            })(this);
        },
        onUnload() {
            this.filterForm && "function" == typeof this.filterForm.unload && this.filterForm.unload();
        },
    };
    Gt("search-page", [ea, oa, Je, Fr]),
        customElements.get("popout-select") || customElements.define("popout-select", xr),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Ue),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Js),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", cr),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", ur);
    const aa = "[data-image-zoom]",
        la = "[data-modal-container]",
        ca = "data-unique",
        ha = "data-src";
    const da = {
        onLoad() {
            new (class {
                init() {
                    this.triggers.forEach((e) => {
                        const t = e.getAttribute(ca),
                            i = this.modalContainer.querySelector(`#zoom-${t}`);
                        if (i) {
                            const e = this.container.querySelector(`#zoom-${t}`);
                            e && (i.parentNode.removeChild(i), this.modalContainer.appendChild(e));
                        }
                        n.init({
                            disableScroll: !0,
                            openTrigger: `data-popup-${t}`,
                            onShow: (e) => {
                                e.querySelectorAll(`[${ha}]`, e).forEach((e) => {
                                    if (null === e.getAttribute("src")) {
                                        const t = e.getAttribute(ha);
                                        e.setAttribute("src", t);
                                    }
                                });
                            },
                            onClose: (e, t, i) => {
                                i.preventDefault();
                            },
                        });
                    });
                }
                constructor(e) {
                    (this.container = e), (this.triggers = this.container.querySelectorAll(aa)), (this.modalContainer = document.querySelector(la)), this.init();
                }
            })(this.container);
        },
    };
    Gt("gallery", [da, eo, tt]);
    const ua = (e, t) => {
        const { el: i, elStyle: s, elHeight: r, rowsLimit: n, rowsWrapped: o, options: a } = e;
        let l = e.buffer,
            c = l;
        if (o === n + 1) return { ...e };
        const h = l;
        let d = o,
            u = r;
        return (
            (i.innerHTML = c = l.length ? `${l}${a.delimiter}${t}${a.replaceStr}` : `${t}${a.replaceStr}`),
            parseFloat(s.height) > parseFloat(r) && (d++, (u = s.height), d === n + 1)
                ? ((i.innerHTML = c = "." === h[h.length - 1] && "..." === a.replaceStr ? `${h}..` : `${h}${a.replaceStr}`), { ...e, elHeight: u, rowsWrapped: d })
                : ((i.innerHTML = c = h.length ? `${h}${a.delimiter}${t}` : `${t}`), { ...e, buffer: c, elHeight: u, rowsWrapped: d })
        );
    };
    !(function () {
        const e = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        document.documentElement.classList.toggle("supports-touch", e);
    })();
    let pa = {},
        ma = {},
        fa = {};
    const ga = "[data-product-slideshow]",
        ya = "[data-shopify-xr]",
        va = "data-media-id",
        ba = "data-model-id",
        wa = "model-viewer",
        Sa = "data-shopify-model3d-id",
        Ea = "#ModelJson-";
    function La(e) {
        if (e) console.warn(e);
        else if (window.ShopifyXR) {
            for (const e in pa)
                if (pa.hasOwnProperty(e)) {
                    const t = pa[e];
                    if (t.loaded) continue;
                    const i = document.querySelector(`${Ea}${e}`);
                    i && (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)), (t.loaded = !0));
                }
            window.ShopifyXR.setupXRElements();
        } else
            document.addEventListener("shopify_xr_initialized", function () {
                La();
            });
    }
    function ka(e) {
        if (e) console.warn(e);
        else
            for (const e in ma)
                if (ma.hasOwnProperty(e)) {
                    const t = ma[e];
                    t.modelViewerUi || (t.modelViewerUi = new Shopify.ModelViewerUI(t.$element)), Ta(t);
                }
    }
    function Ta(e) {
        const t = fa[e.sectionId];
        e.$container.addEventListener("pause", function () {
            e.modelViewerUi.pause && e.modelViewerUi.pause();
        }),
            e.$container.addEventListener("play", function () {
                e.modelViewerUi.play && (e.modelViewerUi.play(), t && t.$element && e && e.modelId && Sa && t.$element.setAttribute(Sa, e.modelId));
            }),
            e.$element.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
                e.$container.dispatchEvent(new CustomEvent("theme:media:play"));
            }),
            e.$element.addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
                e.$container.dispatchEvent(new CustomEvent("theme:media:pause"));
            });
    }
    async function xa(e) {
        const t = document.querySelector(`[data-player="${e}"]`),
            i = t.querySelector("video");
        await xe({ name: "video-ui", version: "1.0" });
        const s = new window.Shopify.Plyr(i);
        return (
            t.addEventListener("pause", () => {
                s.pause && s.pause();
            }),
            t.addEventListener("play", () => {
                try {
                    s.play
                        ? s.paused && s.play()
                        : s.addEventListener("onReady", () => {
                            s.play();
                        });
                } catch (e) {
                    console.warn(e);
                }
            }),
            t.addEventListener("destroy", () => {
                try {
                    s.destroy && s.destroy();
                } catch (e) {
                    console.warn(e);
                }
            }),
            s
        );
    }
    const _a = {
        productSlideshow: "[data-product-slideshow]",
        slideshowMobileStyle: "data-slideshow-mobile-style",
        slideshowDesktopStyle: "data-slideshow-desktop-style",
        productThumbs: "[data-product-thumbs]",
        leftThumbsHolder: "[data-thumbs-holder]",
        thumbImage: "[data-slideshow-thumbnail]",
        mediaSlide: "[data-media-slide]",
        dataMediaId: "data-media-id",
        dataMediaSelect: "data-media-select",
        mediaType: "data-type",
        videoPlayerExternal: '[data-type="external_video"]',
        videoPlayerNative: '[data-type="video"]',
        modelViewer: '[data-type="model"]',
        modelViewerTag: "model-viewer",
        allPlayers: "[data-player]",
        loopVideo: "data-enable-video-looping",
        verticalAlignment: "[data-thumbnails-left]",
        arrowPrev: "[data-thumbs-arrow-prev]",
        arrowNext: "[data-thumbs-arrow-next]",
        aspectRatio: "data-aspect-ratio",
        flickitylockHeight: "flickity-lock-height",
    },
        Aa = "is-activated",
        qa = "show",
        Ca = "enable-video-draggable",
        Pa = "hide";
    let $a = class {
        init() {
            this.storeEvents(),
                this.connectSliderMediaEvents(),
                this.detectVideos(),
                this.detect3d(),
                this.scrollThumbs(),
                document.addEventListener("theme:resize:width", () => {
                    this.scrollThumbs();
                }),
                ge.onChange(() => {
                    this.connectSliderMediaEvents();
                });
        }
        connectSliderMediaEvents() {
            ge.isMobile() ? this.createMobileSlider() : this.createDesktopSlider();
        }
        createMobileSlider() {
            this.hasDesktopSlider && this.flkty && (this.destroySlider(), (this.hasDesktopSlider = !1));
            const e = { autoPlay: !1, prevNextButtons: !1, pageDots: !1, adaptiveHeight: !0, accessibility: !0, watchCSS: !1, wrapAround: !0, rightToLeft: window.isRTL, dragThreshold: 80, contain: !0, fade: !0 };
            "carousel" == this.mobileStyle && ((e.contain = !1), (e.dragThreshold = 10), (e.fade = !1)),
                "slideshow" == this.mobileStyle && ((e.pageDots = !0), (e.fade = !1), (e.dragThreshold = 10)),
                "none" != this.mobileStyle && (this.createSlider(e), (this.hasMobileSlider = !0));
        }
        createDesktopSlider() {
            if ((this.hasMobileSlider && this.flkty && (this.destroySlider(), (this.hasMobileSlider = !1)), "none" == this.desktopStyle)) return;
            const e = { autoPlay: !1, prevNextButtons: !1, pageDots: !1, adaptiveHeight: !0, accessibility: !0, watchCSS: !1, wrapAround: !0, rightToLeft: window.isRTL, dragThreshold: 80, contain: !0, fade: !0 };
            this.createSlider(e), (this.hasDesktopSlider = !0);
        }
        createSlider(e) {
            (this.flkty = new s(this.slideshow, e)), this.flkty.resize(), (this.currentSlide = this.slideshow.querySelectorAll(_a.mediaSlide)[0]), this.setDraggable(), this.addEventListeners();
        }
        destroySlider() {
            this.removeEventListeners(), this.flkty.destroy();
        }
        storeEvents() {
            (this.storeFlktyChange = (e) => this.doFlktyChange(e)),
                (this.storeFlktySettle = (e) => this.doFlktySettle(e)),
                (this.storeImageChange = (e) => this.doImageChange(e)),
                (this.storeArrowPrevClick = (e) => this.doArrowPrevClick(e)),
                (this.storeArrowNextClick = (e) => this.doArrowNextClick(e)),
                (this.storeThumbClick = (e) => this.doThumbClick(e)),
                (this.storeThumbContainerScroll = (e) => this.doThumbContainerScroll(e));
        }
        addEventListeners() {
            var e, t, i;
            this.flkty.on("change", this.storeFlktyChange),
                this.flkty.on("settle", this.storeFlktySettle),
                this.slideshow.addEventListener("theme:image:change", this.storeImageChange),
                null === (e = this.arrowPrev) || void 0 === e || e.addEventListener("click", this.storeArrowPrevClick),
                null === (t = this.arrowNext) || void 0 === t || t.addEventListener("click", this.storeArrowNextClick),
                null === (i = this.thumbs) || void 0 === i || i.addEventListener("scroll", this.storeThumbContainerScroll),
                this.thumbImages.forEach((e) => {
                    e.addEventListener("click", this.storeThumbClick);
                });
        }
        removeEventListeners() {
            var e, t, i;
            this.flkty.on("change", this.storeFlktyChange),
                this.flkty.on("settle", this.storeFlktySettle),
                this.slideshow.removeEventListener("theme:image:change", this.storeImageChange),
                null === (e = this.arrowPrev) || void 0 === e || e.removeEventListener("click", this.storeArrowPrevClick),
                null === (t = this.arrowNext) || void 0 === t || t.removeEventListener("click", this.storeArrowNextClick),
                null === (i = this.thumbs) || void 0 === i || i.removeEventListener("scroll", this.storeThumbContainerScroll),
                this.thumbImages.forEach((e) => {
                    e.removeEventListener("click", this.storeThumbClick);
                });
        }
        addMediaEventListeners(e) {
            e &&
                (e.addEventListener("play", () => {
                    (ge.isMobile() || ge.isTouch()) && this.updateDraggable(!1);
                }),
                    e.addEventListener("pause", () => {
                        (ge.isMobile() || ge.isTouch()) && this.updateDraggable(!0);
                    }));
        }
        doFlktyChange(e) {
            var t, i;
            ("model" !== this.mediaType && "video" !== this.mediaType && "external_video" !== this.mediaType) || this.currentSlide.dispatchEvent(new CustomEvent("pause")),
                (this.currentSlide = this.flkty.cells[e].element),
                this.slideshow.classList.remove(_a.flickitylockHeight);
            const s = this.currentSlide.getAttribute(_a.dataMediaId),
                r = null === (t = this.thumbWrapper) || void 0 === t ? void 0 : t.querySelector(`[${_a.dataMediaSelect}="${s}"]`);
            null === (i = this.thumbWrapper) || void 0 === i || i.querySelector(`.${Aa}`).classList.remove(Aa),
                null == r || r.classList.add(Aa),
                this.scrollThumbs(),
                setTimeout(() => {
                    (null == r ? void 0 : r.classList.contains(Pa)) && (this.lastMediaSelect ? this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", { detail: { id: this.lastMediaSelect } })) : window.location.reload());
                });
        }
        doFlktySettle(e) {
            (this.allSlides = this.flkty.cells), (this.currentSlide = this.flkty.cells[e].element), this.setDraggable();
            document.body.classList.contains(_a.focusEnabled) && this.currentSlide.dispatchEvent(new Event("focus")), this.scrollThumbs();
        }
        doImageChange(e) {
            var t = e.detail.id;
            this.lastMediaSelect = t;
            const i = `[${_a.dataMediaId}="${t}"]`,
                s = this.flkty.cells.findIndex((e) => e.element.matches(i));
            this.flkty.select(s), this.scrollThumbs();
        }
        doThumbContainerScroll() {
            this.scrollThumbs("scroll");
        }
        doArrowPrevClick() {
            this.scrollThumbs("clickPrev");
        }
        doArrowNextClick() {
            this.scrollThumbs("clickNext");
        }
        doThumbClick(e) {
            const t = e.currentTarget.getAttribute(_a.dataMediaSelect);
            this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", { detail: { id: t } }));
        }
        setDraggable() {
            this.currentSlide &&
                ((this.mediaType = this.currentSlide.getAttribute(_a.mediaType)),
                    "model" === this.mediaType || "video" === this.mediaType || "external_video" === this.mediaType
                        ? ge.isMobile() && ge.isTouch()
                            ? this.updateDraggable(!0)
                            : (this.currentSlide.dispatchEvent(new CustomEvent("play")), this.updateDraggable(!1))
                        : this.updateDraggable(!0));
        }
        updateDraggable(e) {
            this.flkty && ((this.flkty.options.draggable = e), this.flkty.updateDraggable(), this.slideshow.classList.toggle(Ca, e));
        }
        detect3d() {
            const e = this.container.querySelectorAll(_a.modelViewer);
            e &&
                (e.forEach((e) => {
                    !(function (e, t) {
                        pa[t] = { loaded: !1 };
                        const i = e.getAttribute(va),
                            s = e.querySelector(wa),
                            r = s.getAttribute(ba);
                        if (null !== e.closest(ga)) {
                            const i = e.closest(ga).parentElement.querySelector(ya);
                            fa[t] = { $element: i, defaultId: r };
                        }
                        (ma[i] = { modelId: r, mediaId: i, sectionId: t, $container: e, $element: s }),
                            window.Shopify.loadFeatures([
                                { name: "shopify-xr", version: "1.0", onLoad: La },
                                { name: "model-viewer-ui", version: "1.0", onLoad: ka },
                            ]);
                    })(e, this.section.id),
                        e.addEventListener("theme:media:play", () => {
                            this.updateDraggable(!1);
                        }),
                        e.addEventListener("theme:media:pause", () => {
                            this.updateDraggable(!0);
                        });
                }),
                    document.addEventListener(
                        "shopify_xr_launch",
                        function () {
                            this.container.querySelectorAll(_a.allPlayers).forEach((e) => {
                                e.dispatchEvent(new CustomEvent("pause"));
                            });
                        }.bind(this)
                    ));
        }
        detectVideos() {
            const e = this.section.container.querySelectorAll(`${_a.videoPlayerExternal}, ${_a.videoPlayerNative}`);
            for (var t of e) {
                const e = t.dataset.player,
                    i = t.dataset.host;
                let s;
                (s = "youtube" === i ? jn(e) : "vimeo" === i ? Gn(e) : xa(e)),
                    !0 === this.loopVideo &&
                    s
                        .then((e) => (i ? Ma(e, i) : ((e.loop = !0), e)))
                        .catch((e) => {
                            console.error(e);
                        }),
                    this.addMediaEventListeners(t);
            }
        }
        pauseAllMedia() {
            this.container.querySelector(_a.mediaSlide).dispatchEvent(new CustomEvent("pause"));
        }
        pauseOtherMedia(e) {
            this.container.querySelector(`${_a.mediaSlide}:not([data-player="${e}"])`).dispatchEvent(new CustomEvent("pause"));
        }
        destroy() {
            this.container.querySelectorAll(_a.allPlayers).forEach((e) => {
                e.dispatchEvent(new CustomEvent("destroy"));
            });
        }
        scrollThumbs(e) {
            if (((this.thumbs = this.container.querySelector(_a.productThumbs)), this.thumbs)) {
                if (((this.thumb = this.thumbs.querySelector(`.${Aa}`)), (this.thumbItems = this.container.querySelectorAll(_a.thumbImage)), (this.lastThumb = this.thumbItems[this.thumbItems.length - 1]), !this.thumb)) return;
                (this.thumbsScrollTop = this.thumbs.scrollTop),
                    (this.thumbsScrollLeft = this.thumbs.scrollLeft),
                    (this.thumbsWidth = this.thumbs.offsetWidth),
                    (this.thumbsHeight = this.slideshow.offsetWidth / this.thumb.getAttribute(_a.aspectRatio)),
                    (this.thumbsPositionBottom = this.thumbsScrollTop + this.thumbsHeight),
                    (this.thumbsPositionRight = this.thumbsScrollLeft + this.thumbsWidth),
                    this.checkThumbPositions(),
                    this.toggleToActiveThumb(e),
                    this.toggleArrows();
            }
        }
        checkThumbPositions() {
            (this.thumbWidth = this.thumb.offsetWidth),
                (this.thumbHeight = this.thumb.offsetHeight),
                (this.thumbPosTop = this.thumb.offsetTop),
                (this.thumbPosLeft = this.thumb.offsetLeft),
                (this.lastThumbRightPos = this.lastThumb.offsetLeft + this.thumbWidth),
                (this.lastThumbBottomPos = this.lastThumb.offsetTop + this.thumbHeight),
                (this.scrollTopPosition = this.thumbPosTop + this.thumbHeight / 2 - this.thumbsHeight / 2),
                (this.scrollLeftPosition = this.thumbPosLeft + this.thumbWidth / 2 - this.thumbsWidth / 2),
                (this.topCheck = this.thumbsScrollTop > 0),
                (this.bottomCheck = this.thumbsPositionBottom < this.lastThumbBottomPos),
                (this.leftCheck = this.thumbsScrollLeft > 0),
                (this.rightCheck = this.thumbsPositionRight < this.lastThumbRightPos),
                (this.verticalCheck = this.bottomCheck || this.topCheck),
                (this.horizontalCheck = this.rightCheck || this.leftCheck);
        }
        toggleToActiveThumb(e) {
            "scroll" !== e &&
                ("clickPrev" == e &&
                    (this.verticalCheck
                        ? ((this.scrollTopPosition = this.thumbsScrollTop - this.thumbsHeight), (this.scrollLeftPosition = 0))
                        : ((this.scrollTopPosition = 0), (this.scrollLeftPosition = this.thumbsScrollLeft - this.thumbsWidth))),
                    "clickNext" == e &&
                    (this.verticalCheck
                        ? ((this.scrollTopPosition = this.thumbsScrollTop + this.thumbsHeight), (this.scrollLeftPosition = 0))
                        : ((this.scrollTopPosition = 0), (this.scrollLeftPosition = this.thumbsScrollLeft + this.thumbsWidth))),
                    this.thumbs.scrollTo({ top: this.scrollTopPosition, left: this.scrollLeftPosition, behavior: "smooth" }));
        }
        toggleArrows() {
            (this.verticalCheck || (this.verticalAlignment && !this.verticalCheck)) && (this.arrowPrev.classList.toggle(qa, this.topCheck), this.arrowNext.classList.toggle(qa, this.bottomCheck)),
                (this.horizontalCheck || (!this.verticalAlignment && !this.horizontalCheck)) && (this.arrowPrev.classList.toggle(qa, this.leftCheck), this.arrowNext.classList.toggle(qa, this.rightCheck));
        }
        constructor(e) {
            (this.section = e),
                (this.container = e.container),
                (this.slideshow = this.container.querySelector(_a.productSlideshow)),
                (this.mobileStyle = this.slideshow.getAttribute(_a.slideshowMobileStyle)),
                (this.desktopStyle = this.slideshow.getAttribute(_a.slideshowDesktopStyle)),
                (this.arrowPrev = this.container.querySelector(_a.arrowPrev)),
                (this.arrowNext = this.container.querySelector(_a.arrowNext)),
                (this.leftThumbsHolder = this.container.querySelector(_a.leftThumbsHolder)),
                (this.thumbWrapper = this.container.querySelector(_a.productThumbs)),
                (this.thumbImages = this.container.querySelectorAll(_a.thumbImage)),
                (this.loopVideo = "true" === this.container.getAttribute(_a.loopVideo)),
                (this.verticalAlignment = Boolean(this.container.querySelector(_a.verticalAlignment))),
                (this.flkty = null),
                (this.lastMediaSelect = null),
                (this.thumbs = this.container.querySelector(_a.productThumbs)),
                (this.currentSlide = null),
                (this.mediaType = null),
                (this.hasMobileSlider = !1),
                (this.hasDesktopSlider = !1),
                this.init();
        }
    };
    function Ma(e, t) {
        return (
            "youtube" === t
                ? e.addEventListener("onStateChange", (e) => {
                    0 === e.data && e.target.playVideo();
                })
                : "vimeo" === t &&
                e.on("ended", () => {
                    e.play();
                }),
            e
        );
    }
    const Ia = "data-store-availability-container",
        Da = "[data-api-content]",
        Oa = "[data-pickup-drawer]",
        Ha = "[data-pickup-drawer-open]",
        Fa = "[data-pickup-drawer-close]",
        Ba = "[data-pickup-body]",
        Wa = "drawer--visible",
        Na = "hide",
        Ra = "is-pickup-visible";
    let ja = {};
    const za = {
        onLoad() {
            ja[this.id] = new (class {
                fetchPickupAvailability(e) {
                    const t = this.container.querySelector(`[${Ia}]`);
                    if (!t) return;
                    const i = e && e.detail.variant ? e.detail.variant.id : t.getAttribute(Ia);
                    !e || e.detail.variant
                        ? i &&
                        fetch(`${window.theme.routes.root_url}variants/${i}/?section_id=api-pickup-availability`)
                            .then(this.handleErrors)
                            .then((e) => e.text())
                            .then((e) => {
                                const i = new DOMParser().parseFromString(e, "text/html").querySelector(Da).innerHTML;
                                (t.innerHTML = i),
                                    t.classList.remove(Na),
                                    (this.drawer = this.container.querySelector(Oa)),
                                    (this.buttonDrawerOpen = this.container.querySelector(Ha)),
                                    (this.buttonDrawerClose = this.container.querySelectorAll(Fa)),
                                    (this.drawerBody = this.container.querySelector(Ba)),
                                    this.buttonDrawerOpen && this.buttonDrawerOpen.addEventListener("click", () => this.openDrawer()),
                                    this.buttonDrawerClose.length &&
                                    this.buttonDrawerClose.forEach((e) => {
                                        e.addEventListener("click", () => this.closeDrawer());
                                    });
                            })
                            .catch((e) => {
                                console.error(e);
                            })
                        : t.classList.add(Na);
                }
                openDrawer() {
                    this.drawer &&
                        (document.body.classList.add(Ra),
                            this.drawer.classList.add(Wa),
                            this.drawer.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                            this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })));
                }
                closeDrawer() {
                    this.drawer &&
                        (document.body.classList.remove(Ra),
                            this.drawer.classList.remove(Wa),
                            this.drawer.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                            this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })));
                }
                handleErrors(e) {
                    return e.ok
                        ? e
                        : e.json().then(function (t) {
                            throw new N({ status: e.statusText, headers: e.headers, json: t });
                        });
                }
                constructor(e) {
                    (this.container = e.container),
                        (this.drawer = null),
                        (this.buttonDrawerOpen = null),
                        (this.buttonDrawerClose = null),
                        (this.drawerBody = null),
                        this.fetchPickupAvailability(),
                        this.container.addEventListener("theme:variant:change", (e) => this.fetchPickupAvailability(e));
                }
            })(this);
        },
    },
        Va = "[data-quantity-selector]",
        Ua = "[data-increase-quantity]",
        Ga = "[data-decrease-quantity]",
        Ja = "[data-quantity-input]";
    function Qa(e) {
        e.querySelectorAll(Va).forEach((e) => {
            new (class {
                initButtons() {
                    this.increase.addEventListener(
                        "click",
                        function (e) {
                            e.preventDefault();
                            let t = parseInt(this.input.value, 10);
                            (t = isNaN(t) ? 0 : t), t++, (this.input.value = t), this.input.dispatchEvent(new Event("change"));
                        }.bind(this)
                    ),
                        this.decrease.addEventListener(
                            "click",
                            function (e) {
                                e.preventDefault();
                                let t = parseInt(this.input.value, 10);
                                (t = isNaN(t) ? 0 : t), t--, (t = Math.max(this.min, t)), (this.input.value = t), this.input.dispatchEvent(new Event("change"));
                            }.bind(this)
                        );
                }
                constructor(e) {
                    (this.wrapper = e),
                        (this.increase = this.wrapper.querySelector(Ua)),
                        (this.decrease = this.wrapper.querySelector(Ga)),
                        (this.input = this.wrapper.querySelector(Ja)),
                        (this.min = parseInt(this.input.getAttribute("min"), 10)),
                        this.initButtons();
                }
            })(e);
        });
    }
    const Ka = "[data-product-form]",
        Ya = "data-option-position",
        Xa = '[name^="options"], [data-popout-option]',
        Za = "data-value",
        el = "sold-out",
        tl = "unavailable";
    const il = "[data-section-id]",
        sl = "[data-quickview-modal]",
        rl = "[data-product-form-wrapper]",
        nl = "[data-product-form]",
        ol = "[data-product-slideshow]",
        al = "[data-add-to-cart]",
        ll = "[data-add-to-cart-text]",
        cl = "[data-compare-price]",
        hl = "[data-compare-text]",
        dl = "[data-buttons-wrapper]",
        ul = "[data-product-select]",
        pl = "[data-price-wrapper]",
        ml = "[data-button-price]",
        fl = "[data-product-json]",
        gl = "[data-product-price]",
        yl = "[data-product-unit-price]",
        vl = "[data-product-base]",
        bl = "[data-product-unit]",
        wl = "data-enable-history-state",
        Sl = "data-option-position",
        El = "[data-option-value]",
        Ll = "[data-subscription-watch-price]",
        kl = "[data-subscription-selectors]",
        Tl = "[data-price-off]",
        xl = "[data-price-off-type]",
        _l = "[data-price-off-amount]",
        Al = "[data-toggles-group]",
        ql = "data-group-toggle",
        Cl = "[data-plan-description]",
        Pl = "[data-remaining-count]",
        $l = "data-remaining-max",
        Ml = "[data-remaining-wrapper]",
        Il = "[data-product-remaining-json]",
        Dl = "[data-product-preorder]",
        Ol = "hide",
        Hl = "variant--soldout",
        Fl = "variant--unavailable",
        Bl = "product__price--sale",
        Wl = "count-is-low",
        Nl = "count-is-in",
        Rl = "count-is-out",
        jl = "count-is-unavailable";
    let zl = class extends HTMLElement {
        connectedCallback() {
            (this.outerSection = this.container.closest(il)),
                (this.quickview = this.container.closest(sl)),
                (this.outerWrapper = this.quickview ? this.quickview : this.outerSection),
                (this.productFormWrapper = this.container.closest(rl)),
                (this.productFormElement = this.container.querySelector(nl)),
                (this.productForm = this.container.querySelector(nl)),
                (this.slideshow = this.outerWrapper.querySelector(ol)),
                (this.enableHistoryState = !(!this.outerSection || !this.outerSection.hasAttribute(wl)) && "true" === this.outerSection.getAttribute(wl)),
                (this.hasUnitPricing = this.outerWrapper.querySelector(bl)),
                (this.subSelectors = this.outerWrapper.querySelector(kl)),
                (this.subPrices = this.outerWrapper.querySelector(Ll)),
                (this.priceOffWrap = this.outerWrapper.querySelector(Tl)),
                (this.priceOffAmount = this.outerWrapper.querySelector(_l)),
                (this.priceOffType = this.outerWrapper.querySelector(xl)),
                (this.planDecription = this.outerWrapper.querySelector(Cl)),
                (this.isPreOrder = this.container.querySelector(Dl)),
                (this.remainingWrapper = this.outerWrapper.querySelector(Ml));
            const e = this.outerWrapper.querySelector(`[${$l}]`);
            (this.sellout = null),
                this.remainingWrapper &&
                e &&
                ((this.remainingMaxInt = parseInt(e.getAttribute($l), 10)),
                    (this.remainingCount = this.outerWrapper.querySelector(Pl)),
                    (this.remainingJSONWrapper = this.outerWrapper.querySelector(Il)),
                    (this.remainingJSON = null),
                    this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML)) : console.warn("Missing product quantity JSON")),
                Qa(this.outerWrapper);
            let t = null;
            this.productJSON = null;
            const i = this.outerWrapper.querySelector(fl);
            i && (t = i.innerHTML),
                t && this.productForm
                    ? ((this.productJSON = JSON.parse(t)),
                        (this.sellout = new (class {
                            init() {
                                this.update();
                            }
                            update() {
                                this.getCurrentState(),
                                    this.optionElements.forEach((e) => {
                                        const t = e.value || e.getAttribute(Za),
                                            i = e.closest(`[${Ya}]`).getAttribute(Ya),
                                            s = parseInt(i, 10) - 1;
                                        let r = [...this.selections];
                                        r[s] = t;
                                        const n = this.productJSON.variants.find((e) => {
                                            let t = !0;
                                            for (let i = 0; i < r.length; i++) e.options[i] !== r[i] && (t = !1);
                                            return t;
                                        });
                                        e.classList.remove(el, tl), void 0 === n ? e.classList.add(tl) : n && !1 === n.available && e.classList.add(el);
                                    });
                            }
                            getCurrentState() {
                                for (var e of ((this.formData = new FormData(this.form)), (this.selections = []), this.formData.entries())) e[0].includes("options[") && this.selections.push(e[1]);
                            }
                            constructor(e, t) {
                                (this.container = e),
                                    (this.productJSON = t),
                                    (this.form = this.container.querySelector(Ka)),
                                    (this.formData = new FormData(this.form)),
                                    (this.optionElements = this.container.querySelectorAll(Xa)),
                                    this.productJSON && this.form && this.init();
                            }
                        })(this.outerWrapper, this.productJSON)),
                        this.linkForm())
                    : console.warn("Missing product form or product JSON"),
                this.productJSON &&
                new (class {
                    updateCookie() {
                        let e = this.cookie.read();
                        const t = e.indexOf(this.handle);
                        -1 === t ? (e.unshift(this.handle), (e = e.splice(0, ee))) : (e.splice(t, 1), e.unshift(this.handle)), this.cookie.write(e);
                    }
                    constructor(e) {
                        (this.handle = e), (this.cookie = new X(ue)), void 0 !== this.handle && (me.push(this.handle), this.updateCookie());
                    }
                })(this.productJSON.handle);
        }
        destroy() {
            this.productForm.destroy();
        }
        linkForm() {
            (this.productForm = new (class {
                destroy() {
                    this._listeners.removeAll();
                }
                options() {
                    return this._serializeInputValues(this.optionInputs, function (e) {
                        return (e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2]), e;
                    });
                }
                variant() {
                    const e = this.options();
                    return e.length ? ve(this.product, e) : this.product.variants[0];
                }
                plan(e) {
                    let t = { allocation: null, group: null, detail: null };
                    const i = new FormData(this.form).get("selling_plan");
                    if (e && e.selling_plan_allocations && e.selling_plan_allocations.length > 0) {
                        const t = [...new Set(e.selling_plan_allocations.map((e) => e.selling_plan_group_id))],
                            i = this.element.querySelectorAll("[data-subscription-group]");
                        if (!i.length) return;
                        i.forEach((e) => (e.style.display = "none")),
                            t.forEach((e) => {
                                this.element.querySelector(`[data-selling-plan-group="${e}"]`).style.display = "block";
                            });
                    }
                    return (
                        i &&
                        e &&
                        (t.allocation = e.selling_plan_allocations.find(function (e) {
                            return e.selling_plan_id.toString() === i.toString();
                        })),
                        t.allocation &&
                        (t.group = this.product.selling_plan_groups.find(function (e) {
                            return e.id.toString() === t.allocation.selling_plan_group_id.toString();
                        })),
                        t.group &&
                        (t.detail = t.group.selling_plans.find(function (e) {
                            return e.id.toString() === i.toString();
                        })),
                        t && t.allocation && t.detail && t.allocation ? t : null
                    );
                }
                properties() {
                    return this._serializeInputValues(this.propertyInputs, function (e) {
                        return (e.name = /(?:^(properties\[))(.*?)(?:\])/.exec(e.name)[2]), e;
                    });
                }
                quantity() {
                    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
                }
                getFormState() {
                    const e = this.variant();
                    return { options: this.options(), variant: e, properties: this.properties(), quantity: this.quantity(), plan: this.plan(e) };
                }
                _setIdInputValue(e) {
                    e && e.id ? (this.variantElement.value = e.id.toString()) : (this.variantElement.value = ""), this.variantElement.dispatchEvent(new Event("change"));
                }
                _onSubmit(e, t) {
                    (t.dataset = this.getFormState()), e.onFormSubmit && e.onFormSubmit(t);
                }
                _onOptionChange(e) {
                    this._setIdInputValue(e.dataset.variant);
                }
                _onFormEvent(e) {
                    return void 0 === e
                        ? Function.prototype
                        : function (t) {
                            (t.dataset = this.getFormState()), this._setIdInputValue(t.dataset.variant), e(t);
                        }.bind(this);
                }
                _initInputs(e, t) {
                    return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(
                        function (e) {
                            return this._listeners.add(e, "change", this._onFormEvent(t)), e;
                        }.bind(this)
                    );
                }
                _serializeInputValues(e, t) {
                    return e.reduce(function (e, i) {
                        return (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) && e.push(t({ name: i.name, value: i.value })), e;
                    }, []);
                }
                _validateProductObject(e) {
                    if ("object" != typeof e) throw new TypeError(e + " is not an object.");
                    if (void 0 === e.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                    return e;
                }
                constructor(e, t, i, s) {
                    (this.element = e),
                        (this.form = "FORM" == t.tagName ? t : t.querySelector("form")),
                        (this.product = this._validateProductObject(i)),
                        (this.variantElement = this.form.querySelector(we)),
                        (s = s || {}),
                        (this.clickedElement = null),
                        (this._listeners = new ye()),
                        this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)),
                        (this.optionInputs = this._initInputs(Ee, s.onOptionChange)),
                        (this.planInputs = this._initInputs(Se, s.onPlanChange)),
                        (this.quantityInputs = this._initInputs(Le, s.onQuantityChange)),
                        (this.propertyInputs = this._initInputs(ke, s.onPropertyChange));
                }
            })(this.outerWrapper, this.productFormElement, this.productJSON, { onOptionChange: this.onOptionChange.bind(this), onPlanChange: this.onPlanChange.bind(this), onQuantityChange: this.onQuantityChange.bind(this) })),
                this.pushState(this.productForm.getFormState(), !0),
                this.subsToggleListeners();
        }
        onOptionChange(e) {
            this.pushState(e.dataset);
        }
        onPlanChange(e) {
            this.subPrices && this.pushState(e.dataset);
        }
        onQuantityChange(e) {
            const t = e.dataset;
            (this.productState = this.setProductState(t)), this.updateButtonPrices(t);
        }
        pushState(e, t = !1) {
            (this.productState = this.setProductState(e)),
                this.updateProductImage(e),
                this.updateAddToCartState(e),
                this.updateProductPrices(e),
                this.updateSaleText(e),
                this.updateSubscriptionText(e),
                this.updateLegend(e),
                this.updateRemaining(e),
                this.fireHookEvent(e),
                this.sellout && this.sellout.update(e),
                this.enableHistoryState && !t && this.updateHistoryState(e);
        }
        updateAddToCartState(e) {
            const t = e.variant;
            let i = theme.strings.addToCart;
            const s = this.outerWrapper.querySelectorAll(pl),
                r = this.outerWrapper.querySelector(dl),
                n = null == r ? void 0 : r.querySelectorAll(al),
                o = null == r ? void 0 : r.querySelectorAll(ll);
            if (
                (this.isPreOrder && (i = theme.strings.preOrder),
                    s.length &&
                    t &&
                    s.forEach((e) => {
                        e.classList.remove(Ol);
                    }),
                    (null == n ? void 0 : n.length) &&
                    n.forEach((e) => {
                        t && t.available ? (e.disabled = !1) : (e.disabled = !0);
                    }),
                    (null == o ? void 0 : o.length) &&
                    o.forEach((e) => {
                        const isCartDrawerUpsellItem = e.closest('.cart-drawer__upsell-item') !== null;
                        if (isCartDrawerUpsellItem) {
                            i = theme.strings.add;
                        }
                        t ? (t.available ? (e.innerHTML = i) : (e.innerHTML = theme.strings.soldOut)) : (e.innerHTML = theme.strings.unavailable);
                    }),
                    r && t)
            ) {
                const e = r.querySelector(ul);
                e && (e.value = t.id);
            }
            r &&
                this.productFormWrapper &&
                (t
                    ? t.available
                        ? this.productFormWrapper.classList.remove(Hl, Fl)
                        : (this.productFormWrapper.classList.add(Hl), this.productFormWrapper.classList.remove(Fl))
                    : (this.productFormWrapper.classList.add(Fl), this.productFormWrapper.classList.remove(Hl)));
        }
        updateLegend(e) {
            const t = e.variant;
            if (t) {
                this.container.parentNode.querySelectorAll(El).forEach((e) => {
                    const i = e.closest(`[${Sl}]`);
                    if (i) {
                        const s = i.getAttribute(Sl),
                            r = parseInt(s, 10) - 1;
                        (this.newValue = t.options[r]), (e.innerHTML = this.newValue);
                    }
                });
            }
        }
        updateHistoryState(e) {
            const t = e.variant,
                i = e.plan,
                s = window.location.href;
            if (t && s.includes("/product")) {
                const e = new window.URL(s),
                    r = e.searchParams;
                r.set("variant", t.id), i && i.detail && i.detail.id && this.productState.hasPlan ? r.set("selling_plan", i.detail.id) : r.delete("selling_plan"), (e.search = r.toString());
                const n = e.toString();
                window.history.replaceState({ path: n }, "", n);
            }
        }
        updateRemaining(e) {
            const t = e.variant;
            if (t && this.remainingWrapper && this.remainingJSON && this.remainingCount) {
                const e = this.remainingJSON[t.id];
                e && e <= this.remainingMaxInt && e > 0
                    ? (this.remainingWrapper.classList.remove(Nl, Rl, jl), this.remainingWrapper.classList.add(Wl), (this.remainingCount.innerHTML = e))
                    : this.productState.soldOut
                        ? (this.remainingWrapper.classList.remove(Wl, Nl, jl), this.remainingWrapper.classList.add(Rl))
                        : this.productState.available && (this.remainingWrapper.classList.remove(Wl, Rl, jl), this.remainingWrapper.classList.add(Nl));
            } else this.remainingWrapper && (this.remainingWrapper.classList.remove(Nl, Rl, Wl), this.remainingWrapper.classList.add(jl));
        }
        getBaseUnit(e) {
            return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
        }
        subsToggleListeners() {
            this.outerWrapper.querySelectorAll(Al).forEach((e) => {
                e.addEventListener(
                    "change",
                    function (e) {
                        const t = e.target.value.toString(),
                            i = this.outerWrapper.querySelector(`[${ql}="${t}"]`),
                            s = this.outerWrapper.querySelectorAll(`[${ql}]`);
                        if (i) {
                            i.classList.remove(Ol);
                            const e = i.querySelector('[name="selling_plan"]');
                            (e.checked = !0), e.dispatchEvent(new Event("change"));
                        }
                        s.forEach((e) => {
                            if (e !== i) {
                                e.classList.add(Ol);
                                e.querySelectorAll('[name="selling_plan"]').forEach((e) => {
                                    (e.checked = !1), e.dispatchEvent(new Event("change"));
                                });
                            }
                        });
                    }.bind(this)
                );
            });
        }
        updateSaleText(e) {
            this.productState.planSale ? this.updateSaleTextSubscription(e) : this.productState.onSale ? this.updateSaleTextStandard(e) : this.priceOffWrap && this.priceOffWrap.classList.add(Ol);
        }
        updateSaleTextStandard(e) {
            if (!this.priceOffType) return;
            this.priceOffType.innerHTML = window.theme.strings.sale || "sale";
            const t = e.variant;
            if (window.theme.settings.badge_sale_type && "percentage" === window.theme.settings.badge_sale_type) {
                const e = (t.compare_at_price - t.price) / t.compare_at_price,
                    i = Math.floor(100 * e);
                this.priceOffAmount.innerHTML = `${i}%`;
            } else {
                const e = t.compare_at_price - t.price;
                this.priceOffAmount.innerHTML = this.formattingMoney(e);
            }
            this.priceOffWrap.classList.remove(Ol);
        }
        updateSaleTextSubscription(e) {
            this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton";
            const t = e.variant,
                i = e.plan.detail.price_adjustments[0],
                s = i.value;
            i && "percentage" === i.value_type
                ? (this.priceOffAmount.innerHTML = `${s}%`)
                : i && "price" === i.value_type
                    ? (this.priceOffAmount.innerHTML = this.formattingMoney(t.price - i.value))
                    : (this.priceOffAmount.innerHTML = this.formattingMoney(s)),
                this.priceOffWrap.classList.remove(Ol);
        }
        updateSubscriptionText(e) {
            e.plan && this.planDecription && null !== e.plan.detail.description
                ? ((this.planDecription.innerHTML = e.plan.detail.description), this.planDecription.classList.remove(Ol))
                : this.planDecription && this.planDecription.classList.add(Ol);
        }
        getPrices(e) {
            const t = e.variant,
                i = e.plan;
            let s = "",
                r = "";
            return (
                this.productState.available && ((s = t.compare_at_price), (r = t.price)),
                this.productState.hasPlan && (r = i.allocation.price),
                this.productState.planSale && ((s = i.allocation.compare_at_price), (r = i.allocation.price)),
                { price: r, comparePrice: s }
            );
        }
        updateButtonPrices(e) {
            const t = this.outerWrapper.querySelectorAll(ml),
                { price: i } = this.getPrices(e);
            t.length &&
                t.forEach((t) => {
                    const s = e.quantity * i;
                    t.innerHTML = this.formattingMoney(s);
                });
        }
        updateProductPrices(e) {
            const t = e.variant,
                i = this.outerWrapper.querySelectorAll(pl),
                s = this.outerWrapper.querySelectorAll(ml),
                { price: r, comparePrice: n } = this.getPrices(e);
            i.forEach((e) => {
                const i = e.querySelector(cl),
                    s = e.querySelector(gl),
                    o = e.querySelector(hl);
                i &&
                    (this.productState.onSale || this.productState.planSale ? (i.classList.remove(Ol), o.classList.remove(Ol), s.classList.add(Bl)) : (i.classList.add(Ol), o.classList.add(Ol), s.classList.remove(Bl)),
                        (i.innerHTML = this.formattingMoney(n))),
                    s && (s.innerHTML = t ? this.formattingMoney(r) : "&nbsp;");
            }),
                s.length &&
                s.forEach((t) => {
                    const i = e.quantity * r;
                    t.innerHTML = this.formattingMoney(i);
                }),
                this.hasUnitPricing && this.updateProductUnits(e);
        }
        updateProductUnits(e) {
            const t = e.variant,
                i = e.plan;
            let s = null;
            if ((t && t.unit_price && (s = t.unit_price), i && i.allocation && i.allocation.unit_price && (s = i.allocation.unit_price), s)) {
                const e = this.getBaseUnit(t);
                (this.outerWrapper.querySelector(yl).innerHTML = this.formattingMoney(s)), (this.outerWrapper.querySelector(vl).innerHTML = e), W(this.outerWrapper.querySelector(bl));
            } else Br(this.outerWrapper.querySelector(bl));
        }
        fireHookEvent(e) {
            const t = e.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: t }, bubbles: !0 }));
        }
        setProductState(e) {
            const t = e.variant,
                i = e.plan,
                s = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1, requiresPlan: !1, hasPlan: !1, planPerDelivery: !1, planSale: !1 };
            return (
                !t || (t.requires_selling_plan && !i)
                    ? (s.available = !1)
                    : (t.available || (s.soldOut = !0),
                        t.compare_at_price > t.price && (s.onSale = !0),
                        t.unit_price && (s.showUnitPrice = !0),
                        this.productJSON && this.productJSON.requires_selling_plan && (s.requiresPlan = !0),
                        i && this.subPrices && ((s.hasPlan = !0), i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), i.allocation.compare_at_price > i.allocation.price && (s.planSale = !0))),
                s
            );
        }
        updateProductImage(e) {
            const t = e.variant;
            t && this.slideshow && t.featured_media && t.featured_media.id && this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", { detail: { id: t.featured_media.id } }));
        }
        formattingMoney(e) {
            return theme.settings.currency_code_enable ? a.formatMoney(e, theme.moneyFormat) + ` ${theme.currencyCode}` : a.formatMoney(e, theme.moneyFormat);
        }
        constructor() {
            super(), (this.container = this);
        }
    },
        Vl = class extends HTMLElement {
            connectedCallback() {
                fetch(this.dataset.url)
                    .then((e) => e.text())
                    .then((e) => {
                        const t = document.createElement("div");
                        t.innerHTML = e;
                        const i = t.querySelector("[data-api-content]");
                        i && (this.innerHTML = i.innerHTML);
                        const s = this.closest("[data-product-complimentary-loaded]");
                        s && "" !== i.innerHTML.trim() && s.classList.remove("js-unloaded");
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
            constructor() {
                super();
            }
        };
    const Ul = "[data-product-slideshow]",
        Gl = "[data-product-image]",
        Jl = "[data-zoom-button]",
        Ql = "[data-zoom-wrapper]",
        Kl = "data-media-id";
    const Yl = "body",
        Xl = "[data-related-section]",
        Zl = "[data-tabs-holder]",
        ec = "data-tab",
        tc = "data-tab-index",
        ic = "data-block-id",
        sc = ".tabs > button",
        rc = ".tab-link",
        nc = ".tab-link__recent",
        oc = ".tab-content",
        ac = "[data-scrollbar]",
        lc = "a:first-child, input:first-child",
        cc = "current",
        hc = "hide",
        dc = "alt",
        uc = "is-focused",
        pc = {};
    const mc = {
        onLoad() {
            pc[this.id] = [];
            this.container.querySelectorAll(Zl).forEach((e) => {
                pc[this.id].push(
                    new (class {
                        init() {
                            const e = this.container,
                                t = e.querySelectorAll(sc),
                                i = e.querySelector(`${rc}-0`),
                                s = e.querySelector(`${oc}-0`);
                            s && s.classList.add(cc),
                                i && i.classList.add(cc),
                                this.checkVisibleTabLinks(),
                                this.container.addEventListener("theme:tabs:check", () => this.checkRecentTab()),
                                this.container.addEventListener("theme:tabs:hide", () => this.hideRelatedTab()),
                                t.length &&
                                t.forEach((t) => {
                                    const i = parseInt(t.getAttribute(ec)),
                                        s = e.querySelector(`${oc}-${i}`);
                                    t.addEventListener("click", () => {
                                        this.tabChange(t, s);
                                    }),
                                        t.addEventListener("keyup", (e) => {
                                            ("Space" !== e.code && "Enter" !== e.code) ||
                                                !this.body.classList.contains(uc) ||
                                                (this.tabChange(t, s), s.querySelector("a, input") && ((this.accessibility.lastFocused = t), this.accessibility.a11y.trapFocus(s, { elementToFocus: s.querySelector(lc) })));
                                        });
                                });
                        }
                        tabChange(e, t) {
                            this.container.querySelector(`${sc}.${cc}`).classList.remove(cc),
                                this.container.querySelector(`${oc}.${cc}`).classList.remove(cc),
                                e.classList.add(cc),
                                t.classList.add(cc),
                                e.classList.contains(hc) && t.classList.add(hc),
                                this.checkVisibleTabLinks(),
                                this.container.dispatchEvent(new CustomEvent("theme:tab:change"));
                        }
                        initNativeScrollbar() {
                            this.scrollbarHolder.length &&
                                this.scrollbarHolder.forEach((e) => {
                                    new G(e);
                                });
                        }
                        checkVisibleTabLinks() {
                            const e = this.container.querySelectorAll(sc),
                                t = this.container.querySelectorAll(`${rc}.${hc}`);
                            e.length - t.length < 2 ? this.container.classList.add(dc) : this.container.classList.remove(dc);
                        }
                        checkRecentTab() {
                            const e = this.container.querySelector(nc);
                            if (e) {
                                e.classList.remove(hc);
                                const t = parseInt(e.getAttribute(ec)),
                                    i = this.container.querySelector(`${oc}[${tc}="${t}"]`);
                                i && i.classList.remove(hc), this.checkVisibleTabLinks(), this.initNativeScrollbar();
                            }
                        }
                        hideRelatedTab() {
                            const e = this.container.querySelector(Xl);
                            if (!e) return;
                            const t = e.closest(`${oc}.${cc}`);
                            if (!t) return;
                            const i = parseInt(t.getAttribute(tc)),
                                s = this.container.querySelectorAll(sc);
                            if (s.length > i) {
                                const e = s[i].nextElementSibling;
                                e && (s[i].classList.add(hc), e.dispatchEvent(new Event("click")), this.initNativeScrollbar());
                            }
                        }
                        onBlockSelect(e) {
                            const t = this.container.querySelector(`${rc}[${ic}="${e.detail.blockId}"]`);
                            t && (t.dispatchEvent(new Event("click")), t.parentNode.scrollTo({ top: 0, left: t.offsetLeft - t.clientWidth, behavior: "smooth" }));
                        }
                        constructor(e) {
                            (this.container = e),
                                (this.body = document.querySelector(Yl)),
                                (this.accessibility = window.accessibility),
                                this.container && ((this.scrollbarHolder = this.container.querySelectorAll(ac)), this.init(), this.initNativeScrollbar());
                        }
                    })(e)
                );
            });
        },
        onBlockSelect(e) {
            pc[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
            });
        },
    },
        fc = "[data-share-url]",
        gc = "data-section-type",
        yc = "[data-share-details]",
        vc = "[data-share-summary]",
        bc = "[data-share-copy]",
        wc = "[data-share-button]",
        Sc = "[data-close-button]",
        Ec = "[data-success-message]",
        Lc = "[data-share-holder]",
        kc = "is-hidden";
    let Tc = class extends HTMLElement {
        init() {
            navigator.share
                ? (this.mainDetailsToggle.classList.add(kc),
                    this.shareButton.classList.remove(kc),
                    this.shareButton.addEventListener("click", () => {
                        navigator.share({ url: this.urlToShare, title: document.title });
                    }))
                : (this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this)),
                    this.mainDetailsToggle.addEventListener("focusout", () => {
                        setTimeout(() => {
                            this.contains(document.activeElement) || this.close();
                        });
                    }),
                    this.shareCopy.addEventListener("click", this.copyToClipboard.bind(this)),
                    this.closeButton.addEventListener("click", this.close.bind(this)),
                    this.container.addEventListener("keyup", this.keyboardEvents.bind(this)));
        }
        updateShareLink() {
            "product" == this.container.getAttribute(gc) &&
                this.container.addEventListener("theme:variant:change", (e) => {
                    e.detail.variant && ((this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${e.detail.variant.id}`), this.urlInput && (this.urlInput.value = `${this.urlToShare.split("?")[0]}?variant=${e.detail.variant.id}`));
                });
        }
        toggleDetails() {
            this.mainDetailsToggle.open || (this.successMessage.classList.add(kc), (this.successMessage.textContent = ""), this.closeButton.classList.add(kc), this.shareCopy.focus());
        }
        copyToClipboard() {
            navigator.clipboard.writeText(this.urlInput.value).then(() => {
                this.successMessage.classList.remove(kc), (this.successMessage.textContent = theme.strings.successMessage), this.closeButton.classList.remove(kc), this.closeButton.focus();
            });
        }
        close() {
            this.mainDetailsToggle.removeAttribute("open"), this.shareSummary.setAttribute("aria-expanded", !1);
        }
        keyboardEvents(e) {
            "Escape" === e.code && (this.mainDetailsToggle.focus(), this.close());
        }
        constructor() {
            super(),
                (this.container = this.closest(`[${gc}]`)),
                (this.mainDetailsToggle = this.querySelector(yc)),
                (this.shareButton = this.querySelector(wc)),
                (this.shareCopy = this.querySelector(bc)),
                (this.shareSummary = this.querySelector(vc)),
                (this.closeButton = this.querySelector(Sc)),
                (this.successMessage = this.querySelector(Ec)),
                (this.shareHolder = this.querySelector(Lc)),
                (this.urlInput = this.querySelector(fc)),
                (this.urlToShare = this.urlInput ? this.urlInput.value : document.location.href),
                this.init(),
                this.updateShareLink();
        }
    };
    const xc = "data-image-filter",
        _c = "[data-product-slideshow]",
        Ac = "[data-product-thumbs]",
        qc = "[data-slideshow-thumbnail]",
        Cc = "[data-media-slide]",
        Pc = "hide",
        $c = "flickity-enabled";
    const Mc = "[data-size-button]",
        Ic = "[data-media-slide]",
        Dc = "is-expanded";
    let Oc = class {
        init() {
            this.sizeButtons.forEach((e) => {
                e.addEventListener("click", () => {
                    e.classList.toggle(Dc), e.closest(Ic).classList.toggle(Dc);
                });
            });
        }
        constructor(e) {
            (this.container = e), (this.sizeButtons = this.container.querySelectorAll(Mc)), this.sizeButtons.length > 0 && this.init();
        }
    };
    const Hc = "[data-product-json]",
        Fc = "[data-zoom-button]",
        Bc = "[data-truncated-holder]",
        Wc = "[data-truncated-button]",
        Nc = "data-truncated-content",
        Rc = "is-expanded",
        jc = "is-visible",
        zc = [];
    const Vc = {
        onLoad() {
            zc[this.id] = new (class {
                init() {
                    var e, t;
                    (this.zoomEnabled = null !== this.container.querySelector(Fc)),
                        this.zoomEnabled &&
                        ((e = this.container),
                            (t = this.product),
                            xe({ url: window.theme.assets.photoswipe })
                                .then(() => {
                                    const i = window.themePhotoswipe.PhotoSwipe.default,
                                        s = window.themePhotoswipe.PhotoSwipeUI.default;
                                    e.querySelectorAll(Jl).forEach((r) => {
                                        r.addEventListener("click", (r) => {
                                            const n = e.querySelector(Ql),
                                                o = r.target.closest(`[${Kl}]`).getAttribute(Kl).toString(),
                                                a = [];
                                            for (let e = 0; e < t.media.length; e++) "image" === t.media[e].media_type && (a[a.length] = { src: t.media[e].src, w: t.media[e].width, h: t.media[e].height, id: t.media[e].id });
                                            const l = {
                                                index: a.findIndex((e) => e.id.toString() === o),
                                                showHideOpacity: !0,
                                                showAnimationDuration: 150,
                                                hideAnimationDuration: 250,
                                                bgOpacity: 1,
                                                spacing: 0,
                                                allowPanToNext: !1,
                                                maxSpreadZoom: 3,
                                                history: !1,
                                                loop: !0,
                                                pinchToClose: !1,
                                                modal: !1,
                                                closeOnScroll: !1,
                                                closeOnVerticalDrag: !0,
                                                getDoubleTapZoom: function (e, t) {
                                                    return e ? 1.67 : t.initialZoomLevel < 0.7 ? 1 : 1.3;
                                                },
                                                getThumbBoundsFn: function () {
                                                    let t = e.querySelector(Ul);
                                                    t || (t = e.querySelector(Gl));
                                                    const i = window.pageYOffset || document.documentElement.scrollTop,
                                                        s = t.getBoundingClientRect();
                                                    return { x: s.left, y: s.top + i, w: s.width };
                                                },
                                            };
                                            n.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                                            const c = new i(n, s, a, l);
                                            c.init(),
                                                c.listen("close", function () {
                                                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                                });
                                        });
                                    });
                                })
                                .catch((e) => console.error(e))),
                        this.truncateElementHolder && this.truncateElement && (setTimeout(this.resizeEventTruncate, 50), document.addEventListener("theme:resize", this.resizeEventTruncate)),
                        new Oc(this.container);
                }
                truncateText() {
                    if (this.truncateElementHolder.classList.contains(jc)) return;
                    const e = this.truncateElement.querySelectorAll("style");
                    e.length &&
                        e.forEach((e) => {
                            this.truncateElementHolder.prepend(e);
                        });
                    const t = this.truncateElement.cloneNode(!0),
                        i = this.truncateElement.getAttribute(Nc),
                        s = this.truncateElement.nextElementSibling;
                    s && s.remove(), this.truncateElement.parentElement.append(t);
                    const r = this.truncateElement.nextElementSibling;
                    r.classList.add(i),
                        r.removeAttribute(Nc),
                        W(r),
                        ((e = "", t = 1, i = {}) => {
                            const s = { replaceStr: "...", debounceDelay: 250, delimiter: " ", ...i },
                                r = e && (e instanceof NodeList ? e : 1 === e.nodeType ? [e] : document.querySelectorAll(e));
                            for (let e = 0; e < r.length; e++) {
                                const i = r[e],
                                    n = /<!--[\s\S]*?-->/g,
                                    o = i.innerHTML.replace(n, "").split(s.delimiter);
                                i.innerHTML = "";
                                const a = window.getComputedStyle(i);
                                o.reduce(ua, { el: i, buffer: i.innerHTML, elStyle: a, elHeight: 0, rowsLimit: t, rowsWrapped: 0, options: s });
                            }
                        })(r, 5, { replaceStr: "", delimiter: " " }),
                        Br(r),
                        this.truncateElement.innerHTML !== r.innerHTML ? this.truncateElementHolder.classList.add(Rc) : (r.remove(), this.truncateElementHolder.classList.remove(Rc)),
                        this.toggleTruncatedContent(this.truncateElementHolder);
                }
                toggleTruncatedContent(e) {
                    const t = e.querySelector(Wc);
                    t &&
                        t.addEventListener("click", (t) => {
                            t.preventDefault(), e.classList.remove(Rc), e.classList.add(jc);
                        });
                    const n = e.querySelector('.read-less');
                    n &&
                        n.addEventListener("click", (t) => {
                            t.preventDefault(), e.classList.add(Rc), e.classList.remove(jc);
                        });
                }
                onBlockSelect(e) {
                    const t = this.container.querySelector(`[data-block-id="${e.detail.blockId}"]`);
                    t && t.dispatchEvent(new Event("click"));
                }
                onBlockDeselect(e) {
                    const t = this.container.querySelector(`[data-block-id="${e.detail.blockId}"]`);
                    t && t.dispatchEvent(new Event("click"));
                }
                onUnload() {
                    this.media.destroy(), this.truncateElementHolder && this.truncateElement && document.removeEventListener("theme:resize", this.resizeEventTruncate);
                }
                constructor(e) {
                    (this.section = e),
                        (this.id = e.id),
                        (this.container = e.container),
                        (this.settings = e.settings),
                        li(this.id),
                        (this.media = new $a(e)),
                        new (class {
                            listen() {
                                this.container.addEventListener("theme:variant:change", (e) => {
                                    jQuery('.custom_product_images .product__grid .product__media.MT__image:first-child .custom_image_wrapper img').attr('src', e.detail.variant.featured_image.src);
                                    jQuery('.custom_product_images .product__grid .product__media.MT__image:first-child .custom_image_wrapper img').attr('srcset', e.detail.variant.featured_image.src);
                                    jQuery('.custom_product_images .product__grid .product__media.MT__image:first-child').attr('data-media-src-placeholder', e.detail.variant.featured_image.src);

                                    e.detail.variant && ((this.variantImage = e.detail.variant.featured_image), this.filterImages());
                                });
                            }
                            filterImages() {
                                null !== this.variantImage && null !== this.variantImage.alt ? ((this.variantImageAlt = this.variantImage.alt.split("#")[1]), this.showImages()) : this.resetImages(), this.refreshSliders();
                            }
                            resetImages() {
                                this.thumbs.forEach((e) => e.classList.remove(Pc)), this.slides.forEach((e) => e.classList.remove(Pc));
                            }
                            showImages() {
                                this.thumbs.forEach((e) => {
                                    "" === e.getAttribute(xc) || e.getAttribute(xc) === this.variantImageAlt ? e.classList.remove(Pc) : e.classList.add(Pc);
                                }),
                                    this.slides.forEach((e) => {
                                        "" === e.getAttribute(xc) || e.getAttribute(xc) === this.variantImageAlt ? e.classList.remove(Pc) : e.classList.add(Pc);
                                    });
                            }
                            refreshSliders() {
                                if (null !== this.slider && this.slider.classList.contains($c)) {
                                    const e = t.data(this.slider);
                                    void 0 !== e && e.reloadCells();
                                }
                                if (null !== this.thumbSlider && this.thumbSlider.classList.contains($c)) {
                                    const e = c.data(this.thumbSlider);
                                    void 0 !== e && e.reloadCells();
                                }
                            }
                            constructor(e) {
                                (this.section = e),
                                    (this.container = e.container),
                                    (this.slider = this.container.querySelector(_c)),
                                    (this.thumbSlider = this.container.querySelector(Ac)),
                                    (this.thumbs = this.container.querySelectorAll(qc)),
                                    (this.slides = this.container.querySelectorAll(Cc)),
                                    (this.variantImage = null),
                                    this.listen();
                            }
                        })(e);
                    const i = this.container.querySelector(Hc);
                    i && "" !== i.innerHTML
                        ? ((this.product = JSON.parse(i.innerHTML)),
                            (this.truncateElementHolder = this.container.querySelector(Bc)),
                            (this.truncateElement = this.container.querySelector(`[${Nc}]`)),
                            (this.resizeEventTruncate = () => this.truncateText()),
                            this.init())
                        : console.error("Missing product JSON");
                }
            })(this);
        },
        onUnload() {
            "function" == typeof zc[this.id].unload && zc[this.id].unload();
        },
        onBlockSelect(e) {
            "function" == typeof zc[this.id].onBlockSelect && zc[this.id].onBlockSelect(e);
        },
        onBlockDeselect(e) {
            "function" == typeof zc[this.id].onBlockDeselect && zc[this.id].onBlockDeselect(e);
        },
    };
    Gt("product", [Vc, za, Fr, mc, $e]),
        customElements.get("product-form") || customElements.define("product-form", zl),
        customElements.get("product-complimentary") || customElements.define("product-complimentary", Vl),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Ue),
        customElements.get("popout-select") || customElements.define("popout-select", xr),
        customElements.get("share-button") || customElements.define("share-button", Tc);
    const Uc = "data-toggle-grid",
        Gc = "data-grid-large",
        Jc = "data-grid-small",
        Qc = "is-active",
        Kc = window.theme.sizes.small;
    var Yc = {};
    const Xc = {
        onLoad() {
            Yc[this.id] = [];
            this.container.querySelectorAll(`[${Uc}]`).forEach((e) => {
                Yc[this.id].push(
                    new (class {
                        init() {
                            this.toggle.addEventListener("click", this.toggleFunction), document.addEventListener("theme:resize:width", this.toggleFunction), this.toggleEvent(!1);
                        }
                        unload() {
                            this.toggle.removeEventListener("click", this.toggleFunction), document.removeEventListener("theme:resize:width", this.toggleFunction);
                        }
                        toggleEvent(e = !0) {
                            const t = e && "click" === e.type,
                                i = window.innerWidth >= Kc ? Gc : Jc,
                                s = this.container.querySelector(`[${i}]`),
                                r = s.getAttribute(i),
                                n = this.toggle.parentElement.querySelector(`[${Uc}].${Qc}`);
                            let o = this.toggle.parentElement.querySelector(`[${Uc}="${r}"]`);
                            t && ((o = this.toggle), s.setAttribute(i, this.value)), n && n.classList.remove(Qc), o && o.classList.add(Qc);
                        }
                        constructor(e, t) {
                            (this.container = t || document), (this.toggle = e), (this.value = this.toggle.getAttribute(Uc)), (this.toggleFunction = (e) => this.toggleEvent(e)), this.init();
                        }
                    })(e, this.container)
                );
            });
        },
        onUnload: function () {
            Yc[this.id].forEach((e) => {
                "function" == typeof e.unload && e.unload();
            });
        },
    },
        Zc = "data-sort-enabled",
        eh = "[data-sort-link]",
        th = "[data-sort-button-text]",
        ih = "data-value",
        sh = "popout-list__item--current";
    var rh = "data-swatch";
    Gt("collection", [
        {
            onLoad() {
                this.collection = new (class {
                    init() {
                        new (class {
                            init() {
                                this.sortLinks.forEach((e) => {
                                    e.addEventListener("click", (e) => {
                                        e.preventDefault(), this.sortingResults(e);
                                    });
                                });
                            }
                            sortingResults(e) {
                                const t = e.currentTarget,
                                    i = t.getAttribute(ih),
                                    s = t.innerText;
                                (this.sortButtonText.innerText = s),
                                    this.sortButtonText.parentNode.dispatchEvent(new Event("click")),
                                    this.sort.querySelector(`.${sh}`).classList.remove(sh),
                                    t.parentNode.classList.add(sh),
                                    this.sort.setAttribute(Zc, i),
                                    this.container.dispatchEvent(new CustomEvent("theme:form:filter", { bubbles: !0, detail: { params: i } }));
                            }
                            constructor(e) {
                                (this.container = e.container),
                                    (this.sort = this.container.querySelector(`[${Zc}]`)),
                                    (this.sortLinks = this.container.querySelectorAll(eh)),
                                    (this.sortButtonText = this.container.querySelector(th)),
                                    this.sort && this.init();
                            }
                        })(this.section);
                    }
                    constructor(e) {
                        (this.section = e), (this.container = this.section.container), (this.swatches = this.container.querySelectorAll(`[${rh}]`)), this.init();
                    }
                })(this);
            },
        },
        ea,
        oa,
        Xc,
        Je,
        Fr,
        K,
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", xr),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Ue),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Js),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", cr),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", ur),
        Gt("collection-row", [Je, K, tt]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Ue),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Js),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", cr),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", ur),
        Gt("collection-tabs", [mc, mo, Je]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Ue),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Js),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", cr),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", ur);
    var nh = {};
    function oh(e) {
        return nh[e];
    }
    (nh.basic = []),
        (nh.light = [
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "on" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "simplified" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (nh.light_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }, { visibility: "off" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (nh.white_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#444444" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (nh.white_label = [
            { featureType: "all", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ gamma: "3.86" }, { lightness: "100" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#cccccc" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels.text", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (nh.dark_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (nh.dark_label = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "simplified" }, { lightness: "-82" }] },
            { featureType: "administrative", elementType: "labels.text.stroke", stylers: [{ invert_lightness: !0 }, { weight: "7.15" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (window.theme.allMaps = window.theme.allMaps || {});
    let ah = window.theme.allMaps;
    const lh = "[data-map-container]",
        ch = "data-style",
        hh = "data-api-key",
        dh = "data-zoom",
        uh = "data-address",
        ph = "data-latlong-correction",
        mh = "data-lat",
        fh = "data-long";
    const gh = {
        onLoad() {
            ah[this.id] = new (class {
                initMaps() {
                    xe({ url: `https://maps.googleapis.com/maps/api/js?key=${this.key}` })
                        .then(() => {
                            return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long
                                ? new window.google.maps.LatLng(this.lat, this.long)
                                : ((e = this.address),
                                    new Promise((t, i) => {
                                        new window.google.maps.Geocoder().geocode({ address: e }, function (e, s) {
                                            if ("OK" == s) {
                                                var r = { lat: e[0].geometry.location.lat(), lng: e[0].geometry.location.lng() };
                                                t(r);
                                            } else i(s);
                                        });
                                    }));
                            var e;
                        })
                        .then((e) => {
                            var t = { zoom: parseInt(this.zoomString, 10), styles: oh(this.styleString), center: e, draggable: !0, clickableIcons: !1, scrollwheel: !1, zoomControl: !1, disableDefaultUI: !0 };
                            const i = (function (e, t) {
                                var i = new window.google.maps.Map(e, t),
                                    s = i.getCenter();
                                return (
                                    new window.google.maps.Marker({ map: i, position: s }),
                                    window.google.maps.event.addDomListener(window, "resize", function () {
                                        window.google.maps.event.trigger(i, "resize"), i.setCenter(s);
                                    }),
                                    i
                                );
                            })(this.mapWrap, t);
                            return i;
                        })
                        .then((e) => {
                            (this.map = e), (ah[this.id] = e);
                        })
                        .catch((e) => {
                            console.error("Failed to load Google Map"), console.error(e);
                        });
                }
                onUnload() {
                    void 0 !== window.google && window.google.maps.event.clearListeners(this.map, "resize");
                }
                constructor(e) {
                    (this.container = e.container),
                        (this.mapWrap = this.container.querySelector(lh)),
                        (this.styleString = this.container.getAttribute(ch) || ""),
                        (this.key = this.container.getAttribute(hh)),
                        (this.zoomString = this.container.getAttribute(dh) || 14),
                        (this.address = this.container.getAttribute(uh)),
                        (this.enableCorrection = this.container.getAttribute(ph)),
                        (this.lat = this.container.getAttribute(mh)),
                        (this.long = this.container.getAttribute(fh)),
                        this.key && this.initMaps();
                }
            })(this);
        },
        onUnload() {
            "function" == typeof ah[this.id].unload && ah[this.id].unload();
        },
    };
    Gt("section-map", gh), Gt("section-columns", [eo, tt]);
    const yh = "[data-related-section]",
        vh = "[data-grid-item]",
        bh = "[data-carousel]",
        wh = "data-limit",
        Sh = "data-minimum",
        Eh = "data-layout-desktop",
        Lh = "data-layout-tablet",
        kh = "data-layout-mobile",
        Th = "[data-recent-wrapper]",
        xh = "[data-recently-viewed-wrapper]",
        _h = "data-product-id";
    Gt("related", [
        {
            onLoad() {
                this.section = new (class {
                    init() {
                        const e = this.container.querySelector(yh);
                        if (!e) return;
                        const t = e.getAttribute(_h),
                            i = e.getAttribute(wh),
                            s = e.getAttribute(Eh),
                            r = e.getAttribute(Lh),
                            n = e.getAttribute(kh),
                            o = `${window.theme.routes.product_recommendations_url || "/recommendations/products/"}?section_id=related&limit=${i}&product_id=${t}`;
                        l.get(o)
                            .then((t) => {
                                const i = document.createElement("div");
                                i.innerHTML = t.data;
                                const o = i.querySelector(yh);
                                if (o.querySelector(vh)) {
                                    const t = o.innerHTML;
                                    (e.innerHTML = t),
                                        e.querySelector(bh).style.setProperty("--grid-large-items", s),
                                        e.querySelector(bh).style.setProperty("--grid-medium-items", r),
                                        e.querySelector(bh).style.setProperty("--grid-small-items", n),
                                        e.dispatchEvent(new CustomEvent("theme:related-products:added", { bubbles: !0 }));
                                } else e.dispatchEvent(new CustomEvent("theme:tabs:hide", { bubbles: !0 }));
                            })
                            .catch(function (e) {
                                console.warn(e);
                            });
                    }
                    recent() {
                        const e = this.container.querySelector(Th),
                            t = this.container.querySelector(xh),
                            i = this.container.querySelectorAll(vh),
                            s = e.hasAttribute(Sh) ? parseInt(e.getAttribute(Sh)) : 4,
                            r = !t && i.length > 0,
                            n = t && i.length >= s;
                        (r || n) && e.dispatchEvent(new CustomEvent("theme:tabs:check", { bubbles: !0 }));
                    }
                    constructor(e) {
                        (this.section = e),
                            (this.container = e.container),
                            this.init(),
                            this.container.addEventListener("theme:recent-products:added", () => {
                                this.recent();
                            });
                    }
                })(this);
            },
        },
        mc,
        fe,
    ]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Ue),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Js),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", cr),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", ur);
    const Ah = "[data-cart-note]";
    class qh {
        initInputs() {
            this.inputs.forEach((e) => {
                e.addEventListener(
                    "input",
                    T(
                        function (e) {
                            const t = e.target.value.toString() || "";
                            this.saveNotes(t);
                        }.bind(this),
                        300
                    )
                );
            });
        }
        saveNotes(e) {
            window.fetch(`${window.theme.routes.cart}/update.js`, { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ note: e }) }).catch((e) => {
                console.error(e);
            });
        }
        constructor(e) {
            (this.inputs = e.querySelectorAll(Ah)), this.initInputs();
        }
    }
    const Ch = (e, t = [], i = !1) => {
        const s = Object.keys(e)
            .map((s) => {
                let r = e[s];
                if ("[object Object]" === Object.prototype.toString.call(r) || Array.isArray(r)) return Array.isArray(e) ? t.push("") : t.push(s), Ch(r, t, Array.isArray(r));
                {
                    let e = s;
                    if (t.length > 0) {
                        e = (i ? t : [...t, s]).reduce((e, t) => ("" === e ? t : `${e}[${t}]`), "");
                    }
                    return i ? `${e}[]=${r}` : `${e}=${r}`;
                }
            })
            .join("&");
        return t.pop(), s;
    },
        Ph = "html",
        $h = "[data-submit-shipping]",
        Mh = "[data-shipping-estimate-form]",
        Ih = "[data-response-template]",
        Dh = "#estimate_address_country",
        Oh = "#estimate_address_province",
        Hh = "#estimate_address_zip",
        Fh = "[data-response-wrapper]",
        Bh = "lang",
        Wh = "data-default",
        Nh = "shipping--success",
        Rh = "errors",
        jh = "disabled";
    class zh {
        enableButtons() {
            this.button.removeAttribute("disabled"), this.button.classList.remove(jh);
        }
        disableButtons() {
            this.button.setAttribute("disabled", "disabled"), this.button.classList.add(jh);
        }
        render(e) {
            if (this.template && this.ratesWrapper) {
                const t = u.render(this.template, e);
                this.ratesWrapper.innerHTML = t;
            }
            this.enableButtons(), this.ratesWrapper.style.removeProperty("display");
        }
        estimate(e) {
            const t = encodeURI(Ch({ shipping_address: e })),
                i = `${window.theme.routes.cart}/shipping_rates.json?${t}`,
                s = this;
            l.get(i)
                .then(function (e) {
                    const t = s.sanitize(e);
                    s.render(t), s.enableButtons(), s.ratesWrapper.style.removeProperty("display");
                })
                .catch(function (e) {
                    const t = s.sanitizeErrors(e);
                    s.render(t);
                });
        }
        sanitize(e) {
            const t = {};
            if (((t.class = Nh), (t.items = []), e.data.shipping_rates && e.data.shipping_rates.length > 0)) {
                e.data.shipping_rates.forEach((e) => {
                    let i = {};
                    (i.title = e.presentment_name), (i.value = a.formatMoney(e.price, theme.moneyFormat)), t.items.push(i);
                });
            } else t.items[0] = { value: theme.strings.noShippingAvailable };
            return t;
        }
        sanitizeErrors(e) {
            const t = {};
            if (((t.class = Rh), (t.items = []), "object" == typeof e.data))
                for (const [i, s] of Object.entries(e.data)) {
                    let e = {};
                    (e.title = i.toString()), (e.value = s.toString()), t.items.push(e);
                }
            else t.items[0] = { value: theme.strings.noShippingAvailable };
            return t;
        }
        init() {
            const e = document.querySelector(Ph);
            let t = "en";
            e.hasAttribute(Bh) && "" !== e.getAttribute(Bh) && (t = e.getAttribute(Bh)),
                this.form && h.AddressForm(this.form, t, { shippingCountriesOnly: !0 }),
                this.country &&
                this.country.hasAttribute(Wh) &&
                this.province &&
                this.province.hasAttribute(Wh) &&
                this.country.addEventListener("change", function () {
                    this.country.removeAttribute(Wh), this.province.removeAttribute(Wh);
                }),
                this.button &&
                this.button.addEventListener(
                    "click",
                    function (e) {
                        for (e.preventDefault(), this.disableButtons(); this.ratesWrapper.firstChild;) this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
                        this.ratesWrapper.style.display = "none";
                        const t = {};
                        let i = this.country.value,
                            s = this.province.value;
                        const r = this.country.getAttribute(Wh);
                        "" === i && r && "" !== r && (i = r);
                        const n = this.province.getAttribute(Wh);
                        "" === s && n && "" !== n && (s = n), (t.zip = this.zip.value || ""), (t.country = i || ""), (t.province = s || ""), this.estimate(t);
                    }.bind(this)
                );
        }
        constructor(e) {
            (this.button = e.container.querySelector($h)),
                (this.template = e.container.querySelector(Ih).innerHTML),
                (this.ratesWrapper = e.container.querySelector(Fh)),
                (this.form = e.container.querySelector(Mh)),
                (this.country = e.container.querySelector(Dh)),
                (this.province = e.container.querySelector(Oh)),
                (this.zip = e.container.querySelector(Hh)),
                this.init();
        }
    }
    const Vh = "[data-cart-message]",
        Uh = "data-cart-message",
        Gh = "[data-left-to-spend]",
        Jh = "[data-cart-progress]",
        Qh = "data-limit",
        Kh = "data-percent",
        Yh = "is-success";
    let Xh = class {
        init() {
            (this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute(Qh)) * this.rate),
                (this.shippingAmount = 0),
                (this.circumference = 28 * Math.PI),
                this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount),
                this.cartBarProgress(),
                this.listen();
        }
        listen() {
            document.addEventListener(
                "theme:cart:change",
                function (e) {
                    (this.cart = e.detail.cart), this.render();
                }.bind(this)
            );
        }
        render() {
            const e = this.cart.total_price;
            this.freeShippingMessageHandle(e), this.cart && this.cart.total_price && this.cartMessage.length > 0 && ((this.shippingAmount = e), this.updateProgress());
            this.freeShippingProgressHandle();
        }
        freeShippingMessageHandle(e) {
            this.cartMessage.length > 0 &&
                this.container.querySelectorAll(Vh).forEach((t) => {
                    const i = t.hasAttribute(Uh) && "true" === t.getAttribute(Uh) && e >= this.cartFreeLimitShipping && 0 !== e;
                    t.classList.toggle(Yh, i);
                });
        }
        freeShippingProgressHandle() {
            const freeShippingProgressElement = this.container.querySelector('.cart-shipping-progress');

            if (freeShippingProgressElement) {
                const limit = parseInt(freeShippingProgressElement.dataset.limit, 10);
                const difference = Math.max(limit - this.cart.total_price, 0);
                const fillPercentage = Math.max(100 - (Math.floor(difference / limit * 100)), 5);

                freeShippingProgressElement.querySelector('.cart-shipping-progress__fill').style.width = `${fillPercentage}%`;
            }
        }
        cartBarProgress(e = null) {
            this.container.querySelectorAll(Jh).forEach((t) => {
                this.setProgress(t, null === e ? t.getAttribute(Kh) : e);
            });
        }
        setProgress(e, t) {
            const i = this.circumference - ((t / 100) * this.circumference) / 2;
            e.style.strokeDashoffset = i;
        }
        updateProgress() {
            const e = (this.shippingAmount / this.cartFreeLimitShipping) * 100;
            this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount), this.cartBarProgress(e > 100 ? 100 : e);
        }
        exchangeRateConversions(e, t) {
            const i = theme.formatMoney(e - t);
            this.container.querySelectorAll(Gh).forEach((e) => {
                e.innerHTML = i;
            });
        }
        constructor(e) {
            (this.container = e), (this.cartMessage = this.container.querySelectorAll(Vh)), (this.rate = window.Shopify.currency.rate), this.cartMessage.length > 0 && this.init();
        }
    };
    const Zh = '[data-drawer="drawer-cart"]',
        ed = "[data-shipping-estimate-form]",
        td = "[data-cart-loading]",
        id = "[data-cart-form]",
        sd = "[data-cart-empty]",
        rd = "[data-cart-progress]",
        nd = "[data-line-items]",
        od = "[data-cart-subtotal]",
        ad = "[data-cart-bottom]",
        ld = "[data-form-errors]",
        cd = "[data-cart-item]",
        hd = "[data-cart-final]",
        cartShippingSelector= "[data-cart-shipping]",
        cartSavingsSelector = "[data-cart-savings]",
        dd = "data-update-cart",
        ud = "data-remove-key",
        pd = "[data-cart-page-upsell-wrapper]",
        md = '[data-section-type="cart"]',
        fd = "[data-cart-bar]",
        gd = "[data-cart-message]",
        yd = "[data-item-loadbar]",
        vd = "[data-cart-message-container]",
        bd = "[data-api-content]",
        wd = "cart--hidden",
        cartFooterActive = "[data-cart-bottom-active]",
        cartFooterEmpty = "[data-cart-bottom-empty]",
        Sd = "cart--loading";
    let Ed = class {
        listen() {
            document.addEventListener(
                "theme:cart:change",
                function (e) {
                    (this.cart = e.detail.cart), (this.stale = !0);
                }.bind(this)
            ),
                document.addEventListener(
                    "theme:cart:init",
                    function () {
                        this.init();
                    }.bind(this)
                ),
                document.addEventListener(
                    "theme:cart:reload",
                    function () {
                        (this.stale = !0), this.cart ? this.loadHTML() : this.init().then(() => this.loadHTML());
                    }.bind(this)
                ),
                this.drawer &&
                (this.drawer.addEventListener(
                    "theme:drawer:open",
                    function () {
                        this.cart ? this.loadHTML() : this.init().then(() => this.loadHTML()), (window.theme.state.cartOpen = !0);
                    }.bind(this)
                ),
                    this.drawer.addEventListener("theme:drawer:close", function () {
                        window.theme.state.cartOpen = !1;
                    })),
                new qh(this.container),
                new Xh(this.container);
        }
        init() {
            return window
                .fetch(`${window.theme.routes.cart}.js`)
                .then(this.handleErrors)
                .then((e) => e.json())
                .then((e) => ((this.cart = e), this.fireChange(e), e))
                .catch((e) => {
                    console.error(e);
                });
        }
        loadHTML(e = !1) {
            this.stale &&
                (this.cart && this.cart.item_count > 0
                    ? this.loadForm(e)
                    : (this.showEmpty(),
                        this.cartMessages.forEach((e) => {
                            new Xh(e);
                        }))),
                (this.stale = !1);
        }
        initInputs() {
            (this.inputs = this.container.querySelectorAll(`[${dd}]`)),
                this.inputs.forEach((e) => {
                    const t = e.getAttribute(dd);
                    e.addEventListener(
                        "change",
                        function (e) {
                            const i = parseInt(e.target.value, 10);
                            (this.latestClick = e.target.closest(cd)), this.lockState(), this.updateCart(t, i);
                        }.bind(this)
                    );
                });
        }
        initRemove() {
            (this.removers = this.container.querySelectorAll(`[${ud}]`)),
                this.removers.forEach((e) => {
                    const t = e.getAttribute(ud);
                    e.addEventListener(
                        "click",
                        function (e) {
                            e.preventDefault(), (this.latestClick = e.target.closest(cd)), this.lockState(), this.updateCart(t, 0);
                        }.bind(this)
                    );
                });
        }
        lockState() {
            (this.latestClick.querySelector(yd).style.display = "block"), this.loader.classList.add(Sd);
        }
        updateCart(e, t) {
            window
                .fetch(`${window.theme.routes.cart}/change.js`, { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: e, quantity: t }) })
                .then(this.handleErrors)
                .then((e) => e.json())
                .then((e) => {
                    (this.cart = e), Ar(this.errors), this.fireChange(e), (this.stale = !0), this.loadHTML();
                })
                .catch((e) => {
                    if (!(e instanceof N)) {
                        let t = `<p>${e.message || window.theme.strings.stockout || "Could not update cart, please reload"}</p>`;
                        throw (this.showError(t), e);
                    }
                    {
                        var t, i;
                        let s = `<p>${(null === (t = e.json) || void 0 === t ? void 0 : t.message) || e.message || window.theme.strings.stockout || "Could not update cart, please reload"}</p>`,
                            r = (null === (i = e.json) || void 0 === i ? void 0 : i.description) || "";
                        this.showError([s, r].join(" ")), this.loadForm();
                    }
                });
        }
        fireChange(e) {
            document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: e }, bubbles: !0 }));
        }
        updateTotal() {
            if (this.cart && null != this.cart.total_price) {
                const e = a.formatMoney(this.cart.total_price, theme.moneyFormat);
                this.finalPrice.innerHTML = e;
            }
            this.subtotal &&
                this.cart &&
                window
                    .fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`)
                    .then(this.handleErrors)
                    .then((e) => e.text())
                    .then((e) => {
                        const t = document.createElement("div");
                        (t.innerHTML = e), (this.subtotal.innerHTML = t.querySelector(bd).innerHTML);
                    });
        }
        updateShipping() {
            window.fetch(`${window.theme.routes.root_url}?section_id=api-cart-shipping`)
                .then(this.handleErrors)
                .then((e) => e.text())
                .then((e) => {
                    const t = document.createElement("div");
                    (t.innerHTML = e), (this.shipping.innerHTML = t.querySelector(bd).innerHTML);
                });
        }
        updateSavings() {
            window.fetch(`${window.theme.routes.root_url}?section_id=api-cart-savings`)
                .then(this.handleErrors)
                .then((e) => e.text())
                .then((e) => {
                    const t = document.createElement("div");
                    (t.innerHTML = e), (this.savings.innerHTML = t.querySelector(bd).innerHTML);
                });
        }
        showError(e) {
            Ar(this.errors),
                (this.errors.innerHTML = e),
                window.setTimeout(() => {
                    _r(this.errors);
                }, 600);
        }
        loadForm(e = !1) {
            if (e) return this.showForm(), this.initQuantity(), this.initQuickview(), void this.updateTotal(), void this.updateShipping(), void this.updateSavings();
            window
                .fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`)
                .then(this.handleErrors)
                .then((e) => e.text())
                .then((e) => {
                    const t = document.createElement("div");
                    (t.innerHTML = e), (this.items.innerHTML = t.querySelector(bd).innerHTML), this.showForm(), this.initQuantity(), this.initQuickview(), this.updateTotal(), this.updateShipping(), this.updateSavings();
                });
        }
        initQuickview() {
            const e = this.items.querySelector(pd),
                t = this.bottom.querySelector(pd);
            t && t.remove(), this.cartPage && e && (this.bottom.insertBefore(e, this.bottom.firstChild), Alpine.initTree(this.bottom));
        }
        initQuantity() {
            Qa(this.container), this.initInputs(), this.initRemove();
        }
        showForm() {
            this.bar && this.bar.classList.remove(wd),
                // this.ship && this.ship.classList.remove(wd),
                this.progress && this.progress.classList.remove(wd),
                this.form.classList.remove(wd),
                // this.bottom.classList.remove(wd),
                this.bottomActive.classList.remove(wd),
                this.loader.classList.remove(Sd),
                this.bottomEmpty.classList.add(wd),
                this.emptystate.classList.add(wd);
        }
        showEmpty() {
            this.bar && this.bar.classList.add(wd),
                // this.ship && this.ship.classList.add(wd),
                this.progress && this.progress.classList.add(wd),
                this.emptystate.classList.remove(wd),
                this.loader.classList.remove(Sd),
                // this.bottom.classList.add(wd),
                this.bottomActive.classList.add(wd),
                this.bottomEmpty.classList.remove(wd),
                this.form.classList.add(wd);
        }
        handleErrors(e) {
            return e.ok
                ? e
                : e.json().then(function (t) {
                    throw new N({ status: e.statusText, headers: e.headers, json: t });
                });
        }
        constructor(e) {
            (this.section = e),
                (this.container = e.container),
                (this.cartMessages = document.querySelectorAll(vd)),
                (this.bar = this.container.querySelector(fd)),
                (this.ship = this.container.querySelector(gd)),
                (this.drawer = this.container.querySelector(Zh)),
                (this.form = this.container.querySelector(id)),
                (this.loader = this.container.querySelector(td)),
                (this.bottom = this.container.querySelector(ad)),
                (this.bottomActive = this.container.querySelector(cartFooterActive)),
                (this.bottomEmpty = this.container.querySelector(cartFooterEmpty)),
                (this.items = this.container.querySelector(nd)),
                (this.subtotal = this.container.querySelector(od)),
                (this.errors = this.container.querySelector(ld)),
                (this.finalPrice = this.container.querySelector(hd)),
                (this.shipping = this.container.querySelector(cartShippingSelector)),
                (this.savings = this.container.querySelector(cartSavingsSelector)),
                (this.emptystate = this.container.querySelector(sd)),
                (this.progress = this.container.querySelector(rd)),
                (this.latestClick = null),
                (this.cart = null),
                (this.stale = !0),
                (this.cartPage = document.querySelector(md)),
                this.listen();
        }
    };
    const Ld = {
        onLoad() {
            document.querySelector(Zh) && (this.cart = new Ed(this));
            this.container.querySelector(ed) && new zh(this);
        },
        onUnload: function () {
            this.cart && "function" == typeof this.cart.unload && this.cart.unload();
        },
    },
        kd = { ajaxDisable: "data-ajax-disable", shipping: "[data-shipping-estimate-form]", input: "[data-update-cart]", update: "[data-update-button]", bottom: "[data-cart-bottom]", upsellWrapper: "[data-cart-page-upsell-wrapper]" },
        Td = "cart--dirty",
        xd = "heart-beat",
        _d = {
            onLoad() {
                if ((this.container.querySelector(kd.shipping) && new zh(this), (this.disabled = "true" == this.container.getAttribute(kd.ajaxDisable)), this.disabled)) return void (this.cart = new Ad(this));
                this.cart = new Ed(this);
                this.cart.init().then(() => {
                    this.cart.loadHTML(!0);
                });
            },
        };
    let Ad = class {
        initQuantity() {
            Qa(this.container);
        }
        moveUpsell() {
            const e = this.container.querySelector(kd.bottom);
            e.insertBefore(this.upsellWrapper, e.firstChild);
        }
        initInputs() {
            this.inputs.forEach((e) => {
                e.addEventListener(
                    "change",
                    function () {
                        this.updateBtn.classList.add(Td),
                            this.updateBtn.classList.add(xd),
                            setTimeout(
                                function () {
                                    this.updateBtn.classList.remove(xd);
                                }.bind(this),
                                1300
                            );
                    }.bind(this)
                );
            });
        }
        constructor(e) {
            (window.theme.state.cartOpen = !0),
                (this.section = e),
                (this.container = e.container),
                (this.inputs = this.container.querySelectorAll(kd.input)),
                (this.quantityWrappers = this.container.querySelectorAll(kd.qty)),
                (this.updateBtn = this.container.querySelector(kd.update)),
                (this.upsellWrapper = this.container.querySelector(kd.upsellWrapper)),
                this.initQuantity(),
                this.initInputs(),
                this.upsellWrapper && this.moveUpsell(),
                document.addEventListener(
                    "theme:cart:reload",
                    function () {
                        window.location.reload();
                    }.bind(this)
                );
        }
    };
    Gt("cart", [_d, Fr]), Gt("cart-drawer", [zi, Ld, Fr]), Gt("accordion-single", Fr);
    const qd = (e, t, i = null) => {
        (e.style.opacity = 0),
            (e.style.display = t || "block"),
            (function t() {
                let s = parseFloat(e.style.opacity);
                (s += 0.1) > 1 || ((e.style.opacity = s), requestAnimationFrame(t)), 1 === s && "function" == typeof i && i();
            })();
    },
        Cd = (e, t = null) => {
            (e.style.opacity = 1),
                (function i() {
                    (e.style.opacity -= 0.1) < 0 ? (e.style.display = "none") : requestAnimationFrame(i), 0 === parseFloat(e.style.opacity) && "function" == typeof t && t();
                })();
        },
        Pd = "[data-tracking-consent]",
        $d = "[data-confirm-cookies]",
        Md = "[data-close-modal]",
        Id = "[data-popup-inner]",
        Dd = "[data-newsletter]",
        Od = "[data-newsletter-holder]",
        Hd = "[data-newsletter-field]",
        Fd = "[data-newsletter-form]",
        Bd = "[data-promo-text]",
        Wd = "data-popup-delay",
        Nd = "data-cookie-name",
        Rd = "data-target-referrer",
        jd = "has-value",
        zd = "has-success",
        Vd = "has-error",
        Ud = "desktop",
        Gd = "mobile";
    let Jd = {},
        Qd = class {
            write() {
                ((-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((e) => e.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) &&
                    (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
            }
            read() {
                if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((e) => e.startsWith(this.name))) {
                    return document.cookie
                        .split("; ")
                        .find((e) => e.startsWith(this.name))
                        .split("=")[1];
                }
                return !1;
            }
            destroy() {
                document.cookie.split("; ").find((e) => e.startsWith(this.name)) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
            }
            constructor(e, t) {
                (this.configuration = { expires: null, path: "/", domain: window.location.hostname }), (this.name = e), (this.value = t);
            }
        },
        Kd = class {
            hide() {
                this.show = !1;
            }
            always() {
                this.show && qd(this.element);
            }
            delayed() {
                setTimeout(() => {
                    this.always();
                }, 1e4);
            }
            bottom() {
                let e;
                const t = () => {
                    e && window.cancelAnimationFrame(e),
                        (e = window.requestAnimationFrame(() => {
                            window.requestIdleCallback(
                                () => {
                                    Math.round(window.scrollY + window.innerHeight) >= Math.round(document.body.clientHeight) && (this.always(), window.removeEventListener("scroll", t, { passive: !0 }));
                                },
                                { timeout: 300 }
                            );
                        }));
                };
                window.addEventListener("scroll", t, { passive: !0 });
            }
            onScroll() { }
            idle() {
                let e = 0;
                const t = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        (e = setTimeout(() => {
                            (e = 0), this.always();
                        }, 6e4)),
                            t.forEach((e) => {
                                document.addEventListener(e, r);
                            }),
                            i.forEach((e) => {
                                window.addEventListener(e, r);
                            });
                    },
                    r = () => {
                        e && clearTimeout(e),
                            t.forEach((e) => {
                                document.removeEventListener(e, r);
                            }),
                            i.forEach((e) => {
                                window.removeEventListener(e, r);
                            }),
                            s();
                    };
                s();
            }
            constructor(e, t) {
                (this.show = !0),
                    (this.element = t),
                    (this.delay = e.getAttribute(Wd)),
                    "always" === this.delay && this.always(),
                    "delayed" === this.delay && this.delayed(),
                    "bottom" === this.delay && this.bottom(),
                    "idle" === this.delay && this.idle();
            }
        },
        Yd = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(Rd)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el);
            }
            constructor(e) {
                (this.el = e), (this.locationPath = location.href), this.el.hasAttribute(Rd) && this.init();
            }
        };
    Gt("popups", [
        Pn,
        {
            onLoad() {
                Jd[this.id] = [];
                this.container.querySelectorAll(Pd).forEach((e) => {
                    Jd[this.id].push(
                        new (class {
                            init() {
                                this.showPopup && qd(this.modalInner), this.clickEvents();
                            }
                            clickEvents() {
                                this.close.addEventListener("click", (e) => {
                                    e.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, () => Cd(this.modalInner));
                                }),
                                    this.acceptButton.addEventListener("click", (e) => {
                                        e.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, () => Cd(this.modalInner));
                                    }),
                                    document.addEventListener("trackingConsentAccepted", function () {
                                        console.log("trackingConsentAccepted event fired");
                                    });
                            }
                            onBlockSelect(e) {
                                this.popup.contains(e.target) && this.showPopup && qd(this.modalInner);
                            }
                            onBlockDeselect(e) {
                                this.popup.contains(e.target) && Cd(this.modalInner);
                            }
                            constructor(e) {
                                /*(this.popup = e),
                                    (this.modal = document.querySelector(Pd)),
                                    (this.modalInner = this.popup.querySelector(Id)),
                                    (this.close = this.modal.querySelector(Md)),
                                    (this.acceptButton = this.modal.querySelector($d)),
                                    (this.enable = "true" === this.modal.getAttribute("data-enable")),
                                    (this.showPopup = !1),
                                    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (e) => {
                                        if (e) throw e;
                                        const t = window.Shopify.customerPrivacy.userCanBeTracked(),
                                            i = window.Shopify.customerPrivacy.getTrackingConsent();
                                        (this.showPopup = !t && "no_interaction" === i && this.enable), window.Shopify.designMode && (this.showPopup = !0), this.init();
                                    }); */
                            }
                        })(e)
                    );
                });
                this.container.querySelectorAll(Dd).forEach((e) => {
                    Jd[this.id].push(
                        new (class {
                            init() {
                                (!1 !== this.cookie.read() && !window.Shopify.designMode) || (this.show(), this.checkForSuccess());
                            }
                            show() {
                                window.Shopify.designMode ? qd(this.popupInner) : (this.delayShow = new Kd(this.popup, this.popupInner)), this.inputField(), this.closePopup();
                            }
                            preventDelayShow() {
                                this.delayShow && this.delayShow.hide();
                            }
                            checkForSuccess() {
                                const e = this.form.classList.contains(Vd),
                                    t = this.form.classList.contains(zd);
                                (t || e) && (qd(this.popupInner), this.preventDelayShow(), t && this.cookie.write());
                            }
                            closePopup() {
                                this.close.addEventListener("click", (e) => {
                                    e.preventDefault(), Cd(this.popupInner), this.cookie.write(), this.preventDelayShow();
                                });
                            }
                            inputField() {
                                this.newsletterField.addEventListener("input", () => {
                                    "" !== this.newsletterField.value && this.holder.classList.add(jd, "" !== this.newsletterField.value);
                                }),
                                    this.newsletterField.addEventListener("focus", () => {
                                        "" !== this.newsletterField.value && this.holder.classList.add(jd, "" !== this.newsletterField.value);
                                    }),
                                    this.newsletterField.addEventListener("focusout", () => {
                                        setTimeout(() => {
                                            this.holder.classList.remove(jd);
                                        }, 2e3);
                                    });
                            }
                            onBlockSelect(e) {
                                this.popup.contains(e.target) && qd(this.popupInner);
                            }
                            onBlockDeselect(e) {
                                this.popup.contains(e.target) && Cd(this.popupInner);
                            }
                            constructor(e) {
                                (this.popup = e),
                                    (this.popupInner = this.popup.querySelector(Id)),
                                    (this.holder = this.popup.querySelector(Od)),
                                    (this.close = this.popup.querySelector(Md)),
                                    (this.newsletterField = this.popup.querySelector(Hd)),
                                    (this.cookie = new Qd(this.popup.getAttribute(Nd), "newsletter_is_closed")),
                                    (this.form = this.popup.querySelector(Fd)),
                                    (this.isTargeted = new Yd(this.popup)),
                                    (this.delayShow = null),
                                    this.init();
                            }
                        })(e)
                    );
                });
                this.container.querySelectorAll(Bd).forEach((e) => {
                    Jd[this.id].push(
                        new (class {
                            init() {
                                (!1 !== this.cookie.read() && !window.Shopify.designMode) || (window.Shopify.designMode ? qd(this.popupInner) : new Kd(this.popup, this.popupInner), this.clickEvents());
                            }
                            clickEvents() {
                                this.close.addEventListener("click", (e) => {
                                    e.preventDefault(), Cd(this.popupInner), this.cookie.write();
                                });
                            }
                            onBlockSelect(e) {
                                this.popup.classList.contains(Gd) && (this.hasDeviceClass = Gd),
                                    this.popup.classList.contains(Ud) && (this.hasDeviceClass = Ud),
                                    "" !== this.hasDeviceClass && this.popup.classList.remove(this.hasDeviceClass),
                                    this.popup.contains(e.target) && qd(this.popupInner);
                            }
                            onBlockDeselect(e) {
                                this.popup.contains(e.target) && Cd(this.popupInner), "" !== this.hasDeviceClass && this.popup.classList.add(this.hasDeviceClass);
                            }
                            constructor(e) {
                                (this.popup = e),
                                    (this.popupInner = this.popup.querySelector(Id)),
                                    (this.close = this.popup.querySelector(Md)),
                                    (this.cookie = new Qd(this.popup.getAttribute(Nd), "user_has_closed")),
                                    (this.isTargeted = new Yd(this.popup)),
                                    (this.hasDeviceClass = ""),
                                    this.init();
                            }
                        })(e)
                    );
                });
            },
            onBlockSelect(e) {
                Jd[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                });
            },
            onBlockDeselect(e) {
                Jd[this.id].forEach((t) => {
                    "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                });
            },
        },
    ]);
    const Xd = "data-look-dot",
        Zd = "data-products-holder",
        eu = "[data-carousel]",
        tu = "[data-button-close-holder]",
        iu = "data-carousel-index",
        su = "data-block-id",
        ru = "button",
        nu = "is-active",
        ou = "is-expanded",
        au = {};
    Gt("look", [
        {
            onLoad() {
                (au[this.id] = []),
                    au[this.id].push(
                        new (class {
                            init() {
                                (this.keyEvents = (e) => this.keyboardEventShowProductHolder(e)),
                                    (this.keyCloseEvent = (e) => this.hideProductsHolder(e)),
                                    (this.clickEventsDot = (e) => this.clickEventShowProductsHolder(e)),
                                    (this.clickEventToClose = (e) => this.clickEventCloseProductsHolder(e)),
                                    (this.toggleOnResize = (e) => T(this.onResize(e), 200)),
                                    this.initSlider(),
                                    this.addEvents();
                            }
                            initSlider() {
                                this.slider &&
                                    ((this.carousel = s.data(this.slider)),
                                        (this.carousel.options.wrapAround = !0),
                                        (this.carousel.options.freeScroll = !1),
                                        this.carousel.resize(),
                                        this.carousel.on("change", (e) => {
                                            (this.currentDot = this.container.querySelector(`[${Xd}="${e}"]`)), this.currentDot.classList.add(nu), this.removeClassOnSiblingDots();
                                        }));
                            }
                            addEvents() {
                                this.dots.forEach((e) => {
                                    e.addEventListener("click", this.clickEventsDot), e.addEventListener("keyup", this.keyEvents);
                                }),
                                    document.addEventListener("keyup", this.keyCloseEvent),
                                    document.addEventListener("theme:resize", this.toggleOnResize),
                                    this.buttonClose && this.buttonClose.addEventListener("click", this.clickEventToClose);
                            }
                            showProductsHolder() {
                                const e = !this.productsHolder.classList.contains(ou);
                                this.currentDot.classList.toggle(nu),
                                    this.productsHolder.classList.toggle(ou, this.currentDot.classList.contains(nu)),
                                    this.currentDot.classList.contains(nu) && ((this.hasDefaultOpen = !0), this.carousel.selectCell(Number(this.currentDot.getAttribute(Xd)), !0, e)),
                                    this.removeClassOnSiblingDots();
                            }
                            hideProductsHolder(e) {
                                "Escape" === e.code && (this.removeClasses(), ni(), this.currentDot.focus());
                            }
                            removeClasses() {
                                this.productsHolder.classList.remove(ou), this.currentDot.classList.remove(nu), (this.hasDefaultOpen = !1);
                            }
                            clickEventShowProductsHolder(e) {
                                (this.currentDot = e.currentTarget), this.showProductsHolder();
                            }
                            clickEventCloseProductsHolder() {
                                this.removeClasses();
                            }
                            keyboardEventShowProductHolder(e) {
                                ("Enter" !== e.code && "Space" !== e.code) ||
                                    setTimeout(() => {
                                        const e = this.productsHolder.querySelector(ru);
                                        ri(this.productsHolder, { elementToFocus: e });
                                    }, 400);
                            }
                            onResize() {
                                this.currentDot &&
                                    (window.innerWidth < window.theme.sizes.medium
                                        ? (this.currentDot.classList.remove(nu), this.productsHolder.classList.remove(ou))
                                        : this.hasDefaultOpen && (this.currentDot.classList.add(nu), this.productsHolder.classList.add(ou)));
                            }
                            removeEvents() {
                                this.dots.forEach((e) => {
                                    e.removeEventListener("click", this.clickEventsDot), e.removeEventListener("keyup", this.keyEvents);
                                }),
                                    document.removeEventListener("keyup", this.keyCloseEvent),
                                    document.removeEventListener("theme:resize", this.toggleOnResize),
                                    this.buttonClose && this.buttonClose.removeEventListener("click", this.clickEventToClose);
                            }
                            removeClassOnSiblingDots() {
                                for (let e of this.currentDot.parentNode.children) e !== this.currentDot && e.classList.remove(nu);
                            }
                            onUnload() {
                                this.slider && this.carousel && this.carousel.destroy(), this.removeEvents();
                            }
                            onBlockSelect(e) {
                                if (this.slider && this.carousel) {
                                    const t = this.container.querySelector(`[${su}="${e.detail.blockId}"]`);
                                    this.productsHolder.classList.add(ou), this.carousel.selectCell(Number(t.getAttribute(iu)), !0, !0);
                                }
                            }
                            onBlockDeselect() {
                                window.innerWidth < window.theme.sizes.medium && (this.productsHolder.classList.remove(ou), this.currentDot.classList.remove(nu));
                            }
                            constructor(e) {
                                (this.section = e),
                                    (this.container = this.section.container),
                                    (this.dots = this.container.querySelectorAll(`[${Xd}]`)),
                                    (this.productsHolder = this.container.querySelector(`[${Zd}]`)),
                                    (this.slider = this.container.querySelector(eu)),
                                    (this.buttonClose = this.container.querySelector(tu)),
                                    (this.currentDot = this.container.querySelector(`[${Xd}].${nu}`)),
                                    (this.hasDefaultOpen = Boolean(this.currentDot)),
                                    this.init();
                            }
                        })(this)
                    );
            },
            onUnload() {
                au[this.id].forEach((e) => {
                    "function" == typeof e.onUnload && e.onUnload();
                });
            },
            onBlockSelect(e) {
                au[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                });
            },
            onBlockDeselect(e) {
                au[this.id].forEach((t) => {
                    "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                });
            },
        },
    ]);
    const lu = (e, t = "", i) => ((i = i || document.createElement("div")).classList.add(t), e.parentNode.insertBefore(i, e), i.appendChild(e));
    window.theme.settings.animate_scroll && e.init({ once: !0 }),
        document.addEventListener("DOMContentLoaded", function () {
            const e = document.querySelector("[data-header-height]");
            if (e) {
                const t = e.clientHeight || 0;
                document.documentElement.style.setProperty("--menu-height", `${t}px`);
            }
            Jt("*"), window.theme.settings.animate_hover && document.body.classList.add("theme-animate-hover");
            document.querySelectorAll(".rte table").forEach((e) => {
                lu(e, "rte__table-wrapper");
            });
            document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((e) => {
                lu(e, "rte__video-wrapper");
            }),
                document.addEventListener("mousedown", () => {
                    document.body.classList.remove("focus-enabled");
                }),
                document.addEventListener("keyup", (e) => {
                    "Tab" === e.code && document.body.classList.add("focus-enabled");
                }),
                window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")),
                ei(),
                ti(),
                "scrollBehavior" in document.documentElement.style || xe({ url: window.theme.assets.smoothscroll });
        });
    var cu = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"],
        hu = cu.join(","),
        du = "undefined" == typeof Element ? function () { } : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
        uu = function (e, t, i) {
            var s = Array.prototype.slice.apply(e.querySelectorAll(hu));
            return t && du.call(e, hu) && s.unshift(e), (s = s.filter(i));
        },
        pu = function (e) {
            var t = parseInt(e.getAttribute("tabindex"), 10);
            return isNaN(t)
                ? (function (e) {
                    return "true" === e.contentEditable;
                })(e)
                    ? 0
                    : ("AUDIO" !== e.nodeName && "VIDEO" !== e.nodeName && "DETAILS" !== e.nodeName) || null !== e.getAttribute("tabindex")
                        ? e.tabIndex
                        : 0
                : t;
        },
        mu = function (e, t) {
            return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
        },
        fu = function (e) {
            return "INPUT" === e.tagName;
        },
        gu = function (e) {
            return (
                (function (e) {
                    return fu(e) && "radio" === e.type;
                })(e) &&
                !(function (e) {
                    if (!e.name) return !0;
                    var t,
                        i = e.form || e.ownerDocument,
                        s = function (e) {
                            return i.querySelectorAll('input[type="radio"][name="' + e + '"]');
                        };
                    if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape) t = s(window.CSS.escape(e.name));
                    else
                        try {
                            t = s(e.name);
                        } catch (e) {
                            return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1;
                        }
                    var r = (function (e, t) {
                        for (var i = 0; i < e.length; i++) if (e[i].checked && e[i].form === t) return e[i];
                    })(t, e.form);
                    return !r || r === e;
                })(e)
            );
        },
        yu = function (e, t) {
            return !(
                t.disabled ||
                (function (e) {
                    return fu(e) && "hidden" === e.type;
                })(t) ||
                (function (e, t) {
                    if ("hidden" === getComputedStyle(e).visibility) return !0;
                    var i = du.call(e, "details>summary:first-of-type") ? e.parentElement : e;
                    if (du.call(i, "details:not([open]) *")) return !0;
                    if (t && "full" !== t) {
                        if ("non-zero-area" === t) {
                            var s = e.getBoundingClientRect(),
                                r = s.width,
                                n = s.height;
                            return 0 === r && 0 === n;
                        }
                    } else
                        for (; e;) {
                            if ("none" === getComputedStyle(e).display) return !0;
                            e = e.parentElement;
                        }
                    return !1;
                })(t, e.displayCheck) ||
                (function (e) {
                    return (
                        "DETAILS" === e.tagName &&
                        Array.prototype.slice.apply(e.children).some(function (e) {
                            return "SUMMARY" === e.tagName;
                        })
                    );
                })(t) ||
                (function (e) {
                    if (fu(e) || "SELECT" === e.tagName || "TEXTAREA" === e.tagName || "BUTTON" === e.tagName)
                        for (var t = e.parentElement; t;) {
                            if ("FIELDSET" === t.tagName && t.disabled) {
                                for (var i = 0; i < t.children.length; i++) {
                                    var s = t.children.item(i);
                                    if ("LEGEND" === s.tagName) return !s.contains(e);
                                }
                                return !0;
                            }
                            t = t.parentElement;
                        }
                    return !1;
                })(t)
            );
        },
        vu = function (e, t) {
            return !(!yu(e, t) || gu(t) || pu(t) < 0);
        },
        bu = function (e, t) {
            var i = [],
                s = [];
            return (
                uu(e, (t = t || {}).includeContainer, vu.bind(null, t)).forEach(function (e, t) {
                    var r = pu(e);
                    0 === r ? i.push(e) : s.push({ documentOrder: t, tabIndex: r, node: e });
                }),
                s
                    .sort(mu)
                    .map(function (e) {
                        return e.node;
                    })
                    .concat(i)
            );
        },
        wu = cu.concat("iframe").join(","),
        Su = function (e, t) {
            if (((t = t || {}), !e)) throw new Error("No node provided");
            return !1 !== du.call(e, wu) && yu(t, e);
        };
    function Eu(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            t &&
                (s = s.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                i.push.apply(i, s);
        }
        return i;
    }
    function Lu(e, t, i) {
        return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = i), e;
    }
    var ku,
        Tu =
            ((ku = []),
            {
                activateTrap: function (e) {
                    if (ku.length > 0) {
                        var t = ku[ku.length - 1];
                        t !== e && t.pause();
                    }
                    var i = ku.indexOf(e);
                    -1 === i || ku.splice(i, 1), ku.push(e);
                },
                deactivateTrap: function (e) {
                    var t = ku.indexOf(e);
                    -1 !== t && ku.splice(t, 1), ku.length > 0 && ku[ku.length - 1].unpause();
                },
            }),
        xu = function (e) {
            return setTimeout(e, 0);
        },
        _u = function (e, t) {
            var i = -1;
            return (
                e.every(function (e, s) {
                    return !t(e) || ((i = s), !1);
                }),
                i
            );
        },
        Au = function (e) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) i[s - 1] = arguments[s];
            return "function" == typeof e ? e.apply(void 0, i) : e;
        },
        qu = function (e, t) {
            var i,
                s = document,
                r = (function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var i = null != arguments[t] ? arguments[t] : {};
                        t % 2
                            ? Eu(Object(i), !0).forEach(function (t) {
                                Lu(e, t, i[t]);
                            })
                            : Object.getOwnPropertyDescriptors
                                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
                                : Eu(Object(i)).forEach(function (t) {
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
                                });
                    }
                    return e;
                })({ returnFocusOnDeactivate: !0, escapeDeactivates: !0, delayInitialFocus: !0 }, t),
                n = { containers: [], tabbableGroups: [], nodeFocusedBeforeActivation: null, mostRecentlyFocusedNode: null, active: !1, paused: !1, delayInitialFocusTimer: void 0 },
                o = function (e, t, i) {
                    return e && void 0 !== e[t] ? e[t] : r[i || t];
                },
                a = function (e) {
                    return n.containers.some(function (t) {
                        return t.contains(e);
                    });
                },
                l = function (e) {
                    var t = r[e];
                    if (!t) return null;
                    var i = t;
                    if ("string" == typeof t && !(i = s.querySelector(t))) throw new Error("`".concat(e, "` refers to no known node"));
                    if ("function" == typeof t && !(i = t())) throw new Error("`".concat(e, "` did not return a node"));
                    return i;
                },
                c = function () {
                    var e;
                    if (!1 === o({}, "initialFocus")) return !1;
                    if (null !== l("initialFocus")) e = l("initialFocus");
                    else if (a(s.activeElement)) e = s.activeElement;
                    else {
                        var t = n.tabbableGroups[0];
                        e = (t && t.firstTabbableNode) || l("fallbackFocus");
                    }
                    if (!e) throw new Error("Your focus-trap needs to have at least one focusable element");
                    return e;
                },
                h = function () {
                    if (
                        ((n.tabbableGroups = n.containers
                            .map(function (e) {
                                var t = bu(e);
                                if (t.length > 0) return { container: e, firstTabbableNode: t[0], lastTabbableNode: t[t.length - 1] };
                            })
                            .filter(function (e) {
                                return !!e;
                            })),
                            n.tabbableGroups.length <= 0 && !l("fallbackFocus"))
                    )
                        throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
                },
                d = function e(t) {
                    !1 !== t &&
                        t !== s.activeElement &&
                        (t && t.focus
                            ? (t.focus({ preventScroll: !!r.preventScroll }),
                                (n.mostRecentlyFocusedNode = t),
                                (function (e) {
                                    return e.tagName && "input" === e.tagName.toLowerCase() && "function" == typeof e.select;
                                })(t) && t.select())
                            : e(c()));
                },
                u = function (e) {
                    var t = l("setReturnFocus");
                    return t || e;
                },
                p = function (e) {
                    a(e.target) || (Au(r.clickOutsideDeactivates, e) ? i.deactivate({ returnFocus: r.returnFocusOnDeactivate && !Su(e.target) }) : Au(r.allowOutsideClick, e) || e.preventDefault());
                },
                m = function (e) {
                    var t = a(e.target);
                    t || e.target instanceof Document ? t && (n.mostRecentlyFocusedNode = e.target) : (e.stopImmediatePropagation(), d(n.mostRecentlyFocusedNode || c()));
                },
                f = function (e) {
                    if (
                        (function (e) {
                            return "Escape" === e.key || "Esc" === e.key || 27 === e.keyCode;
                        })(e) &&
                        !1 !== Au(r.escapeDeactivates)
                    )
                        return e.preventDefault(), void i.deactivate();
                    (function (e) {
                        return "Tab" === e.key || 9 === e.keyCode;
                    })(e) &&
                        (function (e) {
                            h();
                            var t = null;
                            if (n.tabbableGroups.length > 0) {
                                var i = _u(n.tabbableGroups, function (t) {
                                    return t.container.contains(e.target);
                                });
                                if (i < 0) t = e.shiftKey ? n.tabbableGroups[n.tabbableGroups.length - 1].lastTabbableNode : n.tabbableGroups[0].firstTabbableNode;
                                else if (e.shiftKey) {
                                    var s = _u(n.tabbableGroups, function (t) {
                                        var i = t.firstTabbableNode;
                                        return e.target === i;
                                    });
                                    if ((s < 0 && n.tabbableGroups[i].container === e.target && (s = i), s >= 0)) {
                                        var r = 0 === s ? n.tabbableGroups.length - 1 : s - 1;
                                        t = n.tabbableGroups[r].lastTabbableNode;
                                    }
                                } else {
                                    var o = _u(n.tabbableGroups, function (t) {
                                        var i = t.lastTabbableNode;
                                        return e.target === i;
                                    });
                                    if ((o < 0 && n.tabbableGroups[i].container === e.target && (o = i), o >= 0)) {
                                        var a = o === n.tabbableGroups.length - 1 ? 0 : o + 1;
                                        t = n.tabbableGroups[a].firstTabbableNode;
                                    }
                                }
                            } else t = l("fallbackFocus");
                            t && (e.preventDefault(), d(t));
                        })(e);
                },
                g = function (e) {
                    Au(r.clickOutsideDeactivates, e) || a(e.target) || Au(r.allowOutsideClick, e) || (e.preventDefault(), e.stopImmediatePropagation());
                },
                y = function () {
                    if (n.active)
                        return (
                            Tu.activateTrap(i),
                            (n.delayInitialFocusTimer = r.delayInitialFocus
                                ? xu(function () {
                                    d(c());
                                })
                                : d(c())),
                            s.addEventListener("focusin", m, !0),
                            s.addEventListener("mousedown", p, { capture: !0, passive: !1 }),
                            s.addEventListener("touchstart", p, { capture: !0, passive: !1 }),
                            s.addEventListener("click", g, { capture: !0, passive: !1 }),
                            s.addEventListener("keydown", f, { capture: !0, passive: !1 }),
                            i
                        );
                },
                v = function () {
                    if (n.active)
                        return (
                            s.removeEventListener("focusin", m, !0), s.removeEventListener("mousedown", p, !0), s.removeEventListener("touchstart", p, !0), s.removeEventListener("click", g, !0), s.removeEventListener("keydown", f, !0), i
                        );
                };
            return (
                (i = {
                    activate: function (e) {
                        if (n.active) return this;
                        var t = o(e, "onActivate"),
                            i = o(e, "onPostActivate"),
                            r = o(e, "checkCanFocusTrap");
                        r || h(), (n.active = !0), (n.paused = !1), (n.nodeFocusedBeforeActivation = s.activeElement), t && t();
                        var a = function () {
                            r && h(), y(), i && i();
                        };
                        return r ? (r(n.containers.concat()).then(a, a), this) : (a(), this);
                    },
                    deactivate: function (e) {
                        if (!n.active) return this;
                        clearTimeout(n.delayInitialFocusTimer), (n.delayInitialFocusTimer = void 0), v(), (n.active = !1), (n.paused = !1), Tu.deactivateTrap(i);
                        var t = o(e, "onDeactivate"),
                            s = o(e, "onPostDeactivate"),
                            r = o(e, "checkCanReturnFocus");
                        t && t();
                        var a = o(e, "returnFocus", "returnFocusOnDeactivate"),
                            l = function () {
                                xu(function () {
                                    a && d(u(n.nodeFocusedBeforeActivation)), s && s();
                                });
                            };
                        return a && r ? (r(u(n.nodeFocusedBeforeActivation)).then(l, l), this) : (l(), this);
                    },
                    pause: function () {
                        return n.paused || !n.active || ((n.paused = !0), v()), this;
                    },
                    unpause: function () {
                        return n.paused && n.active ? ((n.paused = !1), h(), y(), this) : this;
                    },
                    updateContainerElements: function (e) {
                        var t = [].concat(e).filter(Boolean);
                        return (
                            (n.containers = t.map(function (e) {
                                return "string" == typeof e ? s.querySelector(e) : e;
                            })),
                            n.active && h(),
                            this
                        );
                    },
                }).updateContainerElements(e),
                i
            );
        };
    function Cu(e) {
        let t = [];
        return (
            Pu(e, (e) => {
                let i = e.hasAttribute("aria-hidden");
                e.setAttribute("aria-hidden", "true"), t.push(() => i || e.removeAttribute("aria-hidden"));
            }),
            () => {
                for (; t.length;) t.pop()();
            }
        );
    }
    function Pu(e, t) {
        !e.isSameNode(document.body) &&
            e.parentNode &&
            Array.from(e.parentNode.children).forEach((i) => {
                i.isSameNode(e) ? Pu(e.parentNode, t) : t(i);
            });
    }
    var $u,
        Mu,
        Iu,
        Du,
        Ou = function (e) {
            let t, i;
            window.addEventListener("focusin", () => {
                (t = i), (i = document.activeElement);
            }),
                e.magic("focus", (e) => {
                    let s = e;
                    return {
                        __noscroll: !1,
                        __wrapAround: !1,
                        within(e) {
                            return (s = e), this;
                        },
                        withoutScrolling() {
                            return (this.__noscroll = !0), this;
                        },
                        noscroll() {
                            return (this.__noscroll = !0), this;
                        },
                        withWrapAround() {
                            return (this.__wrapAround = !0), this;
                        },
                        wrap() {
                            return this.withWrapAround();
                        },
                        focusable: (e) => Su(e),
                        previouslyFocused: () => t,
                        lastFocused: () => t,
                        focused: () => i,
                        focusables: () =>
                            Array.isArray(s)
                                ? s
                                : (function (e, t) {
                                    return uu(e, (t = t || {}).includeContainer, yu.bind(null, t));
                                })(s, { displayCheck: "none" }),
                        all() {
                            return this.focusables();
                        },
                        isFirst(e) {
                            let t = this.all();
                            return t[0] && t[0].isSameNode(e);
                        },
                        isLast(e) {
                            let t = this.all();
                            return t.length && t.slice(-1)[0].isSameNode(e);
                        },
                        getFirst() {
                            return this.all()[0];
                        },
                        getLast() {
                            return this.all().slice(-1)[0];
                        },
                        getNext() {
                            let e = this.all(),
                                t = document.activeElement;
                            if (-1 !== e.indexOf(t)) return this.__wrapAround && e.indexOf(t) === e.length - 1 ? e[0] : e[e.indexOf(t) + 1];
                        },
                        getPrevious() {
                            let e = this.all(),
                                t = document.activeElement;
                            if (-1 !== e.indexOf(t)) return this.__wrapAround && 0 === e.indexOf(t) ? e.slice(-1)[0] : e[e.indexOf(t) - 1];
                        },
                        first() {
                            this.focus(this.getFirst());
                        },
                        last() {
                            this.focus(this.getLast());
                        },
                        next() {
                            this.focus(this.getNext());
                        },
                        previous() {
                            this.focus(this.getPrevious());
                        },
                        prev() {
                            return this.previous();
                        },
                        focus(e) {
                            e &&
                                setTimeout(() => {
                                    e.hasAttribute("tabindex") || e.setAttribute("tabindex", "0"), e.focus({ preventScroll: this._noscroll });
                                });
                        },
                    };
                }),
                e.directive(
                    "trap",
                    e.skipDuringClone(
                        (e, { expression: t, modifiers: i }, { effect: s, evaluateLater: r, cleanup: n }) => {
                            let o = r(t),
                                a = !1,
                                l = qu(e, { escapeDeactivates: !1, allowOutsideClick: !0, fallbackFocus: () => e, initialFocus: e.querySelector("[autofocus]") }),
                                c = () => { },
                                h = () => { };
                            const d = () => {
                                c(), (c = () => { }), h(), (h = () => { }), l.deactivate({ returnFocus: !i.includes("noreturn") });
                            };
                            s(() =>
                                o((t) => {
                                    a !== t &&
                                        (t &&
                                            !a &&
                                            setTimeout(() => {
                                                i.includes("inert") && (c = Cu(e)),
                                                    i.includes("noscroll") &&
                                                    (h = (function () {
                                                        let e = document.documentElement.style.overflow,
                                                            t = document.documentElement.style.paddingRight,
                                                            i = window.innerWidth - document.documentElement.clientWidth;
                                                        return (
                                                            (document.documentElement.style.overflow = "hidden"),
                                                            (document.documentElement.style.paddingRight = `${i}px`),
                                                            () => {
                                                                (document.documentElement.style.overflow = e), (document.documentElement.style.paddingRight = t);
                                                            }
                                                        );
                                                    })()),
                                                    l.activate();
                                            }),
                                            !t && a && d(),
                                            (a = !!t));
                                })
                            ),
                                n(d);
                        },
                        (e, { expression: t, modifiers: i }, { evaluate: s }) => {
                            i.includes("inert") && s(t) && Cu(e);
                        }
                    )
                );
        },
        Hu = !1,
        Fu = !1,
        Bu = [],
        Wu = -1;
    function Nu(e) {
        !(function (e) {
            Bu.includes(e) || Bu.push(e);
            Fu || Hu || ((Hu = !0), queueMicrotask(ju));
        })(e);
    }
    function Ru(e) {
        let t = Bu.indexOf(e);
        -1 !== t && t > Wu && Bu.splice(t, 1);
    }
    function ju() {
        (Hu = !1), (Fu = !0);
        for (let e = 0; e < Bu.length; e++) Bu[e](), (Wu = e);
        (Bu.length = 0), (Wu = -1), (Fu = !1);
    }
    var zu = !0;
    function Vu(e) {
        Mu = e;
    }
    var Uu = [],
        Gu = [],
        Ju = [];
    function Qu(e, t) {
        "function" == typeof t ? (e._x_cleanups || (e._x_cleanups = []), e._x_cleanups.push(t)) : ((t = e), Gu.push(t));
    }
    function Ku(e, t) {
        e._x_attributeCleanups &&
            Object.entries(e._x_attributeCleanups).forEach(([i, s]) => {
                (void 0 === t || t.includes(i)) && (s.forEach((e) => e()), delete e._x_attributeCleanups[i]);
            });
    }
    var Yu = new MutationObserver(op),
        Xu = !1;
    function Zu() {
        Yu.observe(document, { subtree: !0, childList: !0, attributes: !0, attributeOldValue: !0 }), (Xu = !0);
    }
    function ep() {
        (tp = tp.concat(Yu.takeRecords())).length &&
            !ip &&
            ((ip = !0),
                queueMicrotask(() => {
                    op(tp), (tp.length = 0), (ip = !1);
                })),
            Yu.disconnect(),
            (Xu = !1);
    }
    var tp = [],
        ip = !1;
    function sp(e) {
        if (!Xu) return e();
        ep();
        let t = e();
        return Zu(), t;
    }
    var rp = !1,
        np = [];
    function op(e) {
        if (rp) return void (np = np.concat(e));
        let t = [],
            i = [],
            s = new Map(),
            r = new Map();
        for (let n = 0; n < e.length; n++)
            if (
                !e[n].target._x_ignoreMutationObserver &&
                ("childList" === e[n].type && (e[n].addedNodes.forEach((e) => 1 === e.nodeType && t.push(e)), e[n].removedNodes.forEach((e) => 1 === e.nodeType && i.push(e))), "attributes" === e[n].type)
            ) {
                let t = e[n].target,
                    i = e[n].attributeName,
                    o = e[n].oldValue,
                    a = () => {
                        s.has(t) || s.set(t, []), s.get(t).push({ name: i, value: t.getAttribute(i) });
                    },
                    l = () => {
                        r.has(t) || r.set(t, []), r.get(t).push(i);
                    };
                t.hasAttribute(i) && null === o ? a() : t.hasAttribute(i) ? (l(), a()) : l();
            }
        r.forEach((e, t) => {
            Ku(t, e);
        }),
            s.forEach((e, t) => {
                Uu.forEach((i) => i(t, e));
            });
        for (let e of i) if (!t.includes(e) && (Gu.forEach((t) => t(e)), e._x_cleanups)) for (; e._x_cleanups.length;) e._x_cleanups.pop()();
        t.forEach((e) => {
            (e._x_ignoreSelf = !0), (e._x_ignore = !0);
        });
        for (let e of t) i.includes(e) || (e.isConnected && (delete e._x_ignoreSelf, delete e._x_ignore, Ju.forEach((t) => t(e)), (e._x_ignore = !0), (e._x_ignoreSelf = !0)));
        t.forEach((e) => {
            delete e._x_ignoreSelf, delete e._x_ignore;
        }),
            (t = null),
            (i = null),
            (s = null),
            (r = null);
    }
    function ap(e) {
        return hp(cp(e));
    }
    function lp(e, t, i) {
        return (
            (e._x_dataStack = [t, ...cp(i || e)]),
            () => {
                e._x_dataStack = e._x_dataStack.filter((e) => e !== t);
            }
        );
    }
    function cp(e) {
        return e._x_dataStack ? e._x_dataStack : "function" == typeof ShadowRoot && e instanceof ShadowRoot ? cp(e.host) : e.parentNode ? cp(e.parentNode) : [];
    }
    function hp(e) {
        let t = new Proxy(
            {},
            {
                ownKeys: () => Array.from(new Set(e.flatMap((e) => Object.keys(e)))),
                has: (t, i) => e.some((e) => e.hasOwnProperty(i)),
                get: (i, s) =>
                    (e.find((e) => {
                        if (e.hasOwnProperty(s)) {
                            let i = Object.getOwnPropertyDescriptor(e, s);
                            if ((i.get && i.get._x_alreadyBound) || (i.set && i.set._x_alreadyBound)) return !0;
                            if ((i.get || i.set) && i.enumerable) {
                                let r = i.get,
                                    n = i.set,
                                    o = i;
                                (r = r && r.bind(t)), (n = n && n.bind(t)), r && (r._x_alreadyBound = !0), n && (n._x_alreadyBound = !0), Object.defineProperty(e, s, { ...o, get: r, set: n });
                            }
                            return !0;
                        }
                        return !1;
                    }) || {})[s],
                set: (t, i, s) => {
                    let r = e.find((e) => e.hasOwnProperty(i));
                    return r ? (r[i] = s) : (e[e.length - 1][i] = s), !0;
                },
            }
        );
        return t;
    }
    function dp(e) {
        let t = (i, s = "") => {
            Object.entries(Object.getOwnPropertyDescriptors(i)).forEach(([r, { value: n, enumerable: o }]) => {
                if (!1 === o || void 0 === n) return;
                let a = "" === s ? r : `${s}.${r}`;
                var l;
                "object" == typeof n && null !== n && n._x_interceptor ? (i[r] = n.initialize(e, a, r)) : "object" != typeof (l = n) || Array.isArray(l) || null === l || n === i || n instanceof Element || t(n, a);
            });
        };
        return t(e);
    }
    function up(e, t = () => { }) {
        let i = {
            initialValue: void 0,
            _x_interceptor: !0,
            initialize(t, i, s) {
                return e(
                    this.initialValue,
                    () =>
                        (function (e, t) {
                            return t.split(".").reduce((e, t) => e[t], e);
                        })(t, i),
                    (e) => pp(t, i, e),
                    i,
                    s
                );
            },
        };
        return (
            t(i),
            (e) => {
                if ("object" == typeof e && null !== e && e._x_interceptor) {
                    let t = i.initialize.bind(i);
                    i.initialize = (s, r, n) => {
                        let o = e.initialize(s, r, n);
                        return (i.initialValue = o), t(s, r, n);
                    };
                } else i.initialValue = e;
                return i;
            }
        );
    }
    function pp(e, t, i) {
        if (("string" == typeof t && (t = t.split(".")), 1 !== t.length)) {
            if (0 === t.length) throw error;
            return e[t[0]] || (e[t[0]] = {}), pp(e[t[0]], t.slice(1), i);
        }
        e[t[0]] = i;
    }
    var mp = {};
    function fp(e, t) {
        mp[e] = t;
    }
    function gp(e, t) {
        return (
            Object.entries(mp).forEach(([i, s]) => {
                let r = null;
                Object.defineProperty(e, `$${i}`, {
                    get: () =>
                        s(
                            t,
                            (function () {
                                if (r) return r;
                                {
                                    let [e, i] = Op(t);
                                    return (r = { interceptor: up, ...e }), Qu(t, i), r;
                                }
                            })()
                        ),
                    enumerable: !1,
                });
            }),
            e
        );
    }
    function yp(e, t, i, ...s) {
        try {
            return i(...s);
        } catch (i) {
            vp(i, e, t);
        }
    }
    function vp(e, t, i) {
        Object.assign(e, { el: t, expression: i }),
            console.warn(`Alpine Expression Error: ${e.message}\n\n${i ? 'Expression: "' + i + '"\n\n' : ""}`, t),
            setTimeout(() => {
                throw e;
            }, 0);
    }
    var bp = !0;
    function wp(e) {
        let t = bp;
        bp = !1;
        let i = e();
        return (bp = t), i;
    }
    function Sp(e, t, i = {}) {
        let s;
        return Ep(e, t)((e) => (s = e), i), s;
    }
    function Ep(...e) {
        return Lp(...e);
    }
    var Lp = kp;
    function kp(e, t) {
        let i = {};
        gp(i, e);
        let s = [i, ...cp(e)],
            r =
                "function" == typeof t
                    ? (function (e, t) {
                        return (i = () => { }, { scope: s = {}, params: r = [] } = {}) => {
                            xp(i, t.apply(hp([s, ...e]), r));
                        };
                    })(s, t)
                    : (function (e, t, i) {
                        let s = (function (e, t) {
                            if (Tp[e]) return Tp[e];
                            let i = Object.getPrototypeOf(async function () { }).constructor,
                                s = /^[\n\s]*if.*\(.*\)/.test(e) || /^(let|const)\s/.test(e) ? `(async()=>{ ${e} })()` : e;
                            let r = (() => {
                                try {
                                    return new i(["__self", "scope"], `with (scope) { __self.result = ${s} }; __self.finished = true; return __self.result;`);
                                } catch (i) {
                                    return vp(i, t, e), Promise.resolve();
                                }
                            })();
                            return (Tp[e] = r), r;
                        })(t, i);
                        return (r = () => { }, { scope: n = {}, params: o = [] } = {}) => {
                            (s.result = void 0), (s.finished = !1);
                            let a = hp([n, ...e]);
                            if ("function" == typeof s) {
                                let e = s(s, a).catch((e) => vp(e, i, t));
                                s.finished
                                    ? (xp(r, s.result, a, o, i), (s.result = void 0))
                                    : e
                                        .then((e) => {
                                            xp(r, e, a, o, i);
                                        })
                                        .catch((e) => vp(e, i, t))
                                        .finally(() => (s.result = void 0));
                            }
                        };
                    })(s, t, e);
        return yp.bind(null, e, t, r);
    }
    var Tp = {};
    function xp(e, t, i, s, r) {
        if (bp && "function" == typeof t) {
            let n = t.apply(i, s);
            n instanceof Promise ? n.then((t) => xp(e, t, i, s)).catch((e) => vp(e, r, t)) : e(n);
        } else "object" == typeof t && t instanceof Promise ? t.then((t) => e(t)) : e(t);
    }
    var _p = "x-";
    function Ap(e = "") {
        return _p + e;
    }
    var qp = {};
    function Cp(e, t) {
        return (
            (qp[e] = t),
            {
                before(t) {
                    if (!qp[t]) return void console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
                    const i = zp.indexOf(t);
                    zp.splice(i >= 0 ? i : zp.indexOf("DEFAULT"), 0, e);
                },
            }
        );
    }
    function Pp(e, t, i) {
        if (((t = Array.from(t)), e._x_virtualDirectives)) {
            let i = Object.entries(e._x_virtualDirectives).map(([e, t]) => ({ name: e, value: t })),
                s = $p(i);
            (i = i.map((e) => (s.find((t) => t.name === e.name) ? { name: `x-bind:${e.name}`, value: `"${e.value}"` } : e))), (t = t.concat(i));
        }
        let s = {},
            r = t
                .map(Fp((e, t) => (s[e] = t)))
                .filter(Np)
                .map(
                    (function (e, t) {
                        return ({ name: i, value: s }) => {
                            let r = i.match(Rp()),
                                n = i.match(/:([a-zA-Z0-9\-:]+)/),
                                o = i.match(/\.[^.\]]+(?=[^\]]*$)/g) || [],
                                a = t || e[i] || i;
                            return { type: r ? r[1] : null, value: n ? n[1] : null, modifiers: o.map((e) => e.replace(".", "")), expression: s, original: a };
                        };
                    })(s, i)
                )
                .sort(Vp);
        return r.map((t) =>
            (function (e, t) {
                let i = () => { },
                    s = qp[t.type] || i,
                    [r, n] = Op(e);
                !(function (e, t, i) {
                    e._x_attributeCleanups || (e._x_attributeCleanups = {}), e._x_attributeCleanups[t] || (e._x_attributeCleanups[t] = []), e._x_attributeCleanups[t].push(i);
                })(e, t.original, n);
                let o = () => {
                    e._x_ignore || e._x_ignoreSelf || (s.inline && s.inline(e, t, r), (s = s.bind(s, e, t, r)), Mp ? Ip.get(Dp).push(s) : s());
                };
                return (o.runCleanups = n), o;
            })(e, t)
        );
    }
    function $p(e) {
        return Array.from(e)
            .map(Fp())
            .filter((e) => !Np(e));
    }
    var Mp = !1,
        Ip = new Map(),
        Dp = Symbol();
    function Op(e) {
        let t = [],
            [i, s] = (function (e) {
                let t = () => { };
                return [
                    (i) => {
                        let s = Mu(i);
                        return (
                            e._x_effects ||
                            ((e._x_effects = new Set()),
                                (e._x_runEffects = () => {
                                    e._x_effects.forEach((e) => e());
                                })),
                            e._x_effects.add(s),
                            (t = () => {
                                void 0 !== s && (e._x_effects.delete(s), Iu(s));
                            }),
                            s
                        );
                    },
                    () => {
                        t();
                    },
                ];
            })(e);
        t.push(s);
        return [{ Alpine: Mm, effect: i, cleanup: (e) => t.push(e), evaluateLater: Ep.bind(Ep, e), evaluate: Sp.bind(Sp, e) }, () => t.forEach((e) => e())];
    }
    var Hp = (e, t) => ({ name: i, value: s }) => (i.startsWith(e) && (i = i.replace(e, t)), { name: i, value: s });
    function Fp(e = () => { }) {
        return ({ name: t, value: i }) => {
            let { name: s, value: r } = Bp.reduce((e, t) => t(e), { name: t, value: i });
            return s !== t && e(s, t), { name: s, value: r };
        };
    }
    var Bp = [];
    function Wp(e) {
        Bp.push(e);
    }
    function Np({ name: e }) {
        return Rp().test(e);
    }
    var Rp = () => new RegExp(`^${_p}([^:^.]+)\\b`);
    var jp = "DEFAULT",
        zp = ["ignore", "ref", "data", "id", "bind", "init", "for", "model", "modelable", "transition", "show", "if", jp, "teleport"];
    function Vp(e, t) {
        let i = -1 === zp.indexOf(e.type) ? jp : e.type,
            s = -1 === zp.indexOf(t.type) ? jp : t.type;
        return zp.indexOf(i) - zp.indexOf(s);
    }
    function Up(e, t, i = {}) {
        e.dispatchEvent(new CustomEvent(t, { detail: i, bubbles: !0, composed: !0, cancelable: !0 }));
    }
    function Gp(e, t) {
        if ("function" == typeof ShadowRoot && e instanceof ShadowRoot) return void Array.from(e.children).forEach((e) => Gp(e, t));
        let i = !1;
        if ((t(e, () => (i = !0)), i)) return;
        let s = e.firstElementChild;
        for (; s;) Gp(s, t), (s = s.nextElementSibling);
    }
    function Jp(e, ...t) {
        console.warn(`Alpine Warning: ${e}`, ...t);
    }
    var Qp = !1;
    var Kp = [],
        Yp = [];
    function Xp() {
        return Kp.map((e) => e());
    }
    function Zp() {
        return Kp.concat(Yp).map((e) => e());
    }
    function em(e) {
        Kp.push(e);
    }
    function tm(e) {
        Yp.push(e);
    }
    function im(e, t = !1) {
        return sm(e, (e) => {
            if ((t ? Zp() : Xp()).some((t) => e.matches(t))) return !0;
        });
    }
    function sm(e, t) {
        if (e) {
            if (t(e)) return e;
            if ((e._x_teleportBack && (e = e._x_teleportBack), e.parentElement)) return sm(e.parentElement, t);
        }
    }
    var rm = [];
    function nm(e, t = Gp, i = () => { }) {
        !(function (e) {
            Mp = !0;
            let t = Symbol();
            (Dp = t), Ip.set(t, []);
            let i = () => {
                for (; Ip.get(t).length;) Ip.get(t).shift()();
                Ip.delete(t);
            };
            e(i), (Mp = !1), i();
        })(() => {
            t(e, (e, t) => {
                i(e, t), rm.forEach((i) => i(e, t)), Pp(e, e.attributes).forEach((e) => e()), e._x_ignore && t();
            });
        });
    }
    function om(e) {
        Gp(e, (e) => Ku(e));
    }
    var am = [],
        lm = !1;
    function cm(e = () => { }) {
        return (
            queueMicrotask(() => {
                lm ||
                    setTimeout(() => {
                        hm();
                    });
            }),
            new Promise((t) => {
                am.push(() => {
                    e(), t();
                });
            })
        );
    }
    function hm() {
        for (lm = !1; am.length;) am.shift()();
    }
    function dm(e, t) {
        return Array.isArray(t)
            ? um(e, t.join(" "))
            : "object" == typeof t && null !== t
                ? (function (e, t) {
                    let i = (e) => e.split(" ").filter(Boolean),
                        s = Object.entries(t)
                            .flatMap(([e, t]) => !!t && i(e))
                            .filter(Boolean),
                        r = Object.entries(t)
                            .flatMap(([e, t]) => !t && i(e))
                            .filter(Boolean),
                        n = [],
                        o = [];
                    return (
                        r.forEach((t) => {
                            e.classList.contains(t) && (e.classList.remove(t), o.push(t));
                        }),
                        s.forEach((t) => {
                            e.classList.contains(t) || (e.classList.add(t), n.push(t));
                        }),
                        () => {
                            o.forEach((t) => e.classList.add(t)), n.forEach((t) => e.classList.remove(t));
                        }
                    );
                })(e, t)
                : "function" == typeof t
                    ? dm(e, t())
                    : um(e, t);
    }
    function um(e, t) {
        return (
            (t = !0 === t ? (t = "") : t || ""),
            ((t) => (
                e.classList.add(...t),
                () => {
                    e.classList.remove(...t);
                }
            ))(
                t
                    .split(" ")
                    .filter((t) => !e.classList.contains(t))
                    .filter(Boolean)
            )
        );
    }
    function pm(e, t) {
        return "object" == typeof t && null !== t
            ? (function (e, t) {
                let i = {};
                return (
                    Object.entries(t).forEach(([t, s]) => {
                        (i[t] = e.style[t]), t.startsWith("--") || (t = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()), e.style.setProperty(t, s);
                    }),
                    setTimeout(() => {
                        0 === e.style.length && e.removeAttribute("style");
                    }),
                    () => {
                        pm(e, i);
                    }
                );
            })(e, t)
            : (function (e, t) {
                let i = e.getAttribute("style", t);
                return (
                    e.setAttribute("style", t),
                    () => {
                        e.setAttribute("style", i || "");
                    }
                );
            })(e, t);
    }
    function mm(e, t = () => { }) {
        let i = !1;
        return function () {
            i ? t.apply(this, arguments) : ((i = !0), e.apply(this, arguments));
        };
    }
    function fm(e, t, i = {}) {
        e._x_transition ||
            (e._x_transition = {
                enter: { during: i, start: i, end: i },
                leave: { during: i, start: i, end: i },
                in(i = () => { }, s = () => { }) {
                    ym(e, t, { during: this.enter.during, start: this.enter.start, end: this.enter.end }, i, s);
                },
                out(i = () => { }, s = () => { }) {
                    ym(e, t, { during: this.leave.during, start: this.leave.start, end: this.leave.end }, i, s);
                },
            });
    }
    function gm(e) {
        let t = e.parentNode;
        if (t) return t._x_hidePromise ? t : gm(t);
    }
    function ym(e, t, { during: i, start: s, end: r } = {}, n = () => { }, o = () => { }) {
        if ((e._x_transitioning && e._x_transitioning.cancel(), 0 === Object.keys(i).length && 0 === Object.keys(s).length && 0 === Object.keys(r).length)) return n(), void o();
        let a, l, c;
        !(function (e, t) {
            let i,
                s,
                r,
                n = mm(() => {
                    sp(() => {
                        (i = !0), s || t.before(), r || (t.end(), hm()), t.after(), e.isConnected && t.cleanup(), delete e._x_transitioning;
                    });
                });
            (e._x_transitioning = {
                beforeCancels: [],
                beforeCancel(e) {
                    this.beforeCancels.push(e);
                },
                cancel: mm(function () {
                    for (; this.beforeCancels.length;) this.beforeCancels.shift()();
                    n();
                }),
                finish: n,
            }),
                sp(() => {
                    t.start(), t.during();
                }),
                (lm = !0),
                requestAnimationFrame(() => {
                    if (i) return;
                    let n = 1e3 * Number(getComputedStyle(e).transitionDuration.replace(/,.*/, "").replace("s", "")),
                        o = 1e3 * Number(getComputedStyle(e).transitionDelay.replace(/,.*/, "").replace("s", ""));
                    0 === n && (n = 1e3 * Number(getComputedStyle(e).animationDuration.replace("s", ""))),
                        sp(() => {
                            t.before();
                        }),
                        (s = !0),
                        requestAnimationFrame(() => {
                            i ||
                                (sp(() => {
                                    t.end();
                                }),
                                    hm(),
                                    setTimeout(e._x_transitioning.finish, n + o),
                                    (r = !0));
                        });
                });
        })(e, {
            start() {
                a = t(e, s);
            },
            during() {
                l = t(e, i);
            },
            before: n,
            end() {
                a(), (c = t(e, r));
            },
            after: o,
            cleanup() {
                l(), c();
            },
        });
    }
    function vm(e, t, i) {
        if (-1 === e.indexOf(t)) return i;
        const s = e[e.indexOf(t) + 1];
        if (!s) return i;
        if ("scale" === t && isNaN(s)) return i;
        if ("duration" === t || "delay" === t) {
            let e = s.match(/([0-9]+)ms/);
            if (e) return e[1];
        }
        return "origin" === t && ["top", "right", "left", "center", "bottom"].includes(e[e.indexOf(t) + 2]) ? [s, e[e.indexOf(t) + 2]].join(" ") : s;
    }
    Cp("transition", (e, { value: t, modifiers: i, expression: s }, { evaluate: r }) => {
        "function" == typeof s && (s = r(s)),
            !1 !== s &&
            (s && "boolean" != typeof s
                ? (function (e, t, i) {
                    fm(e, dm, "");
                    let s = {
                        enter: (t) => {
                            e._x_transition.enter.during = t;
                        },
                        "enter-start": (t) => {
                            e._x_transition.enter.start = t;
                        },
                        "enter-end": (t) => {
                            e._x_transition.enter.end = t;
                        },
                        leave: (t) => {
                            e._x_transition.leave.during = t;
                        },
                        "leave-start": (t) => {
                            e._x_transition.leave.start = t;
                        },
                        "leave-end": (t) => {
                            e._x_transition.leave.end = t;
                        },
                    };
                    s[i](t);
                })(e, s, t)
                : (function (e, t, i) {
                    fm(e, pm);
                    let s = !t.includes("in") && !t.includes("out") && !i,
                        r = s || t.includes("in") || ["enter"].includes(i),
                        n = s || t.includes("out") || ["leave"].includes(i);
                    t.includes("in") && !s && (t = t.filter((e, i) => i < t.indexOf("out")));
                    t.includes("out") && !s && (t = t.filter((e, i) => i > t.indexOf("out")));
                    let o = !t.includes("opacity") && !t.includes("scale"),
                        a = o || t.includes("opacity"),
                        l = o || t.includes("scale"),
                        c = a ? 0 : 1,
                        h = l ? vm(t, "scale", 95) / 100 : 1,
                        d = vm(t, "delay", 0) / 1e3,
                        u = vm(t, "origin", "center"),
                        p = "opacity, transform",
                        m = vm(t, "duration", 150) / 1e3,
                        f = vm(t, "duration", 75) / 1e3,
                        g = "cubic-bezier(0.4, 0.0, 0.2, 1)";
                    r &&
                        ((e._x_transition.enter.during = { transformOrigin: u, transitionDelay: `${d}s`, transitionProperty: p, transitionDuration: `${m}s`, transitionTimingFunction: g }),
                            (e._x_transition.enter.start = { opacity: c, transform: `scale(${h})` }),
                            (e._x_transition.enter.end = { opacity: 1, transform: "scale(1)" }));
                    n &&
                        ((e._x_transition.leave.during = { transformOrigin: u, transitionDelay: `${d}s`, transitionProperty: p, transitionDuration: `${f}s`, transitionTimingFunction: g }),
                            (e._x_transition.leave.start = { opacity: 1, transform: "scale(1)" }),
                            (e._x_transition.leave.end = { opacity: c, transform: `scale(${h})` }));
                })(e, i, t));
    }),
        (window.Element.prototype._x_toggleAndCascadeWithTransitions = function (e, t, i, s) {
            const r = "visible" === document.visibilityState ? requestAnimationFrame : setTimeout;
            let n = () => r(i);
            t
                ? e._x_transition && (e._x_transition.enter || e._x_transition.leave)
                    ? e._x_transition.enter && (Object.entries(e._x_transition.enter.during).length || Object.entries(e._x_transition.enter.start).length || Object.entries(e._x_transition.enter.end).length)
                        ? e._x_transition.in(i)
                        : n()
                    : e._x_transition
                        ? e._x_transition.in(i)
                        : n()
                : ((e._x_hidePromise = e._x_transition
                    ? new Promise((t, i) => {
                        e._x_transition.out(
                            () => { },
                            () => t(s)
                        ),
                            e._x_transitioning.beforeCancel(() => i({ isFromCancelledTransition: !0 }));
                    })
                    : Promise.resolve(s)),
                    queueMicrotask(() => {
                        let t = gm(e);
                        t
                            ? (t._x_hideChildren || (t._x_hideChildren = []), t._x_hideChildren.push(e))
                            : r(() => {
                                let t = (e) => {
                                    let i = Promise.all([e._x_hidePromise, ...(e._x_hideChildren || []).map(t)]).then(([e]) => e());
                                    return delete e._x_hidePromise, delete e._x_hideChildren, i;
                                };
                                t(e).catch((e) => {
                                    if (!e.isFromCancelledTransition) throw e;
                                });
                            });
                    }));
        });
    var bm = !1;
    function wm(e, t = () => { }) {
        return (...i) => (bm ? t(...i) : e(...i));
    }
    function Sm(e, t, i, s = []) {
        switch ((e._x_bindings || (e._x_bindings = $u({})), (e._x_bindings[t] = i), (t = s.includes("camel") ? t.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase()) : t))) {
            case "value":
                !(function (e, t) {
                    if ("radio" === e.type) void 0 === e.attributes.value && (e.value = t), window.fromModel && (e.checked = Lm(e.value, t));
                    else if ("checkbox" === e.type)
                        Number.isInteger(t)
                            ? (e.value = t)
                            : Number.isInteger(t) || Array.isArray(t) || "boolean" == typeof t || [null, void 0].includes(t)
                                ? Array.isArray(t)
                                    ? (e.checked = t.some((t) => Lm(t, e.value)))
                                    : (e.checked = !!t)
                                : (e.value = String(t));
                    else if ("SELECT" === e.tagName)
                        !(function (e, t) {
                            const i = [].concat(t).map((e) => e + "");
                            Array.from(e.options).forEach((e) => {
                                e.selected = i.includes(e.value);
                            });
                        })(e, t);
                    else {
                        if (e.value === t) return;
                        e.value = t;
                    }
                })(e, i);
                break;
            case "style":
                !(function (e, t) {
                    e._x_undoAddedStyles && e._x_undoAddedStyles();
                    e._x_undoAddedStyles = pm(e, t);
                })(e, i);
                break;
            case "class":
                !(function (e, t) {
                    e._x_undoAddedClasses && e._x_undoAddedClasses();
                    e._x_undoAddedClasses = dm(e, t);
                })(e, i);
                break;
            case "selected":
            case "checked":
                !(function (e, t, i) {
                    Em(e, t, i),
                        (function (e, t, i) {
                            e[t] !== i && (e[t] = i);
                        })(e, t, i);
                })(e, t, i);
                break;
            default:
                Em(e, t, i);
        }
    }
    function Em(e, t, i) {
        [null, void 0, !1].includes(i) &&
            (function (e) {
                return !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(e);
            })(t)
            ? e.removeAttribute(t)
            : (km(t) && (i = t),
                (function (e, t, i) {
                    e.getAttribute(t) != i && e.setAttribute(t, i);
                })(e, t, i));
    }
    function Lm(e, t) {
        return e == t;
    }
    function km(e) {
        return [
            "disabled",
            "checked",
            "required",
            "readonly",
            "hidden",
            "open",
            "selected",
            "autofocus",
            "itemscope",
            "multiple",
            "novalidate",
            "allowfullscreen",
            "allowpaymentrequest",
            "formnovalidate",
            "autoplay",
            "controls",
            "loop",
            "muted",
            "playsinline",
            "default",
            "ismap",
            "reversed",
            "async",
            "defer",
            "nomodule",
        ].includes(e);
    }
    function Tm(e, t, i) {
        let s = e.getAttribute(t);
        return null === s ? ("function" == typeof i ? i() : i) : "" === s || (km(t) ? !![t, "true"].includes(s) : s);
    }
    function xm(e, t) {
        var i;
        return function () {
            var s = this,
                r = arguments,
                n = function () {
                    (i = null), e.apply(s, r);
                };
            clearTimeout(i), (i = setTimeout(n, t));
        };
    }
    function _m(e, t) {
        let i;
        return function () {
            let s = this,
                r = arguments;
            i || (e.apply(s, r), (i = !0), setTimeout(() => (i = !1), t));
        };
    }
    var Am = {},
        qm = !1;
    var Cm = {};
    function Pm(e, t, i) {
        let s = [];
        for (; s.length;) s.pop()();
        let r = Object.entries(t).map(([e, t]) => ({ name: e, value: t })),
            n = $p(r);
        (r = r.map((e) => (n.find((t) => t.name === e.name) ? { name: `x-bind:${e.name}`, value: `"${e.value}"` } : e))),
            Pp(e, r, i).map((e) => {
                s.push(e.runCleanups), e();
            });
    }
    var $m = {};
    var Mm = {
        get reactive() {
            return $u;
        },
        get release() {
            return Iu;
        },
        get effect() {
            return Mu;
        },
        get raw() {
            return Du;
        },
        version: "3.12.3",
        flushAndStopDeferringMutations: function () {
            (rp = !1), op(np), (np = []);
        },
        dontAutoEvaluateFunctions: wp,
        disableEffectScheduling: function (e) {
            (zu = !1), e(), (zu = !0);
        },
        startObservingMutations: Zu,
        stopObservingMutations: ep,
        setReactivityEngine: function (e) {
            ($u = e.reactive),
                (Iu = e.release),
                (Mu = (t) =>
                    e.effect(t, {
                        scheduler: (e) => {
                            zu ? Nu(e) : e();
                        },
                    })),
                (Du = e.raw);
        },
        closestDataStack: cp,
        skipDuringClone: wm,
        onlyDuringClone: function (e) {
            return (...t) => bm && e(...t);
        },
        addRootSelector: em,
        addInitSelector: tm,
        addScopeToNode: lp,
        deferMutations: function () {
            rp = !0;
        },
        mapAttributes: Wp,
        evaluateLater: Ep,
        interceptInit: function (e) {
            rm.push(e);
        },
        setEvaluator: function (e) {
            Lp = e;
        },
        mergeProxies: hp,
        extractProp: function (e, t, i, s = !0) {
            if (e._x_bindings && void 0 !== e._x_bindings[t]) return e._x_bindings[t];
            if (e._x_inlineBindings && void 0 !== e._x_inlineBindings[t]) {
                let i = e._x_inlineBindings[t];
                return (i.extract = s), wp(() => Sp(e, i.expression));
            }
            return Tm(e, t, i);
        },
        findClosest: sm,
        closestRoot: im,
        destroyTree: om,
        interceptor: up,
        transition: ym,
        setStyles: pm,
        mutateDom: sp,
        directive: Cp,
        throttle: _m,
        debounce: xm,
        evaluate: Sp,
        initTree: nm,
        nextTick: cm,
        prefixed: Ap,
        prefix: function (e) {
            _p = e;
        },
        plugin: function (e) {
            (Array.isArray(e) ? e : [e]).forEach((e) => e(Mm));
        },
        magic: fp,
        store: function (e, t) {
            if ((qm || ((Am = $u(Am)), (qm = !0)), void 0 === t)) return Am[e];
            (Am[e] = t), "object" == typeof t && null !== t && t.hasOwnProperty("init") && "function" == typeof t.init && Am[e].init(), dp(Am[e]);
        },
        start: function () {
            var e;
            Qp && Jp("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems."),
                (Qp = !0),
                document.body || Jp("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"),
                Up(document, "alpine:init"),
                Up(document, "alpine:initializing"),
                Zu(),
                (e = (e) => nm(e, Gp)),
                Ju.push(e),
                Qu((e) => om(e)),
                (function (e) {
                    Uu.push(e);
                })((e, t) => {
                    Pp(e, t).forEach((e) => e());
                }),
                Array.from(document.querySelectorAll(Zp()))
                    .filter((e) => !im(e.parentElement, !0))
                    .forEach((e) => {
                        nm(e);
                    }),
                Up(document, "alpine:initialized");
        },
        clone: function (e, t) {
            t._x_dataStack || (t._x_dataStack = e._x_dataStack),
                (bm = !0),
                (function (e) {
                    let t = Mu;
                    Vu((e, i) => {
                        let s = t(e);
                        return Iu(s), () => { };
                    }),
                        e(),
                        Vu(t);
                })(() => {
                    !(function (e) {
                        let t = !1;
                        nm(e, (e, i) => {
                            Gp(e, (e, s) => {
                                if (
                                    t &&
                                    (function (e) {
                                        return Xp().some((t) => e.matches(t));
                                    })(e)
                                )
                                    return s();
                                (t = !0), i(e, s);
                            });
                        });
                    })(t);
                }),
                (bm = !1);
        },
        bound: function (e, t, i) {
            return e._x_bindings && void 0 !== e._x_bindings[t] ? e._x_bindings[t] : Tm(e, t, i);
        },
        $data: ap,
        walk: Gp,
        data: function (e, t) {
            $m[e] = t;
        },
        bind: function (e, t) {
            let i = "function" != typeof t ? () => t : t;
            e instanceof Element ? Pm(e, i()) : (Cm[e] = i);
        },
    };
    function Im(e, t) {
        const i = Object.create(null),
            s = e.split(",");
        for (let e = 0; e < s.length; e++) i[s[e]] = !0;
        return t ? (e) => !!i[e.toLowerCase()] : (e) => !!i[e];
    }
    var Dm = Object.freeze({});
    Object.freeze([]);
    var Om,
        Hm = Object.assign,
        Fm = Object.prototype.hasOwnProperty,
        Bm = (e, t) => Fm.call(e, t),
        Wm = Array.isArray,
        Nm = (e) => "[object Map]" === Vm(e),
        Rm = (e) => "symbol" == typeof e,
        jm = (e) => null !== e && "object" == typeof e,
        zm = Object.prototype.toString,
        Vm = (e) => zm.call(e),
        Um = (e) => Vm(e).slice(8, -1),
        Gm = (e) => "string" == typeof e && "NaN" !== e && "-" !== e[0] && "" + parseInt(e, 10) === e,
        Jm = ((e) => {
            const t = Object.create(null);
            return (i) => t[i] || (t[i] = e(i));
        })((e) => e.charAt(0).toUpperCase() + e.slice(1)),
        Qm = (e, t) => e !== t && (e == e || t == t),
        Km = new WeakMap(),
        Ym = [],
        Xm = Symbol("iterate"),
        Zm = Symbol("Map key iterate");
    var ef = 0;
    function tf(e) {
        const { deps: t } = e;
        if (t.length) {
            for (let i = 0; i < t.length; i++) t[i].delete(e);
            t.length = 0;
        }
    }
    var sf = !0,
        rf = [];
    function nf() {
        const e = rf.pop();
        sf = void 0 === e || e;
    }
    function of(e, t, i) {
        if (!sf || void 0 === Om) return;
        let s = Km.get(e);
        s || Km.set(e, (s = new Map()));
        let r = s.get(i);
        r || s.set(i, (r = new Set())), r.has(Om) || (r.add(Om), Om.deps.push(r), Om.options.onTrack && Om.options.onTrack({ effect: Om, target: e, type: t, key: i }));
    }
    function af(e, t, i, s, r, n) {
        const o = Km.get(e);
        if (!o) return;
        const a = new Set(),
            l = (e) => {
                e &&
                    e.forEach((e) => {
                        (e !== Om || e.allowRecurse) && a.add(e);
                    });
            };
        if ("clear" === t) o.forEach(l);
        else if ("length" === i && Wm(e))
            o.forEach((e, t) => {
                ("length" === t || t >= s) && l(e);
            });
        else
            switch ((void 0 !== i && l(o.get(i)), t)) {
                case "add":
                    Wm(e) ? Gm(i) && l(o.get("length")) : (l(o.get(Xm)), Nm(e) && l(o.get(Zm)));
                    break;
                case "delete":
                    Wm(e) || (l(o.get(Xm)), Nm(e) && l(o.get(Zm)));
                    break;
                case "set":
                    Nm(e) && l(o.get(Xm));
            }
        a.forEach((o) => {
            o.options.onTrigger && o.options.onTrigger({ effect: o, target: e, key: i, type: t, newValue: s, oldValue: r, oldTarget: n }), o.options.scheduler ? o.options.scheduler(o) : o();
        });
    }
    var lf = Im("__proto__,__v_isRef,__isVue"),
        cf = new Set(
            Object.getOwnPropertyNames(Symbol)
                .map((e) => Symbol[e])
                .filter(Rm)
        ),
        hf = ff(),
        df = ff(!1, !0),
        uf = ff(!0),
        pf = ff(!0, !0),
        mf = {};
    function ff(e = !1, t = !1) {
        return function (i, s, r) {
            if ("__v_isReactive" === s) return !e;
            if ("__v_isReadonly" === s) return e;
            if ("__v_raw" === s && r === (e ? (t ? zf : jf) : t ? Rf : Nf).get(i)) return i;
            const n = Wm(i);
            if (!e && n && Bm(mf, s)) return Reflect.get(mf, s, r);
            const o = Reflect.get(i, s, r);
            if (Rm(s) ? cf.has(s) : lf(s)) return o;
            if ((e || of(i, "get", s), t)) return o;
            if (Qf(o)) {
                return !n || !Gm(s) ? o.value : o;
            }
            return jm(o) ? (e ? Uf(o) : Vf(o)) : o;
        };
    }
    function gf(e = !1) {
        return function (t, i, s, r) {
            let n = t[i];
            if (!e && ((s = Jf(s)), (n = Jf(n)), !Wm(t) && Qf(n) && !Qf(s))) return (n.value = s), !0;
            const o = Wm(t) && Gm(i) ? Number(i) < t.length : Bm(t, i),
                a = Reflect.set(t, i, s, r);
            return t === Jf(r) && (o ? Qm(s, n) && af(t, "set", i, s, n) : af(t, "add", i, s)), a;
        };
    }
    ["includes", "indexOf", "lastIndexOf"].forEach((e) => {
        const t = Array.prototype[e];
        mf[e] = function (...e) {
            const i = Jf(this);
            for (let e = 0, t = this.length; e < t; e++) of(i, "get", e + "");
            const s = t.apply(i, e);
            return -1 === s || !1 === s ? t.apply(i, e.map(Jf)) : s;
        };
    }),
        ["push", "pop", "shift", "unshift", "splice"].forEach((e) => {
            const t = Array.prototype[e];
            mf[e] = function (...e) {
                rf.push(sf), (sf = !1);
                const i = t.apply(this, e);
                return nf(), i;
            };
        });
    var yf = {
        get: hf,
        set: gf(),
        deleteProperty: function (e, t) {
            const i = Bm(e, t),
                s = e[t],
                r = Reflect.deleteProperty(e, t);
            return r && i && af(e, "delete", t, void 0, s), r;
        },
        has: function (e, t) {
            const i = Reflect.has(e, t);
            return (Rm(t) && cf.has(t)) || of(e, "has", t), i;
        },
        ownKeys: function (e) {
            return of(e, "iterate", Wm(e) ? "length" : Xm), Reflect.ownKeys(e);
        },
    },
        vf = {
            get: uf,
            set: (e, t) => (console.warn(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0),
            deleteProperty: (e, t) => (console.warn(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0),
        };
    Hm({}, yf, { get: df, set: gf(!0) }), Hm({}, vf, { get: pf });
    var bf = (e) => (jm(e) ? Vf(e) : e),
        wf = (e) => (jm(e) ? Uf(e) : e),
        Sf = (e) => e,
        Ef = (e) => Reflect.getPrototypeOf(e);
    function Lf(e, t, i = !1, s = !1) {
        const r = Jf((e = e.__v_raw)),
            n = Jf(t);
        t !== n && !i && of(r, "get", t), !i && of(r, "get", n);
        const { has: o } = Ef(r),
            a = s ? Sf : i ? wf : bf;
        return o.call(r, t) ? a(e.get(t)) : o.call(r, n) ? a(e.get(n)) : void (e !== r && e.get(t));
    }
    function kf(e, t = !1) {
        const i = this.__v_raw,
            s = Jf(i),
            r = Jf(e);
        return e !== r && !t && of(s, "has", e), !t && of(s, "has", r), e === r ? i.has(e) : i.has(e) || i.has(r);
    }
    function Tf(e, t = !1) {
        return (e = e.__v_raw), !t && of(Jf(e), "iterate", Xm), Reflect.get(e, "size", e);
    }
    function xf(e) {
        e = Jf(e);
        const t = Jf(this);
        return Ef(t).has.call(t, e) || (t.add(e), af(t, "add", e, e)), this;
    }
    function _f(e, t) {
        t = Jf(t);
        const i = Jf(this),
            { has: s, get: r } = Ef(i);
        let n = s.call(i, e);
        n ? Wf(i, s, e) : ((e = Jf(e)), (n = s.call(i, e)));
        const o = r.call(i, e);
        return i.set(e, t), n ? Qm(t, o) && af(i, "set", e, t, o) : af(i, "add", e, t), this;
    }
    function Af(e) {
        const t = Jf(this),
            { has: i, get: s } = Ef(t);
        let r = i.call(t, e);
        r ? Wf(t, i, e) : ((e = Jf(e)), (r = i.call(t, e)));
        const n = s ? s.call(t, e) : void 0,
            o = t.delete(e);
        return r && af(t, "delete", e, void 0, n), o;
    }
    function qf() {
        const e = Jf(this),
            t = 0 !== e.size,
            i = Nm(e) ? new Map(e) : new Set(e),
            s = e.clear();
        return t && af(e, "clear", void 0, void 0, i), s;
    }
    function Cf(e, t) {
        return function (i, s) {
            const r = this,
                n = r.__v_raw,
                o = Jf(n),
                a = t ? Sf : e ? wf : bf;
            return !e && of(o, "iterate", Xm), n.forEach((e, t) => i.call(s, a(e), a(t), r));
        };
    }
    function Pf(e, t, i) {
        return function (...s) {
            const r = this.__v_raw,
                n = Jf(r),
                o = Nm(n),
                a = "entries" === e || (e === Symbol.iterator && o),
                l = "keys" === e && o,
                c = r[e](...s),
                h = i ? Sf : t ? wf : bf;
            return (
                !t && of(n, "iterate", l ? Zm : Xm),
                {
                    next() {
                        const { value: e, done: t } = c.next();
                        return t ? { value: e, done: t } : { value: a ? [h(e[0]), h(e[1])] : h(e), done: t };
                    },
                    [Symbol.iterator]() {
                        return this;
                    },
                }
            );
        };
    }
    function $f(e) {
        return function (...t) {
            {
                const i = t[0] ? `on key "${t[0]}" ` : "";
                console.warn(`${Jm(e)} operation ${i}failed: target is readonly.`, Jf(this));
            }
            return "delete" !== e && this;
        };
    }
    var Mf = {
        get(e) {
            return Lf(this, e);
        },
        get size() {
            return Tf(this);
        },
        has: kf,
        add: xf,
        set: _f,
        delete: Af,
        clear: qf,
        forEach: Cf(!1, !1),
    },
        If = {
            get(e) {
                return Lf(this, e, !1, !0);
            },
            get size() {
                return Tf(this);
            },
            has: kf,
            add: xf,
            set: _f,
            delete: Af,
            clear: qf,
            forEach: Cf(!1, !0),
        },
        Df = {
            get(e) {
                return Lf(this, e, !0);
            },
            get size() {
                return Tf(this, !0);
            },
            has(e) {
                return kf.call(this, e, !0);
            },
            add: $f("add"),
            set: $f("set"),
            delete: $f("delete"),
            clear: $f("clear"),
            forEach: Cf(!0, !1),
        },
        Of = {
            get(e) {
                return Lf(this, e, !0, !0);
            },
            get size() {
                return Tf(this, !0);
            },
            has(e) {
                return kf.call(this, e, !0);
            },
            add: $f("add"),
            set: $f("set"),
            delete: $f("delete"),
            clear: $f("clear"),
            forEach: Cf(!0, !0),
        };
    function Hf(e, t) {
        const i = t ? (e ? Of : If) : e ? Df : Mf;
        return (t, s, r) => ("__v_isReactive" === s ? !e : "__v_isReadonly" === s ? e : "__v_raw" === s ? t : Reflect.get(Bm(i, s) && s in t ? i : t, s, r));
    }
    ["keys", "values", "entries", Symbol.iterator].forEach((e) => {
        (Mf[e] = Pf(e, !1, !1)), (Df[e] = Pf(e, !0, !1)), (If[e] = Pf(e, !1, !0)), (Of[e] = Pf(e, !0, !0));
    });
    var Ff = { get: Hf(!1, !1) },
        Bf = { get: Hf(!0, !1) };
    function Wf(e, t, i) {
        const s = Jf(i);
        if (s !== i && t.call(e, s)) {
            const t = Um(e);
            console.warn(
                `Reactive ${t} contains both the raw and reactive versions of the same object${"Map" === t ? " as keys" : ""
                }, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
            );
        }
    }
    var Nf = new WeakMap(),
        Rf = new WeakMap(),
        jf = new WeakMap(),
        zf = new WeakMap();
    function Vf(e) {
        return e && e.__v_isReadonly ? e : Gf(e, !1, yf, Ff, Nf);
    }
    function Uf(e) {
        return Gf(e, !0, vf, Bf, jf);
    }
    function Gf(e, t, i, s, r) {
        if (!jm(e)) return console.warn(`value cannot be made reactive: ${String(e)}`), e;
        if (e.__v_raw && (!t || !e.__v_isReactive)) return e;
        const n = r.get(e);
        if (n) return n;
        const o =
            (a = e).__v_skip || !Object.isExtensible(a)
                ? 0
                : (function (e) {
                    switch (e) {
                        case "Object":
                        case "Array":
                            return 1;
                        case "Map":
                        case "Set":
                        case "WeakMap":
                        case "WeakSet":
                            return 2;
                        default:
                            return 0;
                    }
                })(Um(a));
        var a;
        if (0 === o) return e;
        const l = new Proxy(e, 2 === o ? s : i);
        return r.set(e, l), l;
    }
    function Jf(e) {
        return (e && Jf(e.__v_raw)) || e;
    }
    function Qf(e) {
        return Boolean(e && !0 === e.__v_isRef);
    }
    fp("nextTick", () => cm),
        fp("dispatch", (e) => Up.bind(Up, e)),
        fp("watch", (e, { evaluateLater: t, effect: i }) => (s, r) => {
            let n,
                o = t(s),
                a = !0,
                l = i(() =>
                    o((e) => {
                        JSON.stringify(e),
                            a
                                ? (n = e)
                                : queueMicrotask(() => {
                                    r(e, n), (n = e);
                                }),
                            (a = !1);
                    })
                );
            e._x_effects.delete(l);
        }),
        fp("store", function () {
            return Am;
        }),
        fp("data", (e) => ap(e)),
        fp("root", (e) => im(e)),
        fp(
            "refs",
            (e) => (
                e._x_refs_proxy ||
                (e._x_refs_proxy = hp(
                    (function (e) {
                        let t = [],
                            i = e;
                        for (; i;) i._x_refs && t.push(i._x_refs), (i = i.parentNode);
                        return t;
                    })(e)
                )),
                e._x_refs_proxy
            )
        );
    var Kf = {};
    function Yf(e) {
        return Kf[e] || (Kf[e] = 0), ++Kf[e];
    }
    function Xf(e, t, i) {
        fp(t, (t) => Jp(`You can't use [$${directiveName}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${i}`, t));
    }
    fp("id", (e) => (t, i = null) => {
        let s = (function (e, t) {
            return sm(e, (e) => {
                if (e._x_ids && e._x_ids[t]) return !0;
            });
        })(e, t),
            r = s ? s._x_ids[t] : Yf(t);
        return i ? `${t}-${r}-${i}` : `${t}-${r}`;
    }),
        fp("el", (e) => e),
        Xf("Focus", "focus", "focus"),
        Xf("Persist", "persist", "persist"),
        Cp("modelable", (e, { expression: t }, { effect: i, evaluateLater: s, cleanup: r }) => {
            let n = s(t),
                o = () => {
                    let e;
                    return n((t) => (e = t)), e;
                },
                a = s(`${t} = __placeholder`),
                l = (e) => a(() => { }, { scope: { __placeholder: e } }),
                c = o();
            l(c),
                queueMicrotask(() => {
                    if (!e._x_model) return;
                    e._x_removeModelListeners.default();
                    let t = e._x_model.get,
                        i = e._x_model.set,
                        s = (function ({ get: e, set: t }, { get: i, set: s }) {
                            let r,
                                n,
                                o = !0,
                                a = Mu(() => {
                                    let a, l;
                                    o ? ((a = e()), s(a), (l = i()), (o = !1)) : ((a = e()), (l = i()), (n = JSON.stringify(a)), JSON.stringify(l), n !== r ? ((l = i()), s(a), (l = a)) : (t(l), (a = l))),
                                        (r = JSON.stringify(a)),
                                        JSON.stringify(l);
                                });
                            return () => {
                                Iu(a);
                            };
                        })(
                            {
                                get: () => t(),
                                set(e) {
                                    i(e);
                                },
                            },
                            {
                                get: () => o(),
                                set(e) {
                                    l(e);
                                },
                            }
                        );
                    r(s);
                });
        });
    var Zf = document.createElement("div");
    Cp("teleport", (e, { modifiers: t, expression: i }, { cleanup: s }) => {
        "template" !== e.tagName.toLowerCase() && Jp("x-teleport can only be used on a <template> tag", e);
        let r = wm(
            () => document.querySelector(i),
            () => Zf
        )();
        r || Jp(`Cannot find x-teleport element for selector: "${i}"`);
        let n = e.content.cloneNode(!0).firstElementChild;
        (e._x_teleport = n),
            (n._x_teleportBack = e),
            e._x_forwardEvents &&
            e._x_forwardEvents.forEach((t) => {
                n.addEventListener(t, (t) => {
                    t.stopPropagation(), e.dispatchEvent(new t.constructor(t.type, t));
                });
            }),
            lp(n, {}, e),
            sp(() => {
                t.includes("prepend") ? r.parentNode.insertBefore(n, r) : t.includes("append") ? r.parentNode.insertBefore(n, r.nextSibling) : r.appendChild(n), nm(n), (n._x_ignore = !0);
            }),
            s(() => n.remove());
    });
    var eg = () => { };
    function tg(e, t, i, s) {
        let r = e,
            n = (e) => s(e),
            o = {},
            a = (e, t) => (i) => t(e, i);
        if (
            (i.includes("dot") && (t = t.replace(/-/g, ".")),
                i.includes("camel") &&
                (t = (function (e) {
                    return e.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase());
                })(t)),
                i.includes("passive") && (o.passive = !0),
                i.includes("capture") && (o.capture = !0),
                i.includes("window") && (r = window),
                i.includes("document") && (r = document),
                i.includes("debounce"))
        ) {
            let e = i[i.indexOf("debounce") + 1] || "invalid-wait",
                t = ig(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
            n = xm(n, t);
        }
        if (i.includes("throttle")) {
            let e = i[i.indexOf("throttle") + 1] || "invalid-wait",
                t = ig(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
            n = _m(n, t);
        }
        return (
            i.includes("prevent") &&
            (n = a(n, (e, t) => {
                t.preventDefault(), e(t);
            })),
            i.includes("stop") &&
            (n = a(n, (e, t) => {
                t.stopPropagation(), e(t);
            })),
            i.includes("self") &&
            (n = a(n, (t, i) => {
                i.target === e && t(i);
            })),
            (i.includes("away") || i.includes("outside")) &&
            ((r = document),
                (n = a(n, (t, i) => {
                    e.contains(i.target) || (!1 !== i.target.isConnected && ((e.offsetWidth < 1 && e.offsetHeight < 1) || (!1 !== e._x_isShown && t(i))));
                }))),
            i.includes("once") &&
            (n = a(n, (e, i) => {
                e(i), r.removeEventListener(t, n, o);
            })),
            (n = a(n, (e, s) => {
                ((function (e) {
                    return ["keydown", "keyup"].includes(e);
                })(t) &&
                    (function (e, t) {
                        let i = t.filter((e) => !["window", "document", "prevent", "stop", "once", "capture"].includes(e));
                        if (i.includes("debounce")) {
                            let e = i.indexOf("debounce");
                            i.splice(e, ig((i[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
                        }
                        if (i.includes("throttle")) {
                            let e = i.indexOf("throttle");
                            i.splice(e, ig((i[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
                        }
                        if (0 === i.length) return !1;
                        if (1 === i.length && sg(e.key).includes(i[0])) return !1;
                        const s = ["ctrl", "shift", "alt", "meta", "cmd", "super"].filter((e) => i.includes(e));
                        if (((i = i.filter((e) => !s.includes(e))), s.length > 0)) {
                            if (s.filter((t) => (("cmd" !== t && "super" !== t) || (t = "meta"), e[`${t}Key`])).length === s.length && sg(e.key).includes(i[0])) return !1;
                        }
                        return !0;
                    })(s, i)) ||
                    e(s);
            })),
            r.addEventListener(t, n, o),
            () => {
                r.removeEventListener(t, n, o);
            }
        );
    }
    function ig(e) {
        return !Array.isArray(e) && !isNaN(e);
    }
    function sg(e) {
        if (!e) return [];
        var t;
        e = [" ", "_"].includes((t = e))
            ? t
            : t
                .replace(/([a-z])([A-Z])/g, "$1-$2")
                .replace(/[_\s]/, "-")
                .toLowerCase();
        let i = { ctrl: "control", slash: "/", space: " ", spacebar: " ", cmd: "meta", esc: "escape", up: "arrow-up", down: "arrow-down", left: "arrow-left", right: "arrow-right", period: ".", equal: "=", minus: "-", underscore: "_" };
        return (
            (i[e] = e),
            Object.keys(i)
                .map((t) => {
                    if (i[t] === e) return t;
                })
                .filter((e) => e)
        );
    }
    function rg(e) {
        let t = e ? parseFloat(e) : null;
        return (i = t), Array.isArray(i) || isNaN(i) ? e : t;
        var i;
    }
    function ng(e) {
        return null !== e && "object" == typeof e && "function" == typeof e.get && "function" == typeof e.set;
    }
    (eg.inline = (e, { modifiers: t }, { cleanup: i }) => {
        t.includes("self") ? (e._x_ignoreSelf = !0) : (e._x_ignore = !0),
            i(() => {
                t.includes("self") ? delete e._x_ignoreSelf : delete e._x_ignore;
            });
    }),
        Cp("ignore", eg),
        Cp("effect", (e, { expression: t }, { effect: i }) => i(Ep(e, t))),
        Cp("model", (e, { modifiers: t, expression: i }, { effect: s, cleanup: r }) => {
            let n = e;
            t.includes("parent") && (n = e.parentNode);
            let o,
                a = Ep(n, i);
            o = "string" == typeof i ? Ep(n, `${i} = __placeholder`) : "function" == typeof i && "string" == typeof i() ? Ep(n, `${i()} = __placeholder`) : () => { };
            let l = () => {
                let e;
                return a((t) => (e = t)), ng(e) ? e.get() : e;
            },
                c = (e) => {
                    let t;
                    a((e) => (t = e)), ng(t) ? t.set(e) : o(() => { }, { scope: { __placeholder: e } });
                };
            "string" == typeof i &&
                "radio" === e.type &&
                sp(() => {
                    e.hasAttribute("name") || e.setAttribute("name", i);
                });
            var h = "select" === e.tagName.toLowerCase() || ["checkbox", "radio"].includes(e.type) || t.includes("lazy") ? "change" : "input";
            let d = bm
                ? () => { }
                : tg(e, h, t, (i) => {
                    c(
                        (function (e, t, i, s) {
                            return sp(() => {
                                var r;
                                if (i instanceof CustomEvent && void 0 !== i.detail) return null !== (r = i.detail) && void 0 !== r ? r : i.target.value;
                                if ("checkbox" === e.type) {
                                    if (Array.isArray(s)) {
                                        let e = t.includes("number") ? rg(i.target.value) : i.target.value;
                                        return i.target.checked ? s.concat([e]) : s.filter((t) => !(t == e));
                                    }
                                    return i.target.checked;
                                }
                                if ("select" === e.tagName.toLowerCase() && e.multiple)
                                    return t.includes("number") ? Array.from(i.target.selectedOptions).map((e) => rg(e.value || e.text)) : Array.from(i.target.selectedOptions).map((e) => e.value || e.text);
                                {
                                    let e = i.target.value;
                                    return t.includes("number") ? rg(e) : t.includes("trim") ? e.trim() : e;
                                }
                            });
                        })(e, t, i, l())
                    );
                });
            if (
                (t.includes("fill") && [null, ""].includes(l()) && e.dispatchEvent(new Event(h, {})),
                    e._x_removeModelListeners || (e._x_removeModelListeners = {}),
                    (e._x_removeModelListeners.default = d),
                    r(() => e._x_removeModelListeners.default()),
                    e.form)
            ) {
                let t = tg(e.form, "reset", [], (t) => {
                    cm(() => e._x_model && e._x_model.set(e.value));
                });
                r(() => t());
            }
            (e._x_model = {
                get: () => l(),
                set(e) {
                    c(e);
                },
            }),
                (e._x_forceModelUpdate = (t) => {
                    void 0 === (t = void 0 === t ? l() : t) && "string" == typeof i && i.match(/\./) && (t = ""), (window.fromModel = !0), sp(() => Sm(e, "value", t)), delete window.fromModel;
                }),
                s(() => {
                    let i = l();
                    (t.includes("unintrusive") && document.activeElement.isSameNode(e)) || e._x_forceModelUpdate(i);
                });
        }),
        Cp("cloak", (e) => queueMicrotask(() => sp(() => e.removeAttribute(Ap("cloak"))))),
        tm(() => `[${Ap("init")}]`),
        Cp(
            "init",
            wm((e, { expression: t }, { evaluate: i }) => ("string" == typeof t ? !!t.trim() && i(t, {}, !1) : i(t, {}, !1)))
        ),
        Cp("text", (e, { expression: t }, { effect: i, evaluateLater: s }) => {
            let r = s(t);
            i(() => {
                r((t) => {
                    sp(() => {
                        e.textContent = t;
                    });
                });
            });
        }),
        Cp("html", (e, { expression: t }, { effect: i, evaluateLater: s }) => {
            let r = s(t);
            i(() => {
                r((t) => {
                    sp(() => {
                        (e.innerHTML = t), (e._x_ignoreSelf = !0), nm(e), delete e._x_ignoreSelf;
                    });
                });
            });
        }),
        Wp(Hp(":", Ap("bind:")));
    var og = (e, { value: t, modifiers: i, expression: s, original: r }, { effect: n }) => {
        if (!t) {
            let t = {};
            return (
                (o = t),
                Object.entries(Cm).forEach(([e, t]) => {
                    Object.defineProperty(o, e, { get: () => (...e) => t(...e) });
                }),
                void Ep(e, s)(
                    (t) => {
                        Pm(e, t, r);
                    },
                    { scope: t }
                )
            );
        }
        var o;
        if ("key" === t)
            return (function (e, t) {
                e._x_keyExpression = t;
            })(e, s);
        if (e._x_inlineBindings && e._x_inlineBindings[t] && e._x_inlineBindings[t].extract) return;
        let a = Ep(e, s);
        n(() =>
            a((r) => {
                void 0 === r && "string" == typeof s && s.match(/\./) && (r = ""), sp(() => Sm(e, t, r, i));
            })
        );
    };
    function ag(e, t, i, s) {
        let r = {};
        if (/^\[.*\]$/.test(e.item) && Array.isArray(t)) {
            e.item
                .replace("[", "")
                .replace("]", "")
                .split(",")
                .map((e) => e.trim())
                .forEach((e, i) => {
                    r[e] = t[i];
                });
        } else if (/^\{.*\}$/.test(e.item) && !Array.isArray(t) && "object" == typeof t) {
            e.item
                .replace("{", "")
                .replace("}", "")
                .split(",")
                .map((e) => e.trim())
                .forEach((e) => {
                    r[e] = t[e];
                });
        } else r[e.item] = t;
        return e.index && (r[e.index] = i), e.collection && (r[e.collection] = s), r;
    }
    function lg() { }
    function cg(e, t, i) {
        Cp(t, (s) => Jp(`You can't use [x-${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${i}`, s));
    }
    (og.inline = (e, { value: t, modifiers: i, expression: s }) => {
        t && (e._x_inlineBindings || (e._x_inlineBindings = {}), (e._x_inlineBindings[t] = { expression: s, extract: !1 }));
    }),
        Cp("bind", og),
        em(() => `[${Ap("data")}]`),
        Cp(
            "data",
            wm((e, { expression: t }, { cleanup: i }) => {
                t = "" === t ? "{}" : t;
                let s = {};
                gp(s, e);
                let r = {};
                var n, o;
                (n = r),
                    (o = s),
                    Object.entries($m).forEach(([e, t]) => {
                        Object.defineProperty(n, e, { get: () => (...e) => t.bind(o)(...e), enumerable: !1 });
                    });
                let a = Sp(e, t, { scope: r });
                (void 0 !== a && !0 !== a) || (a = {}), gp(a, e);
                let l = $u(a);
                dp(l);
                let c = lp(e, l);
                l.init && Sp(e, l.init),
                    i(() => {
                        l.destroy && Sp(e, l.destroy), c();
                    });
            })
        ),
        Cp("show", (e, { modifiers: t, expression: i }, { effect: s }) => {
            let r = Ep(e, i);
            e._x_doHide ||
                (e._x_doHide = () => {
                    sp(() => {
                        e.style.setProperty("display", "none", t.includes("important") ? "important" : void 0);
                    });
                }),
                e._x_doShow ||
                (e._x_doShow = () => {
                    sp(() => {
                        1 === e.style.length && "none" === e.style.display ? e.removeAttribute("style") : e.style.removeProperty("display");
                    });
                });
            let n,
                o = () => {
                    e._x_doHide(), (e._x_isShown = !1);
                },
                a = () => {
                    e._x_doShow(), (e._x_isShown = !0);
                },
                l = () => setTimeout(a),
                c = mm(
                    (e) => (e ? a() : o()),
                    (t) => {
                        "function" == typeof e._x_toggleAndCascadeWithTransitions ? e._x_toggleAndCascadeWithTransitions(e, t, a, o) : t ? l() : o();
                    }
                ),
                h = !0;
            s(() =>
                r((e) => {
                    (h || e !== n) && (t.includes("immediate") && (e ? l() : o()), c(e), (n = e), (h = !1));
                })
            );
        }),
        Cp("for", (e, { expression: t }, { effect: i, cleanup: s }) => {
            let r = (function (e) {
                let t = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
                    i = /^\s*\(|\)\s*$/g,
                    s = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
                    r = e.match(s);
                if (!r) return;
                let n = {};
                n.items = r[2].trim();
                let o = r[1].replace(i, "").trim(),
                    a = o.match(t);
                a ? ((n.item = o.replace(t, "").trim()), (n.index = a[1].trim()), a[2] && (n.collection = a[2].trim())) : (n.item = o);
                return n;
            })(t),
                n = Ep(e, r.items),
                o = Ep(e, e._x_keyExpression || "index");
            (e._x_prevKeys = []),
                (e._x_lookup = {}),
                i(() =>
                    (function (e, t, i, s) {
                        let r = (e) => "object" == typeof e && !Array.isArray(e),
                            n = e;
                        i((i) => {
                            var o;
                            (o = i), !Array.isArray(o) && !isNaN(o) && i >= 0 && (i = Array.from(Array(i).keys(), (e) => e + 1)), void 0 === i && (i = []);
                            let a = e._x_lookup,
                                l = e._x_prevKeys,
                                c = [],
                                h = [];
                            if (r(i))
                                i = Object.entries(i).map(([e, r]) => {
                                    let n = ag(t, r, e, i);
                                    s((e) => h.push(e), { scope: { index: e, ...n } }), c.push(n);
                                });
                            else
                                for (let e = 0; e < i.length; e++) {
                                    let r = ag(t, i[e], e, i);
                                    s((e) => h.push(e), { scope: { index: e, ...r } }), c.push(r);
                                }
                            let d = [],
                                u = [],
                                p = [],
                                m = [];
                            for (let e = 0; e < l.length; e++) {
                                let t = l[e];
                                -1 === h.indexOf(t) && p.push(t);
                            }
                            l = l.filter((e) => !p.includes(e));
                            let f = "template";
                            for (let e = 0; e < h.length; e++) {
                                let t = h[e],
                                    i = l.indexOf(t);
                                if (-1 === i) l.splice(e, 0, t), d.push([f, e]);
                                else if (i !== e) {
                                    let t = l.splice(e, 1)[0],
                                        s = l.splice(i - 1, 1)[0];
                                    l.splice(e, 0, s), l.splice(i, 0, t), u.push([t, s]);
                                } else m.push(t);
                                f = t;
                            }
                            for (let e = 0; e < p.length; e++) {
                                let t = p[e];
                                a[t]._x_effects && a[t]._x_effects.forEach(Ru), a[t].remove(), (a[t] = null), delete a[t];
                            }
                            for (let e = 0; e < u.length; e++) {
                                let [t, i] = u[e],
                                    s = a[t],
                                    r = a[i],
                                    o = document.createElement("div");
                                sp(() => {
                                    r || Jp('x-for ":key" is undefined or invalid', n), r.after(o), s.after(r), r._x_currentIfEl && r.after(r._x_currentIfEl), o.before(s), s._x_currentIfEl && s.after(s._x_currentIfEl), o.remove();
                                }),
                                    r._x_refreshXForScope(c[h.indexOf(i)]);
                            }
                            for (let e = 0; e < d.length; e++) {
                                let [t, i] = d[e],
                                    s = "template" === t ? n : a[t];
                                s._x_currentIfEl && (s = s._x_currentIfEl);
                                let r = c[i],
                                    o = h[i],
                                    l = document.importNode(n.content, !0).firstElementChild,
                                    u = $u(r);
                                lp(l, u, n),
                                    (l._x_refreshXForScope = (e) => {
                                        Object.entries(e).forEach(([e, t]) => {
                                            u[e] = t;
                                        });
                                    }),
                                    sp(() => {
                                        s.after(l), nm(l);
                                    }),
                                    "object" == typeof o && Jp("x-for key cannot be an object, it must be a string or an integer", n),
                                    (a[o] = l);
                            }
                            for (let e = 0; e < m.length; e++) a[m[e]]._x_refreshXForScope(c[h.indexOf(m[e])]);
                            n._x_prevKeys = h;
                        });
                    })(e, r, n, o)
                ),
                s(() => {
                    Object.values(e._x_lookup).forEach((e) => e.remove()), delete e._x_prevKeys, delete e._x_lookup;
                });
        }),
        (lg.inline = (e, { expression: t }, { cleanup: i }) => {
            let s = im(e);
            s._x_refs || (s._x_refs = {}), (s._x_refs[t] = e), i(() => delete s._x_refs[t]);
        }),
        Cp("ref", lg),
        Cp("if", (e, { expression: t }, { effect: i, cleanup: s }) => {
            let r = Ep(e, t);
            i(() =>
                r((t) => {
                    t
                        ? (() => {
                            if (e._x_currentIfEl) return e._x_currentIfEl;
                            let t = e.content.cloneNode(!0).firstElementChild;
                            lp(t, {}, e),
                                sp(() => {
                                    e.after(t), nm(t);
                                }),
                                (e._x_currentIfEl = t),
                                (e._x_undoIf = () => {
                                    Gp(t, (e) => {
                                        e._x_effects && e._x_effects.forEach(Ru);
                                    }),
                                        t.remove(),
                                        delete e._x_currentIfEl;
                                });
                        })()
                        : e._x_undoIf && (e._x_undoIf(), delete e._x_undoIf);
                })
            ),
                s(() => e._x_undoIf && e._x_undoIf());
        }),
        Cp("id", (e, { expression: t }, { evaluate: i }) => {
            i(t).forEach((t) =>
                (function (e, t) {
                    e._x_ids || (e._x_ids = {}), e._x_ids[t] || (e._x_ids[t] = Yf(t));
                })(e, t)
            );
        }),
        Wp(Hp("@", Ap("on:"))),
        Cp(
            "on",
            wm((e, { value: t, modifiers: i, expression: s }, { cleanup: r }) => {
                let n = s ? Ep(e, s) : () => { };
                "template" === e.tagName.toLowerCase() && (e._x_forwardEvents || (e._x_forwardEvents = []), e._x_forwardEvents.includes(t) || e._x_forwardEvents.push(t));
                let o = tg(e, t, i, (e) => {
                    n(() => { }, { scope: { $event: e }, params: [e] });
                });
                r(() => o());
            })
        ),
        cg("Collapse", "collapse", "collapse"),
        cg("Intersect", "intersect", "intersect"),
        cg("Focus", "trap", "focus"),
        cg("Mask", "mask", "mask"),
        Mm.setEvaluator(kp),
        Mm.setReactivityEngine({
            reactive: Vf,
            effect: function (e, t = Dm) {
                (function (e) {
                    return e && !0 === e._isEffect;
                })(e) && (e = e.raw);
                const i = (function (e, t) {
                    const i = function () {
                        if (!i.active) return e();
                        if (!Ym.includes(i)) {
                            tf(i);
                            try {
                                return rf.push(sf), (sf = !0), Ym.push(i), (Om = i), e();
                            } finally {
                                Ym.pop(), nf(), (Om = Ym[Ym.length - 1]);
                            }
                        }
                    };
                    return (i.id = ef++), (i.allowRecurse = !!t.allowRecurse), (i._isEffect = !0), (i.active = !0), (i.raw = e), (i.deps = []), (i.options = t), i;
                })(e, t);
                return t.lazy || i(), i;
            },
            release: function (e) {
                e.active && (tf(e), e.options.onStop && e.options.onStop(), (e.active = !1));
            },
            raw: Jf,
        });
    var hg = Mm;
    const dg = "[data-announcement-bar]",
        ug = "[data-ticker-frame]",
        pg = "[data-ticker-scale]",
        mg = "[data-ticker-text]",
        fg = "is-selected",
        gg = "ticker--animated";
    const yg = 0,
        vg = 1,
        bg = 2,
        wg = 3,
        Sg = "[data-product-add-popdown-wrapper]",
        Eg = "[data-add-action-errors]",
        Lg = "[data-error-boundary]",
        kg = "[data-error-display]",
        Tg = "[data-quickview-modal]",
        xg = "[data-cart-page-upsell-wrapper]",
        _g = '[data-section-type="cart"]',
        Ag = '[data-ajax-disable="true"]',
        qg = { durationAddButtonDisable: 3500, hideErrorTime: 5e3 };
    const Cg = 0,
        Pg = 1,
        $g = "data-quickview-holder",
        Mg = "[data-product-quickview-ajax]",
        Ig = "[data-quickview-modal]",
        Dg = "[data-drawer-scrolls]",
        Og = "[data-quickview-modal-template]",
        Hg = "[data-quickview-head]",
        Fg = "[data-quickview-form-area]",
        Bg = "[data-toggle-button]",
        Wg = "[data-media-slide]",
        Ng = "[data-media-id]",
        Rg = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        jg = "hide",
        zg = "is-active",
        Vg = "is-expanded",
        Ug = "loading",
        Gg = 250,
        Jg = 400;
    const Qg = '[role="tablist"]',
        Kg = '[role="tab"]';
    hg.data("announcement", function () {
        new Xh(this.$el);
    }),
        hg.data("announcementSlider", function (e = 4e3) {
            return {
                options: {
                    initialIndex: 0,
                    autoPlay: e,
                    contain: !0,
                    pageDots: !1,
                    adaptiveHeight: !0,
                    wrapAround: !0,
                    groupCells: !1,
                    cellAlign: "left",
                    freeScroll: !1,
                    prevNextButtons: !0,
                    draggable: !0,
                    rightToLeft: window.isRTL,
                    on: {
                        ready: () => {
                            setTimeout(() => {
                                this.$el.dispatchEvent(new CustomEvent("theme:announcement:loaded", { bubbles: !0, detail: { slider: this.$el } }));
                            }, 50);
                        },
                    },
                },
                flkty: null,
                desktopSlides: [],
                mobileSlides: [],
                isMobileSliderInitialized: !1,
                init() {
                    this.$nextTick(() => {
                        this.$el.children.length < 2 ||
                            ((this.flkty = new s(this.$el, this.options)),
                                this.removeDeviceSpecificSlides(),
                                ge.onChange(() => {
                                    this.updateDeviceSpecificSlides();
                                }),
                                (this.scrollEvent = () => this.scrollEvents()),
                                (this.resizeEvent = () => this.resizeEvents()),
                                document.addEventListener("theme:resize", this.resizeEvent),
                                document.addEventListener("theme:scroll", this.scrollEvent));
                    });
                },
                removeDeviceSpecificSlides() {
                    this.flkty.getCellElements().forEach((e, t) => {
                        e.classList.remove(fg),
                            "desktop" == e.dataset.device && (this.desktopSlides.push([e, t]), ge.isMobile() && this.flkty.remove(e)),
                            "mobile" == e.dataset.device && (this.mobileSlides.push([e, t]), (ge.isDesktop() || ge.isTablet()) && this.flkty.remove(e));
                    }),
                        setTimeout(() => {
                            this.flkty.resize();
                        }, 1e3),
                        this.handleSliderAutoplay(),
                        (this.isMobileSliderInitialized = ge.isMobile());
                },
                updateDeviceSpecificSlides() {
                    (ge.isDesktop() || ge.isTablet()) &&
                        this.isMobileSliderInitialized &&
                        (this.desktopSlides.forEach((e) => {
                            this.flkty.insert(e[0], e[1]);
                        }),
                            this.mobileSlides.forEach((e) => {
                                this.flkty.remove(e[0]);
                            })),
                        ge.isMobile() &&
                        (this.isMobileSliderInitialized ||
                            (this.mobileSlides.forEach((e) => {
                                this.flkty.insert(e[0], e[1]);
                            }),
                                this.desktopSlides.forEach((e) => {
                                    this.flkty.remove(e[0]);
                                }))),
                        setTimeout(() => {
                            this.flkty.resize();
                        }, 1e3),
                        this.handleSliderAutoplay(),
                        (this.isMobileSliderInitialized = ge.isMobile());
                },
                handleSliderAutoplay() {
                    var e;
                    (null === (e = this.flkty) || void 0 === e ? void 0 : e.slides.length) > 1 ? this.flkty.playPlayer() : this.flkty.pausePlayer();
                },
                resizeEvents() {
                    this.flkty.resize();
                },
                scrollEvents() {
                    if (!this.flkty.options.autoPlay) return;
                    const e = this.flkty.element,
                        t = e.getBoundingClientRect().top + window.scrollY + e.offsetHeight;
                    window.pageYOffset > t ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer();
                },
                onBlockSelect(e) {
                    const t = this.$el.querySelector(`[x-ref="${e.detail.blockId}"]`);
                    if (!t) return;
                    const i = parseInt([...t.parentNode.children].indexOf(t));
                    this.flkty.selectCell(i), this.flkty.stopPlayer();
                },
                onBlockDeselect() {
                    this.flkty.playPlayer();
                },
                onUnload() {
                    (this.flkty.options.watchCSS = !1), this.flkty.destroy();
                },
            };
        }),
        hg.data("announcementTicker", function (e = { stopClone: !1, waitForSlider: !1 }) {
            var t;
            return {
                tickerFrames: null === (t = this.$el.closest(dg)) || void 0 === t ? void 0 : t.querySelectorAll(ug),
                init() {
                    var t;
                    (null == e ? void 0 : e.waitForSlider) && (null === (t = this.tickerFrames) || void 0 === t ? void 0 : t.length) > 1
                        ? document.addEventListener("theme:announcement:loaded", this.initTicker.bind(this))
                        : this.initTicker();
                },
                initTicker() {
                    new Ti(this.$el, null == e ? void 0 : e.stopClone);
                },
                toggleTicker(e, t) {
                    const i = this.$el.querySelector(pg),
                        s = this.$el.querySelector(`[x-ref="${e.detail.blockId}"]`);
                    if (s && null !== s.offsetParent) {
                        if (t) {
                            const e = Number(getComputedStyle(s).getPropertyValue("--items-spacing").replace("px", "")),
                                t = -(s.offsetLeft + e);
                            i.setAttribute("data-stop", ""),
                                i.querySelectorAll(mg).forEach((e) => {
                                    e.classList.remove(gg), (e.style.transform = `translate3d(${t}px, 0, 0)`);
                                });
                        }
                        t ||
                            (i.querySelectorAll(mg).forEach((e) => {
                                e.classList.add(gg), e.removeAttribute("style");
                            }),
                                i.removeAttribute("data-stop"));
                    }
                },
                onBlockSelect(e) {
                    this.toggleTicker(e, !0);
                },
                onBlockDeselect(e) {
                    this.toggleTicker(e, !1);
                },
            };
        }),
        hg.data("productAddButtonForm", function (e = {}) {
            const t = { ...qg, ...e.times };
            return {
                state: yg,
                error: "",
                isUpsell: !1,
                isInCartPage: !1,
                get cartPageUpsellWrapper() {
                    return this.$el.closest(xg);
                },
                get sectionTypeCart() {
                    return this.$el.closest(_g);
                },
                get form() {
                    return this.isUpsell && this.isInCartPage ? this.$el.closest("form") : this.$el.querySelector("form");
                },
                get button() {
                    return this.$el.querySelector("button");
                },
                get popdown() {
                    return document.querySelector(Sg);
                },
                get errorDisplay() {
                    let e = this.$el.querySelector(Eg);
                    if (!e) {
                        const t = this.$el.closest(Lg);
                        t && (e = t.querySelector(kg));
                    }
                    return e || (e = this.$el.querySelector(kg)), e;
                },
                get quickViewModal() {
                    return this.$el.closest(Tg);
                },
                get isInitial() {
                    return this.state === yg;
                },
                get isLoading() {
                    return this.state === vg;
                },
                get isSuccess() {
                    return this.state === bg;
                },
                get isError() {
                    return this.state === wg;
                },
                get isDisabled() {
                    return this.isLoading;
                },
                get isAjaxDisabled() {
                    return !!this.$el.closest(Ag);
                },
                get isInsideQuickViewModal() {
                    return Boolean(this.quickViewModal);
                },
                handleClickAddButton(e) {
                    e.preventDefault(), (this.state = vg);
                    const t = new FormData(this.form);
                    this.addToCart(t).then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
                },
                handleSuccess(e) {
                    const i = e.data;
                    (this.state = bg),
                        this.updateHeaderTotal(),
                        setTimeout(() => {
                            this.state = yg;
                        }, t.durationAddButtonDisable),
                        this.isInsideQuickViewModal && this.closeQuickView(),
                        window.theme.state.cartOpen || this.isInCartPage || this.isOnCartPage ? this.reloadCart() : this.openPopdown(i);
                },
                handleError(e) {
                    if (!(null == e ? void 0 : e.data)) throw e;
                    if (
                        ((this.state = wg),
                            e.data.description && "string" == typeof e.data.description
                                ? (this.error = e.data.description)
                                : e.data.message && "string" == typeof e.data.message
                                    ? (this.error = e.data.message)
                                    : e.data.description && "object" == typeof e.data.description
                                        ? (this.error = Object.keys(e.data.description)
                                            .map((t) => `${t}: ${e.data.description[t]}`)
                                            .join("<br>"))
                                        : (this.error = "Network error: please try again"),
                            this.errorDisplay)
                    ) {
                        const e = `<div class="errors">${this.error}</div>`;
                        (this.errorDisplay.innerHTML = e),
                            _r(this.errorDisplay),
                            setTimeout(() => {
                                Ar(this.errorDisplay);
                            }, t.hideErrorTime);
                    }
                },
                addToCart(e) {
                    const t = `${window.theme.routes.cart}/add.js`,
                        i = new URLSearchParams(e).toString();

                    return l.post(t, i, { headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/x-www-form-urlencoded" } });

                },
                updateHeaderTotal: () =>
                    l
                        .get(`${window.theme.routes.cart}.js`)
                        .then((e) => {
                            document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: e.data }, bubbles: !0 }));
                        })
                        .catch((e) => {
                            console.error(e);
                        }),
                closeQuickView() {
                    this.quickViewModal.dispatchEvent(new CustomEvent("theme:quickview:close"));
                },
                reloadCart() {
                    document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 }));
                },
                openPopdown(e) {
                    this.popdown.dispatchEvent(new CustomEvent("theme:cart:popdown", { detail: { variant: e }, bubbles: !0 }));
                },
                get isInCartPage() {
                    return Boolean(this.sectionTypeCart);
                },
                get isOnCartPage() {
                    return Boolean(document.body.querySelector(_g));
                },
                get isUpsell() {
                    return Boolean(this.cartPageUpsellWrapper);
                },
                init() {
                    this.button?.addEventListener("click", this.handleClickAddButton.bind(this));
                },
            };
        }),
        hg.data("productQuickViewButton", function (e, t) {
            return {
                state: Cg,
                get quickviewHolder() {
                    return this.$el.querySelector(`[${$g}]`);
                },
                get isInitial() {
                    return this.state === Cg;
                },
                get isLoading() {
                    return this.state === Pg;
                },
                get isDisabled() {
                    return this.isLoading;
                },
                clickQuickviewButton(e) {
                    this.modal && this.modalID && (this.modal.id = this.modalID), document.documentElement.hasAttribute("data-scroll-locked") && (this.scrollLockEnable = !1), (this.state = Pg), this.getQuickviewHTML();
                },
                getQuickviewHTML() {
                    window
                        .fetch(`${window.theme.routes.root_url}products/${t}?section_id=api-product-quickview`)
                        .then(this.handleErrors)
                        .then((e) => e.text())
                        .then((e) => {
                            const t = document.createElement("div");
                            (t.innerHTML = e), (this.modalContent = this.modal.querySelector(Mg)), (this.modalContent.innerHTML = t.querySelector("[data-api-content]").innerHTML), (this.modalScroll = this.modal.querySelector(Dg));
                            const i = this.modalContent.querySelector(Ng);
                            if (i) {
                                const e = document.createElement("div");
                                (e.innerHTML = i.parentElement.innerHTML), this.quickviewHolder.dispatchEvent(new CustomEvent("theme:quickview:media", { bubbles: !0, detail: { media: e } }));
                            }
                            const s = { container: this.modalContent };
                            (this.media = new $a(s)), this.modalCreate(), (this.state = Cg);
                        });
                },
                modalCreate() {
                    n.show(this.modalID, {
                        onShow: (e, t, i) => {
                            (this.quickviewHead = e.querySelector(Hg)),
                                (this.quickviewFormArea = e.querySelector(Fg)),
                                (this.toggleButton = e.querySelector(Bg)),
                                this.toggleForm("loading"),
                                document.addEventListener(
                                    "theme:resize",
                                    Bo(() => {
                                        this.toggleForm("resize");
                                    }, 500)
                                ),
                                this.clickEventToggleForm();
                            const s = e.querySelector(Rg);
                            ri(e, { elementToFocus: s }),
                                this.modal.addEventListener("theme:quickview:close", this.modalClose),
                                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.modalScroll })),
                                new Oc(this.modal);
                        },
                        onClose: (e, t, i) => {
                            this.media.destroy();
                            e.querySelectorAll(Wg).forEach((e) => {
                                e.dispatchEvent(new CustomEvent("pause"));
                            }),
                                ni(),
                                t.focus(),
                                this.modal.removeEventListener("theme:quickview:close", this.modalClose),
                                this.scrollLockEnable ? document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })) : (this.scrollLockEnable = !0);
                        },
                    });
                },
                modalClose() {
                    n.close(this.modalID);
                },
                handleErrors: (e) =>
                    e.ok
                        ? e
                        : e.json().then(function (t) {
                            throw new N({ status: e.statusText, headers: e.headers, json: t });
                        }),
                toggleForm(e) {
                    (this.windowH === window.innerHeight && "resize" === e) ||
                        (this.toggleButton.classList.contains(jg) || this.toggleButton.classList.add(jg),
                            this.quickviewFormArea.classList.contains(Vg) || this.quickviewFormArea.classList.add(Vg),
                            "resize" === e && (this.quickviewFormArea.classList.add(Vg), this.toggleButton.classList.add(jg), (this.windowH = window.innerHeight)),
                            setTimeout(() => {
                                const t = window.innerHeight - this.quickviewHead.offsetHeight - this.quickviewFormArea.offsetHeight,
                                    i = t < Gg;
                                (t < Jg && t > Gg) || i ? (this.toggleButton.classList.remove(jg), this.toggleButton.classList.add(zg)) : this.toggleButton.classList.add(jg),
                                    i
                                        ? ("loading" === e &&
                                            (this.quickviewFormArea.classList.add(Ug),
                                                setTimeout(() => {
                                                    this.quickviewFormArea.classList.remove(Ug);
                                                }, 50)),
                                            this.quickviewFormArea.classList.remove(Vg),
                                            this.toggleButton.classList.remove(zg))
                                        : this.quickviewFormArea.classList.add(Vg);
                            }, 200));
                },
                clickEventToggleForm() {
                    this.toggleButton &&
                        this.toggleButton.addEventListener("click", () => {
                            this.toggleButton.classList.toggle(zg), this.quickviewFormArea.classList.toggle(Vg);
                        });
                },
                init() {
                    if (
                        this.quickviewHolder &&
                        ((this.modalTemplate = this.quickviewHolder.querySelector(Og)),
                            (this.modal = document.querySelector(Ig)),
                            (this.modalID = this.quickviewHolder.getAttribute($g)),
                            (this.modalContent = null),
                            (this.modalScroll = null),
                            (this.scrollLockEnable = !0),
                            (this.windowH = window.innerHeight),
                            this.modalTemplate && !this.modal)
                    ) {
                        const e = this.modalTemplate.innerHTML,
                            t = document.createElement("div");
                        (t.innerHTML = e), (this.modalHtml = t.querySelector(Ig)), document.body.appendChild(this.modalHtml), (this.modal = document.querySelector(Ig));
                    }
                },
            };
        }),
        hg.data("productGridItemQuickAddMenu", function () {
            return {
                controller: null,
                init() {
                    this.$watch("isOpen", (e) => {
                        e ? this.listen() : this.unlisten();
                    });
                },
                listen() {
                    (this.controller = new AbortController()),
                        this.$el.addEventListener(
                            "mouseleave",
                            () => {
                                this.close();
                            },
                            { signal: this.controller.signal }
                        ),
                        document.addEventListener(
                            "click",
                            (e) => {
                                this.$el.contains(e.target) || (!1 !== this.$el._x_isShown && this.close());
                            },
                            { signal: this.controller.signal }
                        ),
                        document.addEventListener(
                            "focusin",
                            (e) => {
                                this.$el.contains(e.target) || this.close();
                            },
                            { signal: this.controller.signal }
                        ),
                        document.addEventListener(
                            "keydown",
                            (e) => {
                                "Escape" === e.key && this.close();
                            },
                            { signal: this.controller.signal }
                        );
                },
                unlisten() {
                    this.controller.abort(), (this.controller = null);
                },
            };
        }),
        hg.data("toggle", function () {
            return {
                isOpen: !1,
                get isClosed() {
                    return !this.isOpen;
                },
                toggle() {
                    if (this.isOpen) return this.close();
                    this.open();
                },
                open() {
                    this.isOpen = !0;
                },
                close() {
                    this.isOpen && (this.isOpen = !1);
                },
            };
        }),
        hg.data("tabs", function (e = 0) {
            return {
                selectedIndex: null,
                init() {
                    this.$nextTick(() => this.select(e));
                },
                get tablist() {
                    return this.$el.querySelector(Qg);
                },
                get tabs() {
                    var e;
                    return null === (e = this.tablist) || void 0 === e ? void 0 : e.querySelectorAll(Kg);
                },
                getTab(e) {
                    var t;
                    return null === (t = this.tabs) || void 0 === t ? void 0 : t[e];
                },
                isSelected(e) {
                    return this.selectedIndex === e;
                },
                select(e, t = !0) {
                    this.selectedIndex = e;
                    const i = this.getTab(e);
                    i && t && this.tablist.scrollTo({ top: 0, left: i.offsetLeft - i.clientWidth, behavior: "smooth" });
                },
                bindTabs: { "x-id": "['tab', 'tab-panel']" },
                bindTablist: {
                    ":role": "'tablist'",
                    "@keydown.right.prevent.stop": "$focus.wrap().next()",
                    "@keydown.home.prevent.stop": "$focus.first()",
                    "@keydown.page-up.prevent.stop": "$focus.first()",
                    "@keydown.left.prevent.stop": "$focus.wrap().prev()",
                    "@keydown.end.prevent.stop": "$focus.last()",
                    "@keydown.page-down.prevent.stop": "$focus.last()",
                },
                bindTabpanels: {},
                bindTab: (e) => ({
                    ":id": `$id('tab', ${e + 1})`,
                    ":role": "'tab'",
                    "@click": `select(${e})`,
                    "@mousedown.prevent": "",
                    "@focus": `select(${e})`,
                    ":tabindex": `isSelected(${e}) ? 0 : -1`,
                    ":aria-selected": `isSelected(${e})`,
                    ":aria-controls": `$id('tab-panel', ${e + 1})`,
                }),
                bindTabpanel: (e) => ({ ":id": `$id('tab-panel', ${e + 1})`, ":role": "'tabpanel'", "x-show": `isSelected(${e})`, ":aria-labelledby": `$id('tab', ${e + 1})` }),
            };
        }),
        hg.data("overflow", function (e = {}) {
            const t = { top: 0, right: 0, bottom: 0, left: 0, ...e.inset };
            return {
                get overflowContainer() {
                    return this.$refs.overflowContainer;
                },
                isOverflowing: { top: !1, bottom: !1, left: !1, right: !1 },
                checkOverflow() {
                    const e = this.overflowContainer.scrollHeight - this.overflowContainer.scrollTop - t.bottom,
                        i = this.overflowContainer.scrollWidth - this.overflowContainer.scrollLeft - t.right;
                    (this.isOverflowing.top = this.overflowContainer.scrollTop - t.top > 0),
                        (this.isOverflowing.bottom = e > this.overflowContainer.clientHeight),
                        (this.isOverflowing.left = this.overflowContainer.scrollLeft - t.left > 0),
                        (this.isOverflowing.right = i > this.overflowContainer.clientWidth);
                },
                scrollTo(e) {
                    this.overflowContainer.scrollTo(e);
                },
            };
        }),
        hg.magic("nudge", function (e) {
            return (e, { left: t, top: i, ...s }) => {
                e.scrollTo({ ...(t && { left: Math.max(Math.min(e.scrollLeft + t, e.scrollWidth), 0) }), ...(i && { left: Math.max(Math.min(e.scrollTop + i, e.scrollHeight), 0) }), ...s });
            };
        }),
        hg.directive("hold", (e, { modifiers: t, expression: i }, { cleanup: s, evaluate: r }) => {
            let n = null,
                o = t[0] || "",
                a = Number.isInteger(o.split("ms")[0]) ? Number(o.split("ms")[0]) : 25;
            const l = () => {
                n = setInterval(() => {
                    r(i);
                }, a);
            },
                c = () => {
                    clearInterval(n);
                };
            e.addEventListener("mousedown", l),
                e.addEventListener("mouseup", c),
                e.addEventListener("mouseleave", c),
                e.addEventListener("touchstart", l),
                e.addEventListener("touchend", c),
                s(() => {
                    e.removeEventListener("mousedown", l), e.removeEventListener("mouseup", c), e.removeEventListener("mouseleave", c), e.removeEventListener("touchstart", l), e.removeEventListener("touchend", c);
                });
        }),
        hg.directive("target-referrer", (e, { expression: t }) => {
            t && (-1 !== document.referrer.indexOf(t) || window.Shopify.designMode || e.parentNode.removeChild(e));
        }),
        hg.plugin(Ou),
        hg.start(),
        (window.Alpine = hg);
})(
    themeVendor.AOS,
    themeVendor.FlickityFade,
    themeVendor.ScrollLock,
    themeVendor.Flickity,
    themeVendor.Sqrl,
    themeVendor.MicroModal,
    themeVendor.Rellax,
    themeVendor.themeCurrency,
    themeVendor.axios,
    themeVendor.FlickitySync,
    themeVendor.themeAddresses
);
